export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: string; output: string; }
  DateTime: { input: string; output: string; }
  JSONObject: { input: any; output: any; }
  Time: { input: string; output: string; }
  URL: { input: any; output: any; }
};

export type Accommodation = {
  __typename?: 'Accommodation';
  amenities?: Maybe<Array<Maybe<AccommodationAmenity>>>;
  classification?: Maybe<AccommodationClassification>;
  configuration?: Maybe<Array<Maybe<AccommodationConfiguration>>>;
  description?: Maybe<Scalars['String']['output']>;
  extendedStay?: Maybe<Scalars['Boolean']['output']>;
  floorSpace?: Maybe<AccommodationFloorSpace>;
  id?: Maybe<Scalars['ID']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  medias?: Maybe<AccommodationMedias>;
  shortLabel?: Maybe<Scalars['String']['output']>;
  spacialViewLink?: Maybe<Scalars['String']['output']>;
  surface?: Maybe<AccommodationSurface>;
  topAmenities?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type AccommodationAmenity = {
  __typename?: 'AccommodationAmenity';
  amenities?: Maybe<Array<Maybe<AccommodationAmenityItem>>>;
  facilities?: Maybe<Array<Maybe<AccommodationFacility>>>;
  label?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type AccommodationAmenityItem = {
  __typename?: 'AccommodationAmenityItem';
  value?: Maybe<Scalars['String']['output']>;
};

export type AccommodationBeddings = {
  __typename?: 'AccommodationBeddings';
  details?: Maybe<Array<Maybe<Scalars['JSONObject']['output']>>>;
  doubleBed?: Maybe<Scalars['Int']['output']>;
  extra?: Maybe<AccommodationExtra>;
  qualified: Array<Maybe<AccommodationBeddingsQualified>>;
  singleBed?: Maybe<Scalars['Int']['output']>;
};

export type AccommodationBeddingsQualified = {
  __typename?: 'AccommodationBeddingsQualified';
  label?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type AccommodationClassification = {
  __typename?: 'AccommodationClassification';
  standard?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type AccommodationConfiguration = {
  __typename?: 'AccommodationConfiguration';
  assets?: Maybe<Array<Maybe<Scalars['JSONObject']['output']>>>;
  beddings?: Maybe<AccommodationBeddings>;
  maxOccupancy?: Maybe<AccommodationMaxOccupancy>;
  situation?: Maybe<AccommodationSituation>;
};

/** --- Rooms --- */
export type AccommodationExtra = {
  __typename?: 'AccommodationExtra';
  adultBed?: Maybe<Scalars['Boolean']['output']>;
  childBed?: Maybe<Scalars['Boolean']['output']>;
  crib?: Maybe<Scalars['Boolean']['output']>;
};

export type AccommodationFacility = {
  __typename?: 'AccommodationFacility';
  items?: Maybe<Array<Maybe<AccommodationItem>>>;
  label?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type AccommodationFloorSpace = {
  __typename?: 'AccommodationFloorSpace';
  unit?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Int']['output']>;
};

export type AccommodationItem = {
  __typename?: 'AccommodationItem';
  code?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  paying?: Maybe<Scalars['Boolean']['output']>;
};

export type AccommodationMaxOccupancy = {
  __typename?: 'AccommodationMaxOccupancy';
  adult?: Maybe<Scalars['Int']['output']>;
  children?: Maybe<Scalars['Int']['output']>;
  maxChildAge?: Maybe<Scalars['Int']['output']>;
  pax?: Maybe<Scalars['Int']['output']>;
};

export type AccommodationMedias = {
  __typename?: 'AccommodationMedias';
  photos?: Maybe<Array<Maybe<AiPicture>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type AccommodationSituation = {
  __typename?: 'AccommodationSituation';
  accessibility?: Maybe<Scalars['Boolean']['output']>;
  views?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type AccommodationSurface = {
  __typename?: 'AccommodationSurface';
  squareFeet?: Maybe<Scalars['Int']['output']>;
  squareMeter?: Maybe<Scalars['Int']['output']>;
};

export type AccorAdvantagesEligibility = {
  __typename?: 'AccorAdvantagesEligibility';
  key?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type AccorMedia = {
  __typename?: 'AccorMedia';
  category?: Maybe<AccorMediaCategory>;
  formats?: Maybe<Array<Maybe<AccorMediaFormat>>>;
  productCode?: Maybe<Scalars['String']['output']>;
  type?: Maybe<AccorMediaType>;
};

export enum AccorMediaCategory {
  Access = 'ACCESS',
  Banner = 'BANNER',
  Bar = 'BAR',
  Bedroom = 'BEDROOM',
  Breakfast = 'BREAKFAST',
  BusinessCenter = 'BUSINESS_CENTER',
  Destination = 'DESTINATION',
  ExecutiveFloor = 'EXECUTIVE_FLOOR',
  Family = 'FAMILY',
  Fitness = 'FITNESS',
  Golf = 'GOLF',
  Hotel = 'HOTEL',
  HotelAdvantage = 'HOTEL_ADVANTAGE',
  Institute = 'INSTITUTE',
  Logo = 'LOGO',
  MeetingRoom = 'MEETING_ROOM',
  Option = 'OPTION',
  Pool = 'POOL',
  Restaurant = 'RESTAURANT',
  Service = 'SERVICE',
  Spa = 'SPA',
  Suite = 'SUITE',
  SustainableDevelopment = 'SUSTAINABLE_DEVELOPMENT',
  Thalasso = 'THALASSO',
  Wedding = 'WEDDING',
  Welcome = 'WELCOME'
}

export type AccorMediaFormat = {
  __typename?: 'AccorMediaFormat';
  format?: Maybe<Scalars['String']['output']>;
  generic?: Maybe<Scalars['Boolean']['output']>;
  lastUpdate?: Maybe<Scalars['String']['output']>;
  path: Scalars['String']['output'];
};

/** API Media */
export enum AccorMediaType {
  Image = 'IMAGE',
  Video = 'VIDEO'
}

export type Address = {
  __typename?: 'Address';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  lat?: Maybe<Scalars['String']['output']>;
  lng?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type Aggregate = {
  __typename?: 'Aggregate';
  code?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type AiPicture = {
  __typename?: 'AiPicture';
  alt?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  src?: Maybe<Scalars['String']['output']>;
  srcSet?: Maybe<Scalars['String']['output']>;
};

export type Amenity = {
  __typename?: 'Amenity';
  code?: Maybe<Scalars['String']['output']>;
  filterCategory?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  topCategory?: Maybe<Scalars['String']['output']>;
  topOrder?: Maybe<Scalars['Int']['output']>;
  topService?: Maybe<Scalars['Boolean']['output']>;
};

export type Amount = {
  __typename?: 'Amount';
  afterTax?: Maybe<Scalars['Float']['output']>;
  fees?: Maybe<Fees>;
  hotelKeeper?: Maybe<Scalars['Float']['output']>;
  otherTax?: Maybe<OtherTax>;
  payAtTheHotel?: Maybe<Scalars['Float']['output']>;
  payOnline?: Maybe<Scalars['Float']['output']>;
  vat?: Maybe<Vat>;
};

export type AmountValue = {
  __typename?: 'AmountValue';
  excluded?: Maybe<Scalars['Float']['output']>;
  included?: Maybe<Scalars['Float']['output']>;
};

export type Analytic = {
  __typename?: 'Analytic';
  code?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Array<Maybe<Datum>>>;
  description?: Maybe<Scalars['String']['output']>;
};

export type Analytics = {
  __typename?: 'Analytics';
  analytic?: Maybe<Array<Maybe<Analytic>>>;
};

export type AvailabilityRoom = {
  __typename?: 'AvailabilityRoom';
  capacity?: Maybe<RoomCapacity>;
  code?: Maybe<Scalars['String']['output']>;
  commercialOffers?: Maybe<Array<Maybe<CommercialOffer>>>;
  description?: Maybe<Scalars['String']['output']>;
  family?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  media?: Maybe<Array<Maybe<AccorMedia>>>;
  offers?: Maybe<Array<Maybe<RoomOffers>>>;
  referenceOffers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  roomClass?: Maybe<Scalars['String']['output']>;
  roomSize?: Maybe<RoomSize>;
};

export type AvailableRoom = {
  __typename?: 'AvailableRoom';
  accommodationRoom?: Maybe<Accommodation>;
  availabilityRoom?: Maybe<AvailabilityRoom>;
};

export type AveragePricing = {
  __typename?: 'AveragePricing';
  amount?: Maybe<Amount>;
  currency?: Maybe<Scalars['String']['output']>;
};

export type Award = {
  __typename?: 'Award';
  awardId?: Maybe<Scalars['String']['output']>;
  cancellationDate?: Maybe<Scalars['Date']['output']>;
  cancellationReason?: Maybe<Scalars['String']['output']>;
  creationCause?: Maybe<Scalars['String']['output']>;
  creationDate?: Maybe<Scalars['Date']['output']>;
  expirationDate?: Maybe<Scalars['String']['output']>;
  repaymentDetail?: Maybe<RepaymentDetail>;
  status?: Maybe<Scalars['String']['output']>;
  stayDetail?: Maybe<StayDetail>;
  triggedDate?: Maybe<Scalars['String']['output']>;
  updateDate?: Maybe<Scalars['Date']['output']>;
};

export type AwardType = {
  __typename?: 'AwardType';
  IntOfAwards?: Maybe<Scalars['Int']['output']>;
  IntOfRemainingAwards?: Maybe<Scalars['Int']['output']>;
  awardTypeName?: Maybe<Scalars['String']['output']>;
  awards?: Maybe<Awards>;
  nightsForNextAward?: Maybe<Scalars['Int']['output']>;
  statusPointsForNextAward?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type AwardTypes = {
  __typename?: 'AwardTypes';
  allTypesAwardEligibility?: Maybe<Scalars['String']['output']>;
  awardType?: Maybe<Array<Maybe<AwardType>>>;
};

export type Awards = {
  __typename?: 'Awards';
  award?: Maybe<Array<Maybe<Award>>>;
};

export type Balances = {
  __typename?: 'Balances';
  currentNightsBalance?: Maybe<Scalars['Int']['output']>;
  currentStaysBalance?: Maybe<Scalars['Int']['output']>;
  fastTrackedStatusNights?: Maybe<Scalars['Int']['output']>;
  nbNightsToNextTiering?: Maybe<Scalars['Int']['output']>;
  nbPoints?: Maybe<Scalars['Int']['output']>;
  nbPointsEarnLast12Months?: Maybe<Scalars['Int']['output']>;
  nbPointsToNextTiering?: Maybe<Scalars['Int']['output']>;
  nightsSpentOnTierUpdate?: Maybe<Scalars['Int']['output']>;
  pointsEarnedOnTierUpdate?: Maybe<Scalars['Int']['output']>;
};

export type BasicRoom = {
  adults?: InputMaybe<Scalars['Int']['input']>;
  childrenAges?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type Basket = {
  __typename?: 'Basket';
  hotel?: Maybe<BasketHotel>;
  hotelId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  payment?: Maybe<BasketPayment>;
  paymentWithFees?: Maybe<BasketPaymentWithFees>;
  policies?: Maybe<BasketPolicies>;
  prices?: Maybe<BasketPrice>;
  products?: Maybe<Array<Maybe<BasketProduct>>>;
  rooms?: Maybe<Array<Maybe<BasketRoom>>>;
  vouchers?: Maybe<Array<BasketVoucher>>;
  warrantyPolicies?: Maybe<BasketWarrantyPolicies>;
};

export type BasketAmount = {
  __typename?: 'BasketAmount';
  amount: Scalars['Float']['output'];
  currency: Scalars['String']['output'];
};

export type BasketAuthorize = {
  __typename?: 'BasketAuthorize';
  price?: Maybe<BasketPrice>;
  status?: Maybe<Scalars['String']['output']>;
};

export type BasketAveragePrice = {
  __typename?: 'BasketAveragePrice';
  amount?: Maybe<BasketPriceLight>;
  commission?: Maybe<BasketCommission>;
};

export type BasketBeneficiary = {
  __typename?: 'BasketBeneficiary';
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  address3?: Maybe<Scalars['String']['output']>;
  address4?: Maybe<Scalars['String']['output']>;
  billing?: Maybe<BasketBeneficiaryCompany>;
  city?: Maybe<Scalars['String']['output']>;
  civilityCode: Scalars['String']['output'];
  countryCode: Scalars['String']['output'];
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  firstNameNonLatin?: Maybe<Scalars['String']['output']>;
  lastName: Scalars['String']['output'];
  lastNameNonLatin?: Maybe<Scalars['String']['output']>;
  nationalityCode?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Phone>;
  stateCode?: Maybe<Scalars['String']['output']>;
  territoryCode?: Maybe<Scalars['String']['output']>;
  zipcode?: Maybe<Scalars['String']['output']>;
};

export type BasketBeneficiaryCompany = {
  __typename?: 'BasketBeneficiaryCompany';
  name?: Maybe<Scalars['String']['output']>;
  vatNumber?: Maybe<Scalars['String']['output']>;
};

export type BasketBeneficiaryCompanyPayload = {
  name?: InputMaybe<Scalars['String']['input']>;
  vatNumber?: InputMaybe<Scalars['String']['input']>;
};

export type BasketBeneficiaryPayload = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  address3?: InputMaybe<Scalars['String']['input']>;
  address4?: InputMaybe<Scalars['String']['input']>;
  billing?: InputMaybe<BasketBeneficiaryCompanyPayload>;
  city?: InputMaybe<Scalars['String']['input']>;
  civilityCode: Scalars['String']['input'];
  countryCode: Scalars['String']['input'];
  currency: Scalars['String']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  firstNameNonLatin?: InputMaybe<Scalars['String']['input']>;
  lastName: Scalars['String']['input'];
  lastNameNonLatin?: InputMaybe<Scalars['String']['input']>;
  nationalityCode: Scalars['String']['input'];
  phone: PhonePayload;
  stateCode?: InputMaybe<Scalars['String']['input']>;
  territoryCode?: InputMaybe<Scalars['String']['input']>;
  zipcode?: InputMaybe<Scalars['String']['input']>;
};

export type BasketCommission = {
  __typename?: 'BasketCommission';
  amount?: Maybe<Scalars['Float']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  percent?: Maybe<Scalars['Float']['output']>;
};

export type BasketCreateRoomOptionPayload = {
  code: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
};

export type BasketCreateRoomPeriodPayload = {
  dateIn: Scalars['String']['input'];
  nights: Scalars['Int']['input'];
};

export type BasketFees = {
  __typename?: 'BasketFees';
  amountAfterTax?: Maybe<Scalars['Float']['output']>;
  amountAtTheHotel?: Maybe<Scalars['Float']['output']>;
  amountOnline?: Maybe<Scalars['Float']['output']>;
  percent?: Maybe<Scalars['Float']['output']>;
};

export type BasketFeesAmount = {
  __typename?: 'BasketFeesAmount';
  afterTax?: Maybe<Scalars['Float']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  fees?: Maybe<BasketFees>;
  payAtTheHotel?: Maybe<Scalars['Float']['output']>;
  payOnline?: Maybe<Scalars['Float']['output']>;
  rank?: Maybe<Scalars['Int']['output']>;
  voucher?: Maybe<Scalars['Int']['output']>;
};

export type BasketFeesPayment = {
  __typename?: 'BasketFeesPayment';
  amounts?: Maybe<Array<Maybe<BasketFeesAmount>>>;
  code?: Maybe<Scalars['String']['output']>;
};

export type BasketHotel = {
  __typename?: 'BasketHotel';
  billingAddressMandatory?: Maybe<Scalars['Boolean']['output']>;
  brand?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nonLatinInputAccepted?: Maybe<Scalars['Boolean']['output']>;
  welcomeProgram?: Maybe<Scalars['String']['output']>;
};

export type BasketMetaInfo = {
  __typename?: 'BasketMetaInfo';
  key?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type BasketOptionPricing = {
  __typename?: 'BasketOptionPricing';
  amount?: Maybe<BasketPriceDetails>;
  commission?: Maybe<BasketCommission>;
  currency?: Maybe<Scalars['String']['output']>;
};

export type BasketPayment = {
  __typename?: 'BasketPayment';
  authorize?: Maybe<BasketAuthorize>;
  families?: Maybe<Array<Maybe<BasketPaymentFamily>>>;
  type?: Maybe<Scalars['String']['output']>;
};

export type BasketPaymentFamily = {
  __typename?: 'BasketPaymentFamily';
  familyCode?: Maybe<Scalars['String']['output']>;
  methods?: Maybe<Array<Maybe<BasketPaymentFamilyMethod>>>;
  payment?: Maybe<BasketFeesPayment>;
  rank?: Maybe<Scalars['Int']['output']>;
};

export type BasketPaymentFamilyMethod = {
  __typename?: 'BasketPaymentFamilyMethod';
  code?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  paymentChannel?: Maybe<Scalars['String']['output']>;
  rank?: Maybe<Scalars['Int']['output']>;
};

export type BasketPaymentWithFees = {
  __typename?: 'BasketPaymentWithFees';
  families?: Maybe<Array<Maybe<BasketPaymentFamily>>>;
  type?: Maybe<Scalars['String']['output']>;
};

export type BasketPenalty = {
  __typename?: 'BasketPenalty';
  amount?: Maybe<BasketAmount>;
  night?: Maybe<Scalars['Float']['output']>;
  percent?: Maybe<Scalars['Float']['output']>;
};

export type BasketPeriod = {
  __typename?: 'BasketPeriod';
  dateIn?: Maybe<Scalars['String']['output']>;
  nights?: Maybe<Scalars['Int']['output']>;
};

export type BasketPolicies = {
  __typename?: 'BasketPolicies';
  extras?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  isBillingAddressMandatory: Scalars['Boolean']['output'];
  warranty?: Maybe<Scalars['String']['output']>;
};

export type BasketPrice = {
  __typename?: 'BasketPrice';
  average?: Maybe<BasketAveragePrice>;
  commission?: Maybe<BasketCommission>;
  currency?: Maybe<Scalars['String']['output']>;
  details?: Maybe<BasketPriceDetails>;
  withProducts?: Maybe<BasketProductPriceDetails>;
};

export type BasketPriceDetails = {
  __typename?: 'BasketPriceDetails';
  afterTax?: Maybe<Scalars['Float']['output']>;
  fees?: Maybe<BasketTaxe>;
  hotelKeeper?: Maybe<Scalars['Float']['output']>;
  otherTax?: Maybe<BasketTaxe>;
  payAtTheHotel?: Maybe<Scalars['Float']['output']>;
  payOnline?: Maybe<Scalars['Float']['output']>;
  vat?: Maybe<BasketTaxe>;
};

export type BasketPriceLight = {
  __typename?: 'BasketPriceLight';
  afterTax?: Maybe<Scalars['Float']['output']>;
  hotelKeeper?: Maybe<Scalars['Float']['output']>;
};

export type BasketProduct = {
  __typename?: 'BasketProduct';
  adults?: Maybe<Scalars['Int']['output']>;
  beneficiaries?: Maybe<Array<Maybe<BasketBeneficiary>>>;
  childrenAges?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  datasheetUrl?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  partnerCode?: Maybe<Scalars['String']['output']>;
  paymentDate?: Maybe<Scalars['String']['output']>;
  period?: Maybe<BasketProductPeriod>;
  price?: Maybe<BasketProductPriceDetails>;
  productCode?: Maybe<Scalars['String']['output']>;
  purchasedOfferId?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  quotation?: Maybe<BasketProductQuotation>;
  salesPoliciesUrls?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  status?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type BasketProductPeriod = {
  __typename?: 'BasketProductPeriod';
  from?: Maybe<Scalars['String']['output']>;
  to?: Maybe<Scalars['String']['output']>;
};

export type BasketProductPriceDetails = {
  __typename?: 'BasketProductPriceDetails';
  afterTax?: Maybe<Scalars['Float']['output']>;
  beforeTax?: Maybe<Scalars['Float']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  payAtTheHotel?: Maybe<Scalars['Float']['output']>;
  payOnline?: Maybe<Scalars['Float']['output']>;
  totalTax?: Maybe<Scalars['Float']['output']>;
};

export type BasketProductQuotation = {
  __typename?: 'BasketProductQuotation';
  id?: Maybe<Scalars['ID']['output']>;
  offerId?: Maybe<Scalars['String']['output']>;
};

export type BasketRoom = {
  __typename?: 'BasketRoom';
  adults?: Maybe<Scalars['Int']['output']>;
  beneficiary?: Maybe<BasketBeneficiary>;
  childrenAges?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  id?: Maybe<Scalars['ID']['output']>;
  offer?: Maybe<BasketRoomOffer>;
  options: Array<Maybe<BasketRoomOption>>;
  period?: Maybe<BasketPeriod>;
  prepay?: Maybe<Scalars['Boolean']['output']>;
  productCode?: Maybe<Scalars['ID']['output']>;
  productLabel?: Maybe<Scalars['String']['output']>;
};

export type BasketRoomOffer = {
  __typename?: 'BasketRoomOffer';
  averagePricing?: Maybe<BasketOptionPricing>;
  categories?: Maybe<Array<Maybe<BasketRoomOfferCategory>>>;
  checkIn?: Maybe<BasketRoomOfferCheckIn>;
  code?: Maybe<Scalars['ID']['output']>;
  concession?: Maybe<BasketRoomOfferConcession>;
  deduction?: Maybe<BasketRoomOfferDeduction>;
  flexibility?: Maybe<BasketRoomOfferFlexibility>;
  label?: Maybe<Scalars['String']['output']>;
  mealPlan?: Maybe<BasketRoomOfferMealPlan>;
  policies: Array<Maybe<BasketRoomOptionPolicy>>;
  pricing?: Maybe<BasketOptionPricing>;
  referenceOffers?: Maybe<Array<Maybe<BasketRoomReferenceOffer>>>;
};

export type BasketRoomOfferCategory = {
  __typename?: 'BasketRoomOfferCategory';
  code?: Maybe<BasketRoomOfferCategoryCode>;
  subCategories?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export enum BasketRoomOfferCategoryCode {
  Agency = 'AGENCY',
  Cobrand = 'COBRAND',
  Corporate = 'CORPORATE',
  DayUse = 'DAY_USE',
  Family = 'FAMILY',
  LongStay = 'LONG_STAY',
  Loyalty = 'LOYALTY',
  OnlyOn = 'ONLY_ON',
  Preferred = 'PREFERRED',
  PremiumAvailability = 'PREMIUM_AVAILABILITY',
  Promotion = 'PROMOTION',
  Standard = 'STANDARD',
  StayPlus = 'STAY_PLUS'
}

export type BasketRoomOfferCheckIn = {
  __typename?: 'BasketRoomOfferCheckIn';
  availability?: Maybe<BasketRoomOfferCheckInAvailability>;
  available?: Maybe<Scalars['Boolean']['output']>;
  checkInSmsAvailable?: Maybe<Scalars['Boolean']['output']>;
  paymentDate?: Maybe<Scalars['String']['output']>;
  price?: Maybe<BasketAmount>;
};

export enum BasketRoomOfferCheckInAvailability {
  None = 'NONE',
  Offline = 'OFFLINE',
  Online = 'ONLINE'
}

export type BasketRoomOfferConcession = {
  __typename?: 'BasketRoomOfferConcession';
  unit?: Maybe<BasketRoomOfferConcessionUnit>;
  value?: Maybe<Scalars['Int']['output']>;
};

export enum BasketRoomOfferConcessionUnit {
  Freenight = 'FREENIGHT',
  Snu = 'SNU'
}

export type BasketRoomOfferDeduction = {
  __typename?: 'BasketRoomOfferDeduction';
  reference?: Maybe<BasketRoomOfferDeductionReference>;
  value?: Maybe<Scalars['Int']['output']>;
};

export type BasketRoomOfferDeductionReference = {
  __typename?: 'BasketRoomOfferDeductionReference';
  deduction?: Maybe<Scalars['String']['output']>;
  index?: Maybe<Scalars['Int']['output']>;
};

export type BasketRoomOfferFlexibility = {
  __typename?: 'BasketRoomOfferFlexibility';
  code?: Maybe<BasketRoomOfferFlexibilityCode>;
  label?: Maybe<Scalars['String']['output']>;
  limitDate?: Maybe<Scalars['String']['output']>;
  penalty?: Maybe<BasketPenalty>;
};

export enum BasketRoomOfferFlexibilityCode {
  FreeCancellation = 'FREE_CANCELLATION',
  NoCancellation = 'NO_CANCELLATION',
  RestrictedCancellation = 'RESTRICTED_CANCELLATION',
  Undefined = 'UNDEFINED'
}

export type BasketRoomOfferMealPlan = {
  __typename?: 'BasketRoomOfferMealPlan';
  description?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  type?: Maybe<BasketRoomOfferMealPlanType>;
};

export enum BasketRoomOfferMealPlanType {
  All = 'ALL',
  Bb = 'BB',
  Ep = 'EP',
  Fb = 'FB',
  Hb = 'HB',
  Variying = 'VARIYING'
}

export type BasketRoomOption = {
  __typename?: 'BasketRoomOption';
  code?: Maybe<Scalars['ID']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  details?: Maybe<Array<Maybe<BasketRoomOptionDetails>>>;
  label?: Maybe<Scalars['String']['output']>;
  maxQuantity?: Maybe<Scalars['Int']['output']>;
  medias: Array<Maybe<BasketRoomOptionMedia>>;
  perDay?: Maybe<Scalars['Boolean']['output']>;
  policies: Array<Maybe<BasketRoomOptionPolicy>>;
  prices?: Maybe<BasketRoomOptionPrices>;
  pricing?: Maybe<BasketOptionPricing>;
  pricingUnit?: Maybe<BasketRoomOptionPricingUnit>;
  quantity?: Maybe<Scalars['Int']['output']>;
  remaining?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<BasketRoomOptionType>;
  unitaryPricing?: Maybe<BasketRoomUnitaryPrice>;
  warranted?: Maybe<Scalars['Boolean']['output']>;
  webExclusive?: Maybe<Scalars['Boolean']['output']>;
};

export type BasketRoomOptionDetails = {
  __typename?: 'BasketRoomOptionDetails';
  period?: Maybe<BasketPeriod>;
  pricing?: Maybe<BasketOptionPricing>;
  status?: Maybe<BasketRoomOptionStatus>;
};

export type BasketRoomOptionMedia = {
  __typename?: 'BasketRoomOptionMedia';
  category?: Maybe<BasketRoomOptionMediaCategory>;
  defaultMedium?: Maybe<Scalars['Boolean']['output']>;
  sources?: Maybe<Array<Maybe<BasketRoomOptionMediaSource>>>;
  type?: Maybe<BasketRoomOptionMediaType>;
};

export enum BasketRoomOptionMediaCategory {
  Bar = 'BAR',
  Bedroom = 'BEDROOM',
  BusinessCenter = 'BUSINESS_CENTER',
  Destination = 'DESTINATION',
  Family = 'FAMILY',
  Golf = 'GOLF',
  Hotel = 'HOTEL',
  HotelAdvantage = 'HOTEL_ADVANTAGE',
  Institute = 'INSTITUTE',
  MeetingRoom = 'MEETING_ROOM',
  Option = 'OPTION',
  Restaurant = 'RESTAURANT',
  Service = 'SERVICE',
  Spa = 'SPA',
  Suite = 'SUITE',
  Thalasso = 'THALASSO',
  Wedding = 'WEDDING'
}

export type BasketRoomOptionMediaSource = {
  __typename?: 'BasketRoomOptionMediaSource';
  format?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export enum BasketRoomOptionMediaType {
  Img = 'IMG',
  Video = 'VIDEO'
}

export type BasketRoomOptionPolicy = {
  __typename?: 'BasketRoomOptionPolicy';
  code?: Maybe<Scalars['ID']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  metas?: Maybe<Array<Maybe<BasketMetaInfo>>>;
  numberDayLimit?: Maybe<Scalars['Int']['output']>;
};

export type BasketRoomOptionPrices = {
  __typename?: 'BasketRoomOptionPrices';
  currency?: Maybe<Scalars['String']['output']>;
  extraTax?: Maybe<Scalars['String']['output']>;
  finalPrice?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['String']['output']>;
};

export type BasketRoomOptionPricingUnit = {
  __typename?: 'BasketRoomOptionPricingUnit';
  code?: Maybe<BasketRoomOptionPricingUnitCode>;
  label?: Maybe<Scalars['String']['output']>;
};

export enum BasketRoomOptionPricingUnitCode {
  PerAdultMeal = 'PER_ADULT_MEAL',
  PerAdultPerStay = 'PER_ADULT_PER_STAY',
  PerChildMeal = 'PER_CHILD_MEAL',
  PerChildPerStay = 'PER_CHILD_PER_STAY',
  PerPersonPerDay = 'PER_PERSON_PER_DAY',
  PerPersonPerStay = 'PER_PERSON_PER_STAY',
  PerRoomPerStay = 'PER_ROOM_PER_STAY',
  PerUnit = 'PER_UNIT',
  Unknown = 'UNKNOWN'
}

export enum BasketRoomOptionStatus {
  Free = 'FREE',
  Offered = 'OFFERED',
  Paying = 'PAYING'
}

export enum BasketRoomOptionType {
  BookingPreference = 'BOOKING_PREFERENCE',
  Breakfast = 'BREAKFAST',
  Custom = 'CUSTOM',
  EarlyLate = 'EARLY_LATE',
  MealUpgrade = 'MEAL_UPGRADE',
  Menu = 'MENU',
  RoomPreference = 'ROOM_PREFERENCE'
}

export type BasketRoomPayload = {
  adults: Scalars['Int']['input'];
  basketRoomId?: InputMaybe<Scalars['ID']['input']>;
  beneficiary?: InputMaybe<BasketBeneficiaryPayload>;
  childrenAges?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  offerCode: Scalars['ID']['input'];
  options?: InputMaybe<Array<InputMaybe<BasketCreateRoomOptionPayload>>>;
  period: BasketCreateRoomPeriodPayload;
  productCode: Scalars['ID']['input'];
};

export type BasketRoomReferenceOffer = {
  __typename?: 'BasketRoomReferenceOffer';
  averagePricing?: Maybe<BasketOptionPricing>;
  categories?: Maybe<Array<Maybe<BasketRoomOfferCategoryCode>>>;
  code?: Maybe<Scalars['ID']['output']>;
  pricing?: Maybe<BasketOptionPricing>;
};

export type BasketRoomUnitaryPrice = {
  __typename?: 'BasketRoomUnitaryPrice';
  afterTax?: Maybe<Scalars['Float']['output']>;
  beforeTax?: Maybe<Scalars['Float']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  hotelKeeper?: Maybe<Scalars['Float']['output']>;
};

export type BasketTaxe = {
  __typename?: 'BasketTaxe';
  details?: Maybe<Array<Maybe<BasketTaxeDetails>>>;
  excluded?: Maybe<Scalars['Float']['output']>;
  included?: Maybe<Scalars['Float']['output']>;
};

export type BasketTaxeDetails = {
  __typename?: 'BasketTaxeDetails';
  code?: Maybe<Scalars['ID']['output']>;
  included?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  onlinePayable?: Maybe<Scalars['Boolean']['output']>;
  refundable?: Maybe<Scalars['Boolean']['output']>;
};

export type BasketVoucher = {
  __typename?: 'BasketVoucher';
  detail: Array<BasketVoucherDetail>;
  points: Scalars['Int']['output'];
  price: BasketAmount;
};

export type BasketVoucherDetail = {
  __typename?: 'BasketVoucherDetail';
  points: Scalars['Int']['output'];
  price: BasketAmount;
  roomId: Scalars['ID']['output'];
};

export type BasketWarrantyPolicies = {
  __typename?: 'BasketWarrantyPolicies';
  checkInLimitHour?: Maybe<Scalars['String']['output']>;
};

export type BestOffer = {
  __typename?: 'BestOffer';
  currency?: Maybe<Scalars['String']['output']>;
  empty: Scalars['Boolean']['output'];
  price?: Maybe<BestOfferPrice>;
};

export type BestOfferPrice = {
  __typename?: 'BestOfferPrice';
  afterTax?: Maybe<Scalars['Float']['output']>;
  hotelKeeper?: Maybe<Scalars['Float']['output']>;
};

export type Booking = {
  __typename?: 'Booking';
  benefits?: Maybe<BookingHotelBenefits>;
  hotel?: Maybe<BookingHotel>;
  id?: Maybe<Scalars['String']['output']>;
  item?: Maybe<Array<Maybe<BookingHotelItem>>>;
  number?: Maybe<Scalars['String']['output']>;
  pricing?: Maybe<BookingHotelPricing>;
};

export type BookingHotel = {
  __typename?: 'BookingHotel';
  brandCode?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type BookingHotelBenefits = {
  __typename?: 'BookingHotelBenefits';
  voucher?: Maybe<BookingHotelBenefitsVoucher>;
};

export type BookingHotelBenefitsVoucher = {
  __typename?: 'BookingHotelBenefitsVoucher';
  points?: Maybe<Scalars['Int']['output']>;
  price?: Maybe<BookingHotelBenefitsVoucherPrice>;
};

export type BookingHotelBenefitsVoucherPrice = {
  __typename?: 'BookingHotelBenefitsVoucherPrice';
  amount?: Maybe<Scalars['Float']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
};

export type BookingHotelItem = {
  __typename?: 'BookingHotelItem';
  cancellation?: Maybe<BookingHotelItemCancellation>;
  detail?: Maybe<BookingHotelItemDetail>;
  id?: Maybe<Scalars['String']['output']>;
  option?: Maybe<Array<Maybe<BookingHotelItemOption>>>;
  participant?: Maybe<BookingHotelItemParticipant>;
  payment?: Maybe<BookingHotelItemPayment>;
  pricing?: Maybe<BookingHotelItemPricing>;
  room?: Maybe<BookingHotelItemRoom>;
  status?: Maybe<Scalars['String']['output']>;
};

export type BookingHotelItemCancellation = {
  __typename?: 'BookingHotelItemCancellation';
  date?: Maybe<Scalars['String']['output']>;
  motive?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  policy?: Maybe<BookingHotelItemCancellationPolicy>;
};

export type BookingHotelItemCancellationPolicy = {
  __typename?: 'BookingHotelItemCancellationPolicy';
  code?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
};

export type BookingHotelItemDetail = {
  __typename?: 'BookingHotelItemDetail';
  adults?: Maybe<Scalars['Int']['output']>;
  children?: Maybe<Scalars['Int']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  guest?: Maybe<Array<Maybe<BookingHotleItemDetailGuest>>>;
  nights?: Maybe<Scalars['Int']['output']>;
};

export type BookingHotelItemOption = {
  __typename?: 'BookingHotelItemOption';
  code?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  pricing?: Maybe<BookingHotelItemOptionPricing>;
  quantity?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  webExclusive?: Maybe<Scalars['Boolean']['output']>;
};

export type BookingHotelItemOptionPricing = {
  __typename?: 'BookingHotelItemOptionPricing';
  amount?: Maybe<CommonPricingAmount>;
  currency?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type BookingHotelItemParticipant = {
  __typename?: 'BookingHotelItemParticipant';
  reservee?: Maybe<ParticipantReservee>;
};

export type BookingHotelItemPayment = {
  __typename?: 'BookingHotelItemPayment';
  deadline?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  paymentResponseType?: Maybe<BookingHotelItemPaymentResponseType>;
  status?: Maybe<Scalars['String']['output']>;
};

export type BookingHotelItemPaymentResponseType = {
  __typename?: 'BookingHotelItemPaymentResponseType';
  cardType?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  transactionId?: Maybe<Scalars['String']['output']>;
};

export type BookingHotelItemPricing = {
  __typename?: 'BookingHotelItemPricing';
  amount?: Maybe<CommonPricingAmount>;
  currency?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type BookingHotelItemRoom = {
  __typename?: 'BookingHotelItemRoom';
  code?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  offer?: Maybe<BookingHotelItemRoomOffer>;
  policies?: Maybe<Array<Maybe<BookingHotelItemRoomPolicies>>>;
};

export type BookingHotelItemRoomOffer = {
  __typename?: 'BookingHotelItemRoomOffer';
  code?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  pricing?: Maybe<BookingHotemItemRoomOfferPricing>;
};

export type BookingHotelItemRoomPolicies = {
  __typename?: 'BookingHotelItemRoomPolicies';
  description?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
};

export type BookingHotelPricing = {
  __typename?: 'BookingHotelPricing';
  amount?: Maybe<CommonPricingAmount>;
  currency?: Maybe<Scalars['String']['output']>;
};

export type BookingHotemItemRoomOfferPricing = {
  __typename?: 'BookingHotemItemRoomOfferPricing';
  amount?: Maybe<CommonPricingAmount>;
  currency?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type BookingHotleItemDetailGuest = {
  __typename?: 'BookingHotleItemDetailGuest';
  age?: Maybe<Scalars['Int']['output']>;
  civility?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type BookingSeoMetadata = {
  __typename?: 'BookingSeoMetadata';
  confirmation?: Maybe<SeoMetadata>;
  details?: Maybe<SeoMetadata>;
  payment?: Maybe<SeoMetadata>;
  rate?: Maybe<SeoMetadata>;
  room?: Maybe<SeoMetadata>;
};

export type Brand = {
  __typename?: 'Brand';
  code?: Maybe<Scalars['String']['output']>;
};

export type BrandSegment = {
  __typename?: 'BrandSegment';
  brands?: Maybe<Array<Maybe<Brand>>>;
  code?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
};

export enum CacheControlScope {
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

export type Card = {
  __typename?: 'Card';
  beginDate?: Maybe<Scalars['String']['output']>;
  cardInt?: Maybe<Scalars['String']['output']>;
  cardLinks?: Maybe<CardLinks>;
  cardNumber?: Maybe<Scalars['String']['output']>;
  cardProduct?: Maybe<CardProduct>;
  companyStampedName?: Maybe<Scalars['String']['output']>;
  duplicationStatus?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  isLastActiveCard?: Maybe<Scalars['Boolean']['output']>;
  isPrintable?: Maybe<Scalars['Boolean']['output']>;
  stampedName?: Maybe<Scalars['String']['output']>;
  statusGift?: Maybe<StatusGift>;
  temporary?: Maybe<Scalars['Boolean']['output']>;
  termsAndConditionsAcceptanceDate?: Maybe<Scalars['String']['output']>;
};

export type Card3 = {
  __typename?: 'Card3';
  beginDate?: Maybe<Scalars['String']['output']>;
  cardInt?: Maybe<Scalars['String']['output']>;
  cardProduct?: Maybe<CardProduct>;
  isLastActiveCard?: Maybe<Scalars['Boolean']['output']>;
  isPrintable?: Maybe<Scalars['Boolean']['output']>;
  temporary?: Maybe<Scalars['Boolean']['output']>;
  termsAndConditionsAcceptanceDate?: Maybe<Scalars['String']['output']>;
};

export type CardLinks = {
  __typename?: 'CardLinks';
  link?: Maybe<Array<Maybe<Link>>>;
};

export type CardProduct = {
  __typename?: 'CardProduct';
  active?: Maybe<Scalars['Boolean']['output']>;
  cardCodeTARS?: Maybe<Scalars['String']['output']>;
  productBin?: Maybe<Scalars['String']['output']>;
  productCode?: Maybe<Scalars['String']['output']>;
  productLabel?: Maybe<Scalars['String']['output']>;
  productTier?: Maybe<Scalars['String']['output']>;
  productType?: Maybe<Scalars['String']['output']>;
};

export type Categories = {
  __typename?: 'Categories';
  code?: Maybe<Scalars['String']['output']>;
  subCategories?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type Child = {
  __typename?: 'Child';
  birthdate?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  tracking?: Maybe<Tracking>;
};

export type Children = {
  __typename?: 'Children';
  child?: Maybe<Array<Maybe<Child>>>;
};

export type Civility = {
  __typename?: 'Civility';
  code?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type CoBrandedCard = {
  __typename?: 'CoBrandedCard';
  cardInt?: Maybe<Scalars['String']['output']>;
  cardType?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  partnerCode?: Maybe<Scalars['String']['output']>;
  partnerName?: Maybe<Scalars['String']['output']>;
  programmeName?: Maybe<Scalars['String']['output']>;
  subscriptionDate?: Maybe<Scalars['String']['output']>;
};

export type CoBrandedCards = {
  __typename?: 'CoBrandedCards';
  coBrandedCard?: Maybe<Scalars['JSONObject']['output']>;
};

export type CobrandedRateCards = {
  __typename?: 'CobrandedRateCards';
  card?: Maybe<Array<Maybe<Card>>>;
};

export type CommercialOffer = {
  __typename?: 'CommercialOffer';
  alternative?: Maybe<Offer>;
  main?: Maybe<Offer>;
};

export type CommonPricingAmount = {
  __typename?: 'CommonPricingAmount';
  afterTax?: Maybe<Scalars['Float']['output']>;
  fees?: Maybe<CommonTaxPricing>;
  hotelKeeper?: Maybe<Scalars['Float']['output']>;
  otherTax?: Maybe<CommonTaxPricing>;
  payAtTheHotel?: Maybe<Scalars['Float']['output']>;
  payOnline?: Maybe<Scalars['Float']['output']>;
  vat?: Maybe<CommonTaxPricing>;
};

export type CommonTaxPricing = {
  __typename?: 'CommonTaxPricing';
  amount?: Maybe<CommonTaxPricingAmount>;
  detail?: Maybe<CommonTaxPricingDetail>;
};

export type CommonTaxPricingAmount = {
  __typename?: 'CommonTaxPricingAmount';
  excluded?: Maybe<Scalars['Float']['output']>;
  included?: Maybe<Scalars['Float']['output']>;
};

export type CommonTaxPricingDetail = {
  __typename?: 'CommonTaxPricingDetail';
  code?: Maybe<Scalars['String']['output']>;
  included?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  onlinePayable?: Maybe<Scalars['Boolean']['output']>;
  refundable?: Maybe<Scalars['Boolean']['output']>;
  value?: Maybe<CommonTaxPricingDetailValue>;
};

export type CommonTaxPricingDetailValue = {
  __typename?: 'CommonTaxPricingDetailValue';
  amount?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  percent?: Maybe<Scalars['Float']['output']>;
};

export type Communication = {
  __typename?: 'Communication';
  channel?: Maybe<Scalars['String']['output']>;
  device?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type Contact = {
  __typename?: 'Contact';
  mail?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  phonePrefix?: Maybe<Scalars['String']['output']>;
};

export type ContactMedium = {
  __typename?: 'ContactMedium';
  contextType?: Maybe<Scalars['String']['output']>;
  emailContact?: Maybe<ContactMediumEmail>;
  id: Scalars['ID']['output'];
  isNpai?: Maybe<Scalars['Boolean']['output']>;
  isOptOut?: Maybe<Scalars['Boolean']['output']>;
  mediumUsages?: Maybe<ContactMediumUsages>;
  optOutDate?: Maybe<Scalars['String']['output']>;
  postalAddress?: Maybe<ContactMediumPostalAddress>;
  telephoneNumber?: Maybe<ContactMediumPhoneNumber>;
  tracking?: Maybe<ContactMediumTracking>;
};

export type ContactMediumEmail = {
  __typename?: 'ContactMediumEmail';
  email?: Maybe<Scalars['String']['output']>;
  emailRequested?: Maybe<ContactMediumEmailRequested>;
  isPrimary?: Maybe<Scalars['Boolean']['output']>;
};

export type ContactMediumEmailRequested = {
  __typename?: 'ContactMediumEmailRequested';
  email?: Maybe<Scalars['String']['output']>;
  requesteddate?: Maybe<Scalars['String']['output']>;
  tracking?: Maybe<ContactMediumTracking>;
};

export type ContactMediumPhoneNumber = {
  __typename?: 'ContactMediumPhoneNumber';
  isPrimary?: Maybe<Scalars['Boolean']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  phonePrefix?: Maybe<Scalars['String']['output']>;
  phoneType?: Maybe<Scalars['String']['output']>;
};

export type ContactMediumPostalAddress = {
  __typename?: 'ContactMediumPostalAddress';
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  address3?: Maybe<Scalars['String']['output']>;
  address4?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  intraCommunityVat?: Maybe<Scalars['String']['output']>;
  isAsBilling?: Maybe<Scalars['Boolean']['output']>;
  isPrimary?: Maybe<Scalars['Boolean']['output']>;
  stateCode?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type ContactMediumTracking = {
  __typename?: 'ContactMediumTracking';
  createdByHotel?: Maybe<Scalars['String']['output']>;
  createdByOperator?: Maybe<Scalars['String']['output']>;
  createdBySystem?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['String']['output']>;
  updatedByHotel?: Maybe<Scalars['String']['output']>;
  updatedByOperator?: Maybe<Scalars['String']['output']>;
  updatedBySystem?: Maybe<Scalars['String']['output']>;
  updatedDate?: Maybe<Scalars['String']['output']>;
};

export type ContactMediumUsage = {
  __typename?: 'ContactMediumUsage';
  isOptOut?: Maybe<Scalars['Boolean']['output']>;
  optOutDate?: Maybe<Scalars['String']['output']>;
  usageType?: Maybe<Scalars['String']['output']>;
};

export type ContactMediumUsages = {
  __typename?: 'ContactMediumUsages';
  mediumUsage?: Maybe<Array<ContactMediumUsage>>;
};

export type ContactMediums = {
  __typename?: 'ContactMediums';
  contactMedium?: Maybe<Array<ContactMedium>>;
};

export type ContactUs = {
  __typename?: 'ContactUs';
  email?: Maybe<Scalars['String']['output']>;
};

/** Only for Contentful extension, don't map all field */
export type ContentfulHotel = {
  __typename?: 'ContentfulHotel';
  address?: Maybe<Address>;
  brand?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Rating>;
};

export type Cookie = {
  __typename?: 'Cookie';
  DateAcceptation?: Maybe<Scalars['String']['output']>;
  TypeCookie?: Maybe<Scalars['String']['output']>;
  Version?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  tracking?: Maybe<Tracking>;
};

export type Cookies = {
  __typename?: 'Cookies';
  cookie?: Maybe<Array<Maybe<Cookie>>>;
};

export type CorporateCodes = {
  __typename?: 'CorporateCodes';
  corporateCodes?: Maybe<Array<Scalars['String']['output']>>;
};

export type Country = {
  __typename?: 'Country';
  alpha2Code?: Maybe<Scalars['String']['output']>;
  callingCodes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  countInHotels?: Maybe<Scalars['Int']['output']>;
  destinationPicture?: Maybe<AiPicture>;
  geoCode?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  idCardRequired?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nationality?: Maybe<Nationality>;
  states?: Maybe<Array<Maybe<State>>>;
  title?: Maybe<Scalars['String']['output']>;
};

export type CriteriaBonus = {
  __typename?: 'CriteriaBonus';
  bookingBeginDate?: Maybe<Scalars['String']['output']>;
  bookingEndDate?: Maybe<Scalars['String']['output']>;
  minTurnOverStay?: Maybe<Scalars['String']['output']>;
  stayBeginDate?: Maybe<Scalars['String']['output']>;
  stayEndDate?: Maybe<Scalars['String']['output']>;
  stayMinNights?: Maybe<Scalars['Int']['output']>;
};

export type Currency = {
  __typename?: 'Currency';
  code: Scalars['String']['output'];
  euroRate: Scalars['Float']['output'];
  symbol?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

export type CustomerInformation = {
  __typename?: 'CustomerInformation';
  analytics?: Maybe<Analytics>;
  contactMediums?: Maybe<ContactMediums>;
  cookies?: Maybe<Cookies>;
  creationDate?: Maybe<Scalars['Date']['output']>;
  creationSourceSystem?: Maybe<Scalars['String']['output']>;
  experiencesTracking?: Maybe<ExperiencesTracking>;
  externalSystems?: Maybe<ExternalSystems>;
  id?: Maybe<Scalars['String']['output']>;
  individual?: Maybe<Individual>;
  internalId?: Maybe<Scalars['String']['output']>;
  leads?: Maybe<Leads>;
  loyalty?: Maybe<Loyalty>;
  partyType?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  surveys?: Maybe<Surveys>;
  wallets?: Maybe<Wallets>;
};

export type DateSearchInput = {
  dateIn: Scalars['String']['input'];
  dateOut: Scalars['String']['input'];
  nights: Scalars['Int']['input'];
};

export type Datum = {
  __typename?: 'Datum';
  key?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type Deduction = {
  __typename?: 'Deduction';
  reference?: Maybe<Offer>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type DestinationSearchInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  hotel?: InputMaybe<Scalars['String']['input']>;
  ridcode?: InputMaybe<Scalars['String']['input']>;
};

export type EffectiveOccupancy = {
  __typename?: 'EffectiveOccupancy';
  adults?: Maybe<Scalars['Int']['output']>;
  childrenAge?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  childrenAgeAsAdult?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type EligibilityResponse = {
  __typename?: 'EligibilityResponse';
  codeSent?: Maybe<Scalars['Boolean']['output']>;
  contactType?: Maybe<Scalars['String']['output']>;
};

export type EnhancementOptionDetail = {
  __typename?: 'EnhancementOptionDetail';
  period?: Maybe<SelectedPeriod>;
  pricing?: Maybe<Pricing>;
  status?: Maybe<Scalars['String']['output']>;
};

export type EnhancementOptionPolicy = {
  __typename?: 'EnhancementOptionPolicy';
  code?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  numberDayLimit?: Maybe<Scalars['Int']['output']>;
};

export type EnhancementOptionPricing = {
  __typename?: 'EnhancementOptionPricing';
  amount: EnhancementOptionPricingAmount;
  commission?: Maybe<Scalars['String']['output']>;
  currency: Scalars['String']['output'];
};

export type EnhancementOptionPricingAmount = {
  __typename?: 'EnhancementOptionPricingAmount';
  afterTax?: Maybe<Scalars['Float']['output']>;
  fees?: Maybe<Fees>;
  hotelKeeper: Scalars['Float']['output'];
  otherTax?: Maybe<OtherTax>;
  payAtTheHotel?: Maybe<Scalars['Float']['output']>;
  payOnline?: Maybe<Scalars['Float']['output']>;
  vat?: Maybe<Vat>;
};

export type EnhancementOptionPricingUnit = {
  __typename?: 'EnhancementOptionPricingUnit';
  code?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
};

export type ExpediaConfiguration = {
  __typename?: 'ExpediaConfiguration';
  countries: Array<Scalars['String']['output']>;
  expediaHotelIds: Array<Scalars['String']['output']>;
  languages: Array<Scalars['String']['output']>;
};

export type ExperienceCategory = {
  __typename?: 'ExperienceCategory';
  carouselImage?: Maybe<AiPicture>;
  countInHotels?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  logo?: Maybe<AiPicture>;
  order: Scalars['Int']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type ExperienceTracking = {
  __typename?: 'ExperienceTracking';
  experienceTrackingContent?: Maybe<Array<Maybe<ExperienceTrackingContent>>>;
  hotelCode?: Maybe<Scalars['String']['output']>;
};

export type ExperienceTrackingContent = {
  __typename?: 'ExperienceTrackingContent';
  categoryCode?: Maybe<Scalars['String']['output']>;
  checkOutDate?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  compensationCode?: Maybe<Scalars['String']['output']>;
  courtesyPoints?: Maybe<Scalars['Int']['output']>;
  creationDate?: Maybe<Scalars['Date']['output']>;
  eventDate?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  languageCode?: Maybe<Scalars['String']['output']>;
  login?: Maybe<Scalars['String']['output']>;
  moderation?: Maybe<Moderation>;
  reasonCode?: Maybe<Scalars['String']['output']>;
  satisfactionCode?: Maybe<Scalars['String']['output']>;
  updateDate?: Maybe<Scalars['Date']['output']>;
  visibility?: Maybe<Scalars['String']['output']>;
};

export type ExperiencesTracking = {
  __typename?: 'ExperiencesTracking';
  experienceTracking?: Maybe<Array<Maybe<ExperienceTracking>>>;
};

export type ExternalSystem = {
  __typename?: 'ExternalSystem';
  externalId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  systemCode?: Maybe<Scalars['String']['output']>;
  tracking?: Maybe<Tracking>;
  updateDate?: Maybe<Scalars['Date']['output']>;
};

export type ExternalSystems = {
  __typename?: 'ExternalSystems';
  externalSystem?: Maybe<Array<Maybe<ExternalSystem>>>;
};

export type Facility = {
  __typename?: 'Facility';
  cuisineType?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  goldSticker?: Maybe<GoldSticker>;
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  menu?: Maybe<Scalars['String']['output']>;
  menuUrl?: Maybe<Scalars['String']['output']>;
  openingHours?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<AiPicture>;
  title: Scalars['String']['output'];
};

export type FacilitySection = {
  __typename?: 'FacilitySection';
  entries: Array<Maybe<Facility>>;
  id: Scalars['ID']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type FavoriteHotel = {
  __typename?: 'FavoriteHotel';
  hotelCode?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  tracking?: Maybe<Tracking>;
};

export type FavoriteHotels = {
  __typename?: 'FavoriteHotels';
  favoriteHotel?: Maybe<Array<Maybe<FavoriteHotel>>>;
};

export type Favorites = {
  __typename?: 'Favorites';
  hotels?: Maybe<Array<Maybe<FavoriteHotel>>>;
};

export type Fees = {
  __typename?: 'Fees';
  amount?: Maybe<AmountValue>;
  detail?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type Flexibility = {
  __typename?: 'Flexibility';
  Penalty?: Maybe<FlexibilityPenalty>;
  code?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  limitDate?: Maybe<Scalars['String']['output']>;
};

export type FlexibilityPenalty = {
  __typename?: 'FlexibilityPenalty';
  amount?: Maybe<PenaltyAmount>;
  night?: Maybe<Scalars['Float']['output']>;
  percent?: Maybe<Scalars['Float']['output']>;
};

export type FooterColumn = {
  __typename?: 'FooterColumn';
  id: Scalars['ID']['output'];
  links?: Maybe<Array<Link>>;
  title: Scalars['String']['output'];
};

export type FooterConfiguration = {
  __typename?: 'FooterConfiguration';
  copyright: Scalars['String']['output'];
  footerBrandLogos?: Maybe<Array<AiPicture>>;
  footerColumns?: Maybe<Array<FooterColumn>>;
  footerLinks?: Maybe<Array<Link>>;
  socialLinks?: Maybe<Array<Link>>;
};

export type Freenight = {
  __typename?: 'Freenight';
  checkInDate?: Maybe<Scalars['String']['output']>;
  checkOutDate?: Maybe<Scalars['String']['output']>;
  creationDate?: Maybe<Scalars['Date']['output']>;
  expirationDate?: Maybe<Scalars['String']['output']>;
  hotelCode?: Maybe<Scalars['String']['output']>;
  hotelName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  modificationDate?: Maybe<Scalars['Date']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tarsFileInt?: Maybe<Scalars['String']['output']>;
};

export type Freenights = {
  __typename?: 'Freenights';
  freenight?: Maybe<Array<Maybe<Freenight>>>;
};

export type GivenCardProduct = {
  __typename?: 'GivenCardProduct';
  active?: Maybe<Scalars['Boolean']['output']>;
  cardCodeTARS?: Maybe<Scalars['String']['output']>;
  productBin?: Maybe<Scalars['String']['output']>;
  productCode?: Maybe<Scalars['String']['output']>;
  productLabel?: Maybe<Scalars['String']['output']>;
  productTier?: Maybe<Scalars['String']['output']>;
  productType?: Maybe<Scalars['String']['output']>;
};

export type GlobalConfiguration = {
  __typename?: 'GlobalConfiguration';
  contactUs?: Maybe<ContactUs>;
  corporateCodes?: Maybe<CorporateCodes>;
  expedia: ExpediaConfiguration;
  footer?: Maybe<FooterConfiguration>;
};

export type GoldSticker = {
  __typename?: 'GoldSticker';
  label?: Maybe<Scalars['String']['output']>;
};

export type Homepage = {
  __typename?: 'Homepage';
  destinations?: Maybe<Array<Maybe<Country>>>;
  experienceCategories?: Maybe<Array<Maybe<ExperienceCategory>>>;
  experienceCategoriesBigTitle?: Maybe<Scalars['String']['output']>;
  experienceCategoriesSubtitle?: Maybe<Scalars['String']['output']>;
  experienceCategoriesTitle?: Maybe<Scalars['String']['output']>;
  featuredHotels?: Maybe<Array<Maybe<Hotel>>>;
  featuredTestimonials?: Maybe<Array<Maybe<Testimonial>>>;
  heroImage?: Maybe<AiPicture>;
  heroVideo?: Maybe<AiPicture>;
  iconicDestinationSubtitle?: Maybe<Scalars['String']['output']>;
  iconicDestinationTitle?: Maybe<Scalars['String']['output']>;
  introDescription?: Maybe<Scalars['String']['output']>;
  introTitle?: Maybe<Scalars['String']['output']>;
  offerDescription?: Maybe<Scalars['String']['output']>;
  seoMetadata?: Maybe<SeoMetadata>;
  sevenPillars?: Maybe<Array<Maybe<Pillar>>>;
  specialPackageLink?: Maybe<Scalars['String']['output']>;
  specialPackages?: Maybe<Array<Maybe<OfferAndPackage>>>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  title2?: Maybe<Scalars['String']['output']>;
};

export type Hotel = {
  __typename?: 'Hotel';
  address?: Maybe<Address>;
  brand?: Maybe<Scalars['String']['output']>;
  checkInHour?: Maybe<Scalars['String']['output']>;
  checkOutHour?: Maybe<Scalars['String']['output']>;
  contact?: Maybe<Contact>;
  description?: Maybe<Scalars['String']['output']>;
  entertainments?: Maybe<Array<Maybe<HotelEntertainment>>>;
  events?: Maybe<Array<Maybe<HotelEvent>>>;
  expediaId: Scalars['String']['output'];
  experienceCategories?: Maybe<Array<Maybe<ExperienceCategory>>>;
  facilities?: Maybe<Array<HotelAmenity>>;
  galleryImages?: Maybe<Array<Maybe<AiPicture>>>;
  heroImage?: Maybe<AiPicture>;
  heroVideo?: Maybe<AiPicture>;
  hotelExperiences?: Maybe<Array<Maybe<HotelExperience>>>;
  hotelFacilities?: Maybe<Array<Maybe<FacilitySection>>>;
  hotelInclusiveness?: Maybe<Scalars['String']['output']>;
  hotelOffers?: Maybe<Array<Maybe<HotelOfferPage>>>;
  id: Scalars['ID']['output'];
  kfDescription?: Maybe<Scalars['String']['output']>;
  kfGalleryImages?: Maybe<Array<Maybe<AiPicture>>>;
  kidsActivities?: Maybe<Array<Maybe<HotelKidActivity>>>;
  loyaltyProgram?: Maybe<LoyaltyProgram>;
  map?: Maybe<Scalars['String']['output']>;
  maxChildAge?: Maybe<Scalars['Int']['output']>;
  medias?: Maybe<Array<Maybe<AccorMedia>>>;
  minimumStayDuration?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  offersAndPackages?: Maybe<Array<Maybe<OfferAndPackage>>>;
  opDescription?: Maybe<Scalars['String']['output']>;
  opSeeAllOffersLink?: Maybe<Scalars['String']['output']>;
  pageConfiguration?: Maybe<HotelPageConfiguration>;
  rating?: Maybe<Rating>;
  reviews?: Maybe<Reviews>;
  reviewsList?: Maybe<Array<Maybe<ReviewItem>>>;
  rooms?: Maybe<Array<Maybe<Accommodation>>>;
  seo?: Maybe<SeoMetadata>;
  slug: Scalars['String']['output'];
  soDescription?: Maybe<Scalars['String']['output']>;
  soGalleryImages?: Maybe<Array<Maybe<AiPicture>>>;
  spaActivities?: Maybe<Array<Maybe<HotelSpaActivity>>>;
  spaDescription?: Maybe<Scalars['String']['output']>;
  sportActivities?: Maybe<Array<Maybe<HotelSportActivity>>>;
  surroundings?: Maybe<Surroundings>;
};


export type HotelMediasArgs = {
  mediaCategory?: InputMaybe<AccorMediaCategory>;
  mediaType?: InputMaybe<AccorMediaType>;
};


export type HotelReviewsListArgs = {
  offset?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
};

export type HotelAmenity = {
  __typename?: 'HotelAmenity';
  id: Scalars['ID']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type HotelEntertainment = {
  __typename?: 'HotelEntertainment';
  description?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  picture?: Maybe<AiPicture>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type HotelEvent = {
  __typename?: 'HotelEvent';
  id: Scalars['ID']['output'];
  introduction?: Maybe<Scalars['String']['output']>;
  learnMoreUrl?: Maybe<Scalars['String']['output']>;
  picto?: Maybe<AiPicture>;
  title?: Maybe<Scalars['String']['output']>;
};

export type HotelExperience = {
  __typename?: 'HotelExperience';
  id: Scalars['ID']['output'];
  picture?: Maybe<AiPicture>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type HotelKidActivity = {
  __typename?: 'HotelKidActivity';
  goldSticker?: Maybe<GoldSticker>;
  id: Scalars['ID']['output'];
  introduction?: Maybe<Scalars['String']['output']>;
  learnMoreUrl?: Maybe<Scalars['URL']['output']>;
  picto?: Maybe<AiPicture>;
  title?: Maybe<Scalars['String']['output']>;
};

export type HotelOfferPage = {
  __typename?: 'HotelOfferPage';
  heroImage?: Maybe<AiPicture>;
  hotel?: Maybe<Hotel>;
  inclusionsCarouselDescription?: Maybe<Scalars['String']['output']>;
  inclusionsCarouselPicture?: Maybe<Array<Maybe<AiPicture>>>;
  introduction?: Maybe<Scalars['String']['output']>;
  overviewCarouselDescription?: Maybe<Scalars['String']['output']>;
  overviewCarouselPicture?: Maybe<Array<Maybe<AiPicture>>>;
  seo?: Maybe<SeoMetadata>;
  slug?: Maybe<Scalars['String']['output']>;
  slugByLanguage?: Maybe<Scalars['JSONObject']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  termsAndConditionsContent?: Maybe<Scalars['JSONObject']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type HotelPageConfiguration = {
  __typename?: 'HotelPageConfiguration';
  hide7Pillars?: Maybe<Scalars['Boolean']['output']>;
  hideEntertainments?: Maybe<Scalars['Boolean']['output']>;
  hideFoodsAndBeverages?: Maybe<Scalars['Boolean']['output']>;
  hideIntroduction?: Maybe<Scalars['Boolean']['output']>;
  hideKidsAndFamilyActivity?: Maybe<Scalars['Boolean']['output']>;
  hideKidsAndFamilyOverview?: Maybe<Scalars['Boolean']['output']>;
  hideMeetingAndEvent?: Maybe<Scalars['Boolean']['output']>;
  hideOffer?: Maybe<Scalars['Boolean']['output']>;
  hideReview?: Maybe<Scalars['Boolean']['output']>;
  hideServices?: Maybe<Scalars['Boolean']['output']>;
  hideSpa?: Maybe<Scalars['Boolean']['output']>;
  hideSportsActivities?: Maybe<Scalars['Boolean']['output']>;
  hideSportsOverview?: Maybe<Scalars['Boolean']['output']>;
};

export type HotelSpaActivity = {
  __typename?: 'HotelSpaActivity';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  menuUrl?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<AiPicture>;
  title?: Maybe<Scalars['String']['output']>;
};

export type HotelSportActivity = {
  __typename?: 'HotelSportActivity';
  goldSticker?: Maybe<GoldSticker>;
  id: Scalars['ID']['output'];
  introduction?: Maybe<Scalars['String']['output']>;
  learnMoreUrl?: Maybe<Scalars['URL']['output']>;
  picto?: Maybe<AiPicture>;
  title?: Maybe<Scalars['String']['output']>;
};

export type Identification = {
  __typename?: 'Identification';
  clientType?: Maybe<Scalars['String']['output']>;
  context?: Maybe<Scalars['String']['output']>;
  identificationId?: Maybe<Scalars['String']['output']>;
  lcahmember?: Maybe<Scalars['Boolean']['output']>;
  loyaltyCard?: Maybe<Scalars['Boolean']['output']>;
  loyaltyMember?: Maybe<Scalars['Boolean']['output']>;
};

export type IdentificationPlainText = {
  __typename?: 'IdentificationPlainText';
  identification?: Maybe<Identification>;
};

export type Individual = {
  __typename?: 'Individual';
  birthDate?: Maybe<Scalars['String']['output']>;
  children?: Maybe<Children>;
  favorites?: Maybe<Favorites>;
  gender?: Maybe<Scalars['String']['output']>;
  hasBooking?: Maybe<Scalars['Boolean']['output']>;
  hasHotelFavorite?: Maybe<Scalars['Boolean']['output']>;
  hasLoyaltyCard?: Maybe<Scalars['Boolean']['output']>;
  hasPassword?: Maybe<Scalars['Boolean']['output']>;
  hasPreference?: Maybe<Scalars['Boolean']['output']>;
  hasSegment?: Maybe<Scalars['Boolean']['output']>;
  hasSubscriptionCard?: Maybe<Scalars['Boolean']['output']>;
  hasWallet?: Maybe<Scalars['Boolean']['output']>;
  individualContracts?: Maybe<IndividualContracts>;
  individualLegalIdentifications?: Maybe<IndividualLegalIdentifications>;
  individualName?: Maybe<IndividualName>;
  individualPreferenceFamilies?: Maybe<IndividualPreferenceFamilies>;
  individualSubscriptions?: Maybe<IndividualSubscriptions>;
  isHighValueContact?: Maybe<Scalars['Boolean']['output']>;
  isLoyaltyMember?: Maybe<Scalars['Boolean']['output']>;
  isMerged?: Maybe<Scalars['Boolean']['output']>;
  isReachable?: Maybe<Scalars['Boolean']['output']>;
  isRelevant?: Maybe<Scalars['Boolean']['output']>;
  jobTitle?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  mustUpdatePassword?: Maybe<Scalars['Boolean']['output']>;
  nationality?: Maybe<Scalars['String']['output']>;
  noShareToHotel?: Maybe<Scalars['String']['output']>;
  optOut?: Maybe<OptOut>;
  placeOfBirth?: Maybe<Scalars['String']['output']>;
  pmid?: Maybe<Scalars['String']['output']>;
  registrationChannel?: Maybe<Scalars['String']['output']>;
  tracking?: Maybe<Tracking>;
  uaUserId?: Maybe<Scalars['String']['output']>;
  vipCode?: Maybe<Scalars['String']['output']>;
  vipReasons?: Maybe<VipReasons>;
};

export type IndividualContracts = {
  __typename?: 'IndividualContracts';
  accessCode?: Maybe<Scalars['String']['output']>;
  companySCCode?: Maybe<Scalars['String']['output']>;
  contractId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  tracking?: Maybe<Tracking>;
};

export type IndividualLegalIdentification = {
  __typename?: 'IndividualLegalIdentification';
  Int?: Maybe<Scalars['String']['output']>;
  active?: Maybe<Scalars['Boolean']['output']>;
  expirationDate?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  issuedDate?: Maybe<Scalars['String']['output']>;
  issuingCountry?: Maybe<Scalars['String']['output']>;
  issuingPlace?: Maybe<Scalars['String']['output']>;
  nationalityCode?: Maybe<Scalars['String']['output']>;
  tracking?: Maybe<Tracking>;
  type?: Maybe<Scalars['String']['output']>;
  validationDate?: Maybe<Scalars['String']['output']>;
};

export type IndividualLegalIdentifications = {
  __typename?: 'IndividualLegalIdentifications';
  individualLegalIdentification?: Maybe<Array<Maybe<IndividualLegalIdentification>>>;
};

export type IndividualName = {
  __typename?: 'IndividualName';
  civility?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
  suffix?: Maybe<Scalars['String']['output']>;
};

export type IndividualPreference = {
  __typename?: 'IndividualPreference';
  preference?: Maybe<Preference>;
  preferenceValues?: Maybe<PreferenceValues>;
};

export type IndividualPreferenceFamilies = {
  __typename?: 'IndividualPreferenceFamilies';
  individualPreferenceFamily?: Maybe<Array<Maybe<IndividualPreferenceFamily>>>;
};

export type IndividualPreferenceFamily = {
  __typename?: 'IndividualPreferenceFamily';
  code?: Maybe<Scalars['String']['output']>;
  individualPreferences?: Maybe<IndividualPreferences>;
  preferenceFamilyLabels?: Maybe<PreferenceFamilyLabels>;
};

export type IndividualPreferences = {
  __typename?: 'IndividualPreferences';
  individualPreference?: Maybe<Array<Maybe<IndividualPreference>>>;
};

export type IndividualSubscription = {
  __typename?: 'IndividualSubscription';
  code?: Maybe<Scalars['String']['output']>;
  communication?: Maybe<Communication>;
  id?: Maybe<Scalars['String']['output']>;
  optin?: Maybe<Scalars['Boolean']['output']>;
  origine?: Maybe<Scalars['String']['output']>;
  subscribeDate?: Maybe<Scalars['String']['output']>;
  subscriptionLabels?: Maybe<SubscriptionLabels>;
  tracking?: Maybe<Tracking>;
  unsubscribeDate?: Maybe<Scalars['String']['output']>;
  unsubscribeReason?: Maybe<Scalars['String']['output']>;
  unsubscriptionReasonLabels?: Maybe<UnsubscriptionReasonLabels>;
};

export type IndividualSubscriptions = {
  __typename?: 'IndividualSubscriptions';
  individualSubscription?: Maybe<Array<Maybe<IndividualSubscription>>>;
};

export type InformationBonus = {
  __typename?: 'InformationBonus';
  individualBonusType?: Maybe<Scalars['String']['output']>;
  limitedIntOfUse?: Maybe<Scalars['String']['output']>;
  nohetoId?: Maybe<Scalars['String']['output']>;
  tarsKeys?: Maybe<Scalars['String']['output']>;
  wiseId?: Maybe<Scalars['String']['output']>;
};

export type InputSelectedPeriod = {
  dateIn?: InputMaybe<Scalars['String']['input']>;
  nights?: InputMaybe<Scalars['Int']['input']>;
};

export type Label = {
  __typename?: 'Label';
  label?: Maybe<Scalars['String']['output']>;
  languageCodeAlpha2?: Maybe<Scalars['String']['output']>;
  languageCodeAlpha3?: Maybe<Scalars['String']['output']>;
  languageCodeISO?: Maybe<Scalars['String']['output']>;
};

export type Language = {
  __typename?: 'Language';
  code: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type Lead = {
  __typename?: 'Lead';
  code?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  leadLabels?: Maybe<LeadLabels>;
  tracking?: Maybe<Tracking>;
};

export type LeadLabels = {
  __typename?: 'LeadLabels';
  label?: Maybe<Array<Maybe<Label>>>;
};

export type Leads = {
  __typename?: 'Leads';
  lead?: Maybe<Array<Maybe<Lead>>>;
};

export type LegalPage = {
  __typename?: 'LegalPage';
  description?: Maybe<Scalars['JSONObject']['output']>;
  sections?: Maybe<Array<Maybe<LegalPageSection>>>;
  seo?: Maybe<SeoMetadata>;
  slug?: Maybe<Scalars['String']['output']>;
  slugByLanguage?: Maybe<Scalars['JSONObject']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type LegalPageSection = {
  __typename?: 'LegalPageSection';
  description?: Maybe<Scalars['JSONObject']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type Link = {
  __typename?: 'Link';
  icon?: Maybe<AiPicture>;
  id: Scalars['ID']['output'];
  key?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  url: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type LinkPartner = {
  __typename?: 'LinkPartner';
  accorAdvantagesEligibility?: Maybe<Array<Maybe<AccorAdvantagesEligibility>>>;
  isSwitchable?: Maybe<Scalars['Boolean']['output']>;
  linkEligibile?: Maybe<Scalars['Boolean']['output']>;
  linkEligibleDate?: Maybe<Scalars['String']['output']>;
  partnerCode?: Maybe<Scalars['String']['output']>;
  uneligibilityReason?: Maybe<Scalars['String']['output']>;
};

export type Links = {
  __typename?: 'Links';
  link?: Maybe<Array<Maybe<Array<Maybe<Scalars['JSONObject']['output']>>>>>;
};

export type Loyalty = {
  __typename?: 'Loyalty';
  awardTypes?: Maybe<AwardTypes>;
  balances?: Maybe<Balances>;
  coBrandedCards?: Maybe<CoBrandedCards>;
  cobrandedRateCards?: Maybe<CobrandedRateCards>;
  freenights?: Maybe<Freenights>;
  linkPartners?: Maybe<Array<Maybe<LinkPartner>>>;
  links?: Maybe<Links>;
  loyaltyCards?: Maybe<LoyaltyCards>;
  memberInfo?: Maybe<MemberInfo>;
  operations?: Maybe<Operations>;
  subscribedBonuses?: Maybe<SubscribedBonuses>;
  subscriptionCards?: Maybe<SubscriptionCards>;
};

export type LoyaltyCards = {
  __typename?: 'LoyaltyCards';
  card?: Maybe<Array<Maybe<Card>>>;
  statusGiftEligibility?: Maybe<Scalars['String']['output']>;
};

export type LoyaltyProgram = {
  __typename?: 'LoyaltyProgram';
  advantageAllowed?: Maybe<Scalars['Boolean']['output']>;
  burnAllowed?: Maybe<Scalars['Boolean']['output']>;
  earnAllowed?: Maybe<Scalars['Boolean']['output']>;
  memberRate?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type MemberInfo = {
  __typename?: 'MemberInfo';
  allTypesAwardEligibility?: Maybe<Scalars['String']['output']>;
  displayBurnOnline?: Maybe<Scalars['Boolean']['output']>;
  enrollCompletionReminderEmailSent?: Maybe<Scalars['Boolean']['output']>;
  enrolledBeforeGDPRCompliancy?: Maybe<Scalars['Boolean']['output']>;
  fullEnrolmentDate?: Maybe<Scalars['String']['output']>;
  locked?: Maybe<Scalars['Boolean']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  loyaltyTermsAndConditionsAcceptancedate?: Maybe<Scalars['String']['output']>;
  meetingPlannerAuthorizationEnddate?: Maybe<Scalars['String']['output']>;
  memberPhysicalCard?: Maybe<Scalars['Boolean']['output']>;
  nextTiering?: Maybe<Scalars['String']['output']>;
  pointsExpirationdate?: Maybe<Scalars['String']['output']>;
  preEnrollExpirationDate?: Maybe<Scalars['String']['output']>;
  qrCode?: Maybe<Scalars['JSONObject']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  userHashKey?: Maybe<Scalars['String']['output']>;
};

export type MetaPolicy = {
  __typename?: 'MetaPolicy';
  key?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type Moderated = {
  __typename?: 'Moderated';
  category?: Maybe<Scalars['String']['output']>;
  subCategory?: Maybe<Scalars['String']['output']>;
  word?: Maybe<Scalars['String']['output']>;
};

export type Moderation = {
  __typename?: 'Moderation';
  moderated?: Maybe<Array<Maybe<Moderated>>>;
  originalComment?: Maybe<Scalars['String']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  continueToPayment?: Maybe<PerformBookingResponse>;
  createBasket?: Maybe<Basket>;
  updateBasket?: Maybe<Basket>;
};


export type MutationContinueToPaymentArgs = {
  payload?: InputMaybe<PerformBookingPayload>;
};


export type MutationCreateBasketArgs = {
  hotelCode: Scalars['ID']['input'];
  rooms: Array<BasketRoomPayload>;
};


export type MutationUpdateBasketArgs = {
  basketId: Scalars['ID']['input'];
  hotelCode: Scalars['ID']['input'];
  rooms: Array<BasketRoomPayload>;
};

export type Nationality = {
  __typename?: 'Nationality';
  geoCode?: Maybe<Scalars['String']['output']>;
  isoCode?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type NbNightsByProduct = {
  __typename?: 'NbNightsByProduct';
  multiplyingPointsCoeff?: Maybe<Scalars['String']['output']>;
  nbNights?: Maybe<Scalars['Int']['output']>;
  nbPointsStay1?: Maybe<Scalars['Int']['output']>;
  nbPointsStay2?: Maybe<Scalars['Int']['output']>;
  nbPointsStay3?: Maybe<Scalars['Int']['output']>;
  nbPointsStay4?: Maybe<Scalars['Int']['output']>;
  nightsForAProduct?: Maybe<Array<Maybe<NightsForAProduct>>>;
};

export type NightsForAProduct = {
  __typename?: 'NightsForAProduct';
  productCode?: Maybe<Scalars['Int']['output']>;
  productLabel?: Maybe<Scalars['String']['output']>;
};

/** An object with an ID. */
export type Node = {
  /** The ID of the object. */
  id: Scalars['ID']['output'];
};

export type Offer = {
  __typename?: 'Offer';
  concession?: Maybe<Scalars['String']['output']>;
  deduction?: Maybe<Deduction>;
  index?: Maybe<Scalars['Int']['output']>;
};

export type OfferAndPackage = {
  __typename?: 'OfferAndPackage';
  description?: Maybe<Scalars['String']['output']>;
  detailLink?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  picture?: Maybe<AiPicture>;
  sectionTitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type OfferDetailsMealPlan = {
  __typename?: 'OfferDetailsMealPlan';
  breakfast?: Maybe<OfferDetailsMealPlanBreakfast>;
  code?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  statusDescription?: Maybe<Scalars['String']['output']>;
};

export type OfferDetailsMealPlanBreakfast = {
  __typename?: 'OfferDetailsMealPlanBreakfast';
  price?: Maybe<OfferDetailsMealPlanBreakfastPrice>;
  pricingDescription?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type OfferDetailsMealPlanBreakfastPrice = {
  __typename?: 'OfferDetailsMealPlanBreakfastPrice';
  amount?: Maybe<Scalars['Float']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
};

export type OfferDetailsRoom = {
  __typename?: 'OfferDetailsRoom';
  capacity?: Maybe<RoomCapacity>;
  code?: Maybe<Scalars['String']['output']>;
  commercialOffer?: Maybe<CommercialOffer>;
  description?: Maybe<Scalars['String']['output']>;
  detail?: Maybe<Array<Maybe<OfferDetailsRoomDetail>>>;
  label?: Maybe<Scalars['String']['output']>;
  media?: Maybe<Array<Maybe<AccorMedia>>>;
  offers?: Maybe<Array<Maybe<OfferDetailsRoomOffer>>>;
  referenceOffers?: Maybe<Array<Maybe<BasketRoomReferenceOffer>>>;
  roomSize?: Maybe<Scalars['Float']['output']>;
};

export type OfferDetailsRoomDetail = {
  __typename?: 'OfferDetailsRoomDetail';
  commercialOffer?: Maybe<CommercialOffer>;
  date?: Maybe<Scalars['String']['output']>;
  offers?: Maybe<Array<Maybe<OfferDetailsRoomDetailOffer>>>;
  referenceOffers?: Maybe<Array<Maybe<BasketRoomReferenceOffer>>>;
};

export type OfferDetailsRoomDetailOffer = {
  __typename?: 'OfferDetailsRoomDetailOffer';
  mealPlan?: Maybe<OfferDetailsMealPlan>;
  pricing?: Maybe<Pricing>;
  status?: Maybe<Scalars['String']['output']>;
};

export type OfferDetailsRoomOffer = {
  __typename?: 'OfferDetailsRoomOffer';
  averagePricing?: Maybe<Pricing>;
  burnPointAvailable?: Maybe<Scalars['Boolean']['output']>;
  categories?: Maybe<Array<Maybe<Categories>>>;
  childLabel?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  childSupplement?: Maybe<Scalars['Boolean']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  effectiveOccupancy?: Maybe<EffectiveOccupancy>;
  flexibility?: Maybe<Flexibility>;
  href?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  mainMealPlanDescription?: Maybe<Scalars['String']['output']>;
  mealPlan?: Maybe<Scalars['String']['output']>;
  mealPlanDescription?: Maybe<Scalars['String']['output']>;
  package?: Maybe<RoomOfferPackage>;
  paymentDescription?: Maybe<Scalars['String']['output']>;
  policies?: Maybe<Array<Maybe<Policies>>>;
  prepay?: Maybe<Scalars['Boolean']['output']>;
  pricing?: Maybe<Pricing>;
  status?: Maybe<Scalars['String']['output']>;
  tax?: Maybe<Array<Maybe<OfferDetailsRoomOfferTax>>>;
};

export type OfferDetailsRoomOfferTax = {
  __typename?: 'OfferDetailsRoomOfferTax';
  included?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  prepay?: Maybe<Scalars['Boolean']['output']>;
  vat?: Maybe<Scalars['Boolean']['output']>;
};

export type Operations = {
  __typename?: 'Operations';
  maxResultOperationsExceeded?: Maybe<Scalars['Boolean']['output']>;
  operation?: Maybe<Array<Maybe<UserOperation>>>;
};

export type OptOut = {
  __typename?: 'OptOut';
  isOptOutTotal?: Maybe<Scalars['Boolean']['output']>;
  optOutDate?: Maybe<Scalars['String']['output']>;
};

export type OtherPage = {
  __typename?: 'OtherPage';
  content?: Maybe<Scalars['JSONObject']['output']>;
  cta?: Maybe<OtherPageCta>;
  heroImage?: Maybe<AiPicture>;
  introduction?: Maybe<Scalars['String']['output']>;
  seo?: Maybe<SeoMetadata>;
  slug?: Maybe<Scalars['String']['output']>;
  slugByLanguage?: Maybe<Scalars['JSONObject']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type OtherPageCta = {
  __typename?: 'OtherPageCta';
  label?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type OtherTax = {
  __typename?: 'OtherTax';
  amount?: Maybe<AmountValue>;
  detail?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type ParticipantReservee = {
  __typename?: 'ParticipantReservee';
  civility?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  mail?: Maybe<Scalars['String']['output']>;
};

export type PenaltyAmount = {
  __typename?: 'PenaltyAmount';
  currency?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type PerformBookingCheckinResponse = {
  __typename?: 'PerformBookingCheckinResponse';
  checkInAction?: Maybe<Scalars['String']['output']>;
  checkInLabel?: Maybe<Scalars['String']['output']>;
  checkInStatus?: Maybe<Scalars['String']['output']>;
  checkInUrl?: Maybe<Scalars['String']['output']>;
  checkOutLabel?: Maybe<Scalars['String']['output']>;
  checkOutStatus?: Maybe<Scalars['String']['output']>;
  hourOfArrival?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  smsLabel?: Maybe<Scalars['String']['output']>;
};

export type PerformBookingCompanyResponse = {
  __typename?: 'PerformBookingCompanyResponse';
  name?: Maybe<Scalars['String']['output']>;
  reserver?: Maybe<Scalars['String']['output']>;
};

export type PerformBookingIdhabResponse = {
  __typename?: 'PerformBookingIDHABResponse';
  code?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type PerformBookingLoyaltyProgramResponse = {
  __typename?: 'PerformBookingLoyaltyProgramResponse';
  hotel?: Maybe<Scalars['Boolean']['output']>;
  offer?: Maybe<Scalars['Boolean']['output']>;
};

export type PerformBookingMetadata = {
  additionnalBookingInformations: Scalars['String']['input'];
  stayReason: Scalars['String']['input'];
};

export type PerformBookingPartnersResponse = {
  __typename?: 'PerformBookingPartnersResponse';
  trustPilot?: Maybe<PerformBookingPartnersTrustPilotResponse>;
};

export type PerformBookingPartnersTrustPilotResponse = {
  __typename?: 'PerformBookingPartnersTrustPilotResponse';
  url?: Maybe<Scalars['String']['output']>;
};

export type PerformBookingPayload = {
  basketId: Scalars['String']['input'];
  burnPoints: Scalars['Int']['input'];
  metaData: PerformBookingMetadata;
  payment: PerformBookingPaymentMethod;
  profile?: InputMaybe<PerformBookingProfile>;
  reservee: PerformBookingReservee;
  salesConditionAccepted: Scalars['Boolean']['input'];
  savePersonalInformations?: InputMaybe<Scalars['Boolean']['input']>;
  userPmid?: InputMaybe<Scalars['String']['input']>;
};

export type PerformBookingPaymentMethod = {
  cardType?: InputMaybe<Scalars['String']['input']>;
};

export type PerformBookingPaymentProviderPsd2Response = {
  __typename?: 'PerformBookingPaymentProviderPSD2Response';
  payload?: Maybe<Scalars['String']['output']>;
  pspTransactionId?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type PerformBookingPaymentProviderQrCodeResponse = {
  __typename?: 'PerformBookingPaymentProviderQRCodeResponse';
  qrCodeImage?: Maybe<Scalars['String']['output']>;
  qrCodeToken?: Maybe<Scalars['String']['output']>;
};

export type PerformBookingPaymentProviderResponse = {
  __typename?: 'PerformBookingPaymentProviderResponse';
  psd2?: Maybe<PerformBookingPaymentProviderPsd2Response>;
  qrcode?: Maybe<PerformBookingPaymentProviderQrCodeResponse>;
  redirectUrl?: Maybe<Scalars['String']['output']>;
};

export type PerformBookingPaymentResponse = {
  __typename?: 'PerformBookingPaymentResponse';
  cardType?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<PerformBookingPaymentProviderResponse>;
  status?: Maybe<Scalars['String']['output']>;
  transactionId?: Maybe<Scalars['String']['output']>;
  wallet?: Maybe<PerformBookingPaymentWalletResponse>;
};

export type PerformBookingPaymentWalletResponse = {
  __typename?: 'PerformBookingPaymentWalletResponse';
  enrollStatus?: Maybe<Scalars['String']['output']>;
  responseStatus?: Maybe<Scalars['String']['output']>;
};

export type PerformBookingProfile = {
  cguAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  enroll?: InputMaybe<Scalars['Boolean']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
};

export type PerformBookingProfileResponse = {
  __typename?: 'PerformBookingProfileResponse';
  enroll?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type PerformBookingReservee = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  address3?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  civilityCode: Scalars['String']['input'];
  countryCode: Scalars['String']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  nationalityCode: Scalars['String']['input'];
  phone: PerformBookingReserveePhone;
  stateCode?: InputMaybe<Scalars['String']['input']>;
  zipcode?: InputMaybe<Scalars['String']['input']>;
};

export type PerformBookingReserveePhone = {
  number: Scalars['String']['input'];
  prefix: Scalars['String']['input'];
};

export type PerformBookingResponse = {
  __typename?: 'PerformBookingResponse';
  bookingId?: Maybe<Scalars['String']['output']>;
  bookingNumber?: Maybe<Scalars['String']['output']>;
  checkIn?: Maybe<PerformBookingCheckinResponse>;
  checkInDate?: Maybe<Scalars['String']['output']>;
  checkInDone?: Maybe<Scalars['Boolean']['output']>;
  company?: Maybe<PerformBookingCompanyResponse>;
  hotelCode?: Maybe<Scalars['String']['output']>;
  idhab?: Maybe<PerformBookingIdhabResponse>;
  loyaltyProgram?: Maybe<PerformBookingLoyaltyProgramResponse>;
  nights?: Maybe<Scalars['Int']['output']>;
  notifications?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  partners?: Maybe<PerformBookingPartnersResponse>;
  payment?: Maybe<PerformBookingPaymentResponse>;
  profile?: Maybe<PerformBookingProfileResponse>;
  recipientEmail?: Maybe<Scalars['String']['output']>;
  recipientFirstName?: Maybe<Scalars['String']['output']>;
  recipientLastName?: Maybe<Scalars['String']['output']>;
  responseStatus?: Maybe<PerformBookingResponseStatusResponse>;
  tracking?: Maybe<PerformBookingTrackingResponse>;
  welcome?: Maybe<PerformBookingWelcomeResponse>;
};

export type PerformBookingResponseStatusResponse = {
  __typename?: 'PerformBookingResponseStatusResponse';
  bookingStatus?: Maybe<Scalars['String']['output']>;
};

export type PerformBookingTrackingResponse = {
  __typename?: 'PerformBookingTrackingResponse';
  urlCommissionJunction?: Maybe<Scalars['String']['output']>;
  urlKenshoo?: Maybe<Scalars['String']['output']>;
  urlMediamind?: Maybe<Scalars['String']['output']>;
  urlTradeDoubler?: Maybe<Scalars['String']['output']>;
};

export type PerformBookingWelcomeResponse = {
  __typename?: 'PerformBookingWelcomeResponse';
  behaviour?: Maybe<Scalars['String']['output']>;
  checkInLabel?: Maybe<Scalars['String']['output']>;
  checkInStatus?: Maybe<Scalars['String']['output']>;
  checkInUrl?: Maybe<Scalars['String']['output']>;
  checkOutLabel?: Maybe<Scalars['String']['output']>;
  checkOutStatus?: Maybe<Scalars['String']['output']>;
  hourOfArrival?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  smsLabel?: Maybe<Scalars['String']['output']>;
};

export type Phone = {
  __typename?: 'Phone';
  number?: Maybe<Scalars['String']['output']>;
  prefix?: Maybe<Scalars['String']['output']>;
};

export type PhonePayload = {
  number: Scalars['String']['input'];
  prefix: Scalars['String']['input'];
};

export type Pillar = {
  __typename?: 'Pillar';
  description?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<AiPicture>;
};

export type Policies = {
  __typename?: 'Policies';
  code?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  meta?: Maybe<Array<Maybe<MetaPolicy>>>;
  numberDayLimit?: Maybe<Scalars['String']['output']>;
};

export type Preference = {
  __typename?: 'Preference';
  code?: Maybe<Scalars['String']['output']>;
  defaultName?: Maybe<Scalars['String']['output']>;
  preferenceLabels?: Maybe<PreferenceLabels>;
  valuesType?: Maybe<Scalars['String']['output']>;
};

export type PreferenceFamilyLabels = {
  __typename?: 'PreferenceFamilyLabels';
  label?: Maybe<Array<Maybe<Label>>>;
};

export type PreferenceLabels = {
  __typename?: 'PreferenceLabels';
  label?: Maybe<Array<Maybe<Label>>>;
};

export type PreferenceValue = {
  __typename?: 'PreferenceValue';
  brandSegment?: Maybe<BrandSegment>;
  code?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  commentLanguage?: Maybe<Scalars['String']['output']>;
  commentTitle?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['Date']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  createdByHotel?: Maybe<Scalars['String']['output']>;
  defaultName?: Maybe<Scalars['String']['output']>;
  favoriteCentral?: Maybe<Scalars['Boolean']['output']>;
  favoriteClient?: Maybe<Scalars['Boolean']['output']>;
  favoriteHotels?: Maybe<FavoriteHotels>;
  id?: Maybe<Scalars['String']['output']>;
  moderation?: Maybe<Moderation>;
  nature?: Maybe<Scalars['String']['output']>;
  optinDate?: Maybe<Scalars['String']['output']>;
  preferenceValueLabels?: Maybe<PreferenceValueLabels>;
  sensitive?: Maybe<Scalars['Boolean']['output']>;
  tracking?: Maybe<Tracking>;
  updated?: Maybe<Scalars['Date']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type PreferenceValueLabels = {
  __typename?: 'PreferenceValueLabels';
  label?: Maybe<Array<Maybe<Label>>>;
};

export type PreferenceValues = {
  __typename?: 'PreferenceValues';
  preferenceValue?: Maybe<Array<Maybe<PreferenceValue>>>;
};

export type Pricing = {
  __typename?: 'Pricing';
  amount?: Maybe<Amount>;
  commission?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
};

export type ProductAccommodation = {
  __typename?: 'ProductAccommodation';
  accommodations?: Maybe<Array<Maybe<Accommodation>>>;
  id: Scalars['ID']['output'];
};

export type PromiseBonus = {
  __typename?: 'PromiseBonus';
  nbNightsByProduct?: Maybe<NbNightsByProduct>;
  nbPoints?: Maybe<Scalars['Int']['output']>;
};

export type Query = {
  __typename?: 'Query';
  accountEligibility?: Maybe<EligibilityResponse>;
  amenities: Array<Amenity>;
  availableRoomEnhancementOptions?: Maybe<Array<Maybe<RoomEnhancementOptions>>>;
  availableRooms?: Maybe<Array<Maybe<AvailableRoom>>>;
  basket?: Maybe<Basket>;
  bestOffer: BestOffer;
  booking?: Maybe<Booking>;
  bookingSeo?: Maybe<BookingSeoMetadata>;
  checkCorporateCodes?: Maybe<IdentificationPlainText>;
  civilities: Array<Civility>;
  contentfulHotel?: Maybe<ContentfulHotel>;
  countries: Array<Country>;
  currencies: Array<Currency>;
  experienceCategories?: Maybe<Array<Maybe<ExperienceCategory>>>;
  globalConfiguration?: Maybe<GlobalConfiguration>;
  homepage?: Maybe<Homepage>;
  hotel?: Maybe<Hotel>;
  hotelBySlug?: Maybe<Hotel>;
  hotelOfferPage?: Maybe<HotelOfferPage>;
  hotelRoomsAvailabilities: Array<Maybe<AvailabilityRoom>>;
  identificationPlainText?: Maybe<IdentificationPlainText>;
  languages: Array<Language>;
  legalPage?: Maybe<LegalPage>;
  nationalities: Array<Nationality>;
  now: Scalars['DateTime']['output'];
  otherPage?: Maybe<OtherPage>;
  roomOfferDetails?: Maybe<OfferDetailsRoom>;
  searchAirportOrigin?: Maybe<SearchOriginResult>;
  searchDestination?: Maybe<SearchDestinationResult>;
  searchHotels?: Maybe<SearchHotelResult>;
  searchSeo?: Maybe<SeoMetadata>;
  user?: Maybe<CustomerInformation>;
  validatePhone?: Maybe<Scalars['Boolean']['output']>;
  validateRooms?: Maybe<Scalars['Boolean']['output']>;
  verifyCode?: Maybe<VerifyCodeResponse>;
};


export type QueryAccountEligibilityArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  lang?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAvailableRoomEnhancementOptionsArgs = {
  hotelCode: Scalars['ID']['input'];
  rooms: Array<InputMaybe<SelectedRoom>>;
};


export type QueryAvailableRoomsArgs = {
  adults: Scalars['Int']['input'];
  childrenAges?: InputMaybe<Array<Scalars['Int']['input']>>;
  dateIn: Scalars['Date']['input'];
  hotelCode: Scalars['ID']['input'];
  nights: Scalars['Int']['input'];
};


export type QueryBasketArgs = {
  basketId: Scalars['ID']['input'];
};


export type QueryBestOfferArgs = {
  adults: Scalars['Int']['input'];
  childrenAges?: InputMaybe<Array<Scalars['Int']['input']>>;
  dateIn: Scalars['String']['input'];
  hotelCode: Scalars['ID']['input'];
  nights: Scalars['Int']['input'];
};


export type QueryBookingArgs = {
  bookingId: Scalars['ID']['input'];
};


export type QueryCheckCorporateCodesArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
  cardNumber?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['String']['input']>;
  preferentialCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryContentfulHotelArgs = {
  id: Scalars['ID']['input'];
};


export type QueryHotelArgs = {
  id: Scalars['ID']['input'];
  mediaCategory?: InputMaybe<AccorMediaCategory>;
  mediaType?: InputMaybe<AccorMediaType>;
};


export type QueryHotelBySlugArgs = {
  mediaCategory?: InputMaybe<AccorMediaCategory>;
  mediaType?: InputMaybe<AccorMediaType>;
  slug: Scalars['String']['input'];
};


export type QueryHotelOfferPageArgs = {
  hotelSlug: Scalars['String']['input'];
  slug: Scalars['String']['input'];
};


export type QueryHotelRoomsAvailabilitiesArgs = {
  adults: Scalars['Int']['input'];
  childrenAges?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  dateIn: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  nights: Scalars['Int']['input'];
};


export type QueryIdentificationPlainTextArgs = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
  cardNumber?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['String']['input']>;
  preferentialCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryLegalPageArgs = {
  slug: Scalars['String']['input'];
};


export type QueryOtherPageArgs = {
  slug: Scalars['String']['input'];
};


export type QueryRoomOfferDetailsArgs = {
  adults: Scalars['Int']['input'];
  childrenAges?: InputMaybe<Array<Scalars['Int']['input']>>;
  dateIn: Scalars['String']['input'];
  hotelCode: Scalars['ID']['input'];
  nights: Scalars['Int']['input'];
  offerCode: Scalars['ID']['input'];
  productCode: Scalars['ID']['input'];
};


export type QuerySearchAirportOriginArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySearchDestinationArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySearchHotelsArgs = {
  dates?: InputMaybe<DateSearchInput>;
  destination?: InputMaybe<DestinationSearchInput>;
  rooms?: InputMaybe<Array<InputMaybe<RoomSearchInput>>>;
};


export type QueryValidatePhoneArgs = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};


export type QueryValidateRoomsArgs = {
  dateIn: Scalars['String']['input'];
  hotelCode: Scalars['ID']['input'];
  nights: Scalars['Int']['input'];
  rooms: Array<InputMaybe<BasicRoom>>;
};


export type QueryVerifyCodeArgs = {
  code?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
};

export type QuestionAnswer = {
  __typename?: 'QuestionAnswer';
  answer?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
};

export type Rating = {
  __typename?: 'Rating';
  stars?: Maybe<Scalars['Float']['output']>;
};

export type RepaymentDetail = {
  __typename?: 'RepaymentDetail';
  amountInCurrency?: Maybe<Scalars['Int']['output']>;
  amountInEuro?: Maybe<Scalars['Int']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  nbDecimalsCurrency?: Maybe<Scalars['Int']['output']>;
  refundDate?: Maybe<Scalars['Date']['output']>;
  refundRate?: Maybe<Scalars['Int']['output']>;
};

export type ReviewItem = {
  __typename?: 'ReviewItem';
  author?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['String']['output']>;
  score?: Maybe<Scalars['Int']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  tripType?: Maybe<Scalars['String']['output']>;
};

export type Reviews = {
  __typename?: 'Reviews';
  average?: Maybe<Scalars['Float']['output']>;
  count?: Maybe<Scalars['Int']['output']>;
  hotelId?: Maybe<Scalars['String']['output']>;
};

export type RoomCapacity = {
  __typename?: 'RoomCapacity';
  maxAdult?: Maybe<Scalars['Int']['output']>;
  maxChild?: Maybe<Scalars['Int']['output']>;
  maxPax?: Maybe<Scalars['Int']['output']>;
};

export type RoomEnhancementOption = {
  __typename?: 'RoomEnhancementOption';
  code?: Maybe<Scalars['String']['output']>;
  customerCategory?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  detail?: Maybe<Array<Maybe<EnhancementOptionDetail>>>;
  label: Scalars['String']['output'];
  maxQuantity: Scalars['Int']['output'];
  media?: Maybe<Array<Maybe<AccorMedia>>>;
  perDay?: Maybe<Scalars['Boolean']['output']>;
  policy?: Maybe<Array<Maybe<EnhancementOptionPolicy>>>;
  pricing: EnhancementOptionPricing;
  pricingUnit?: Maybe<EnhancementOptionPricingUnit>;
  remaining?: Maybe<Scalars['Int']['output']>;
  tax?: Maybe<Array<Maybe<RoomEnhancementOptionTax>>>;
  type?: Maybe<Scalars['String']['output']>;
  warranted?: Maybe<Scalars['Boolean']['output']>;
  webExclusive?: Maybe<Scalars['Boolean']['output']>;
};

export type RoomEnhancementOptionTax = {
  __typename?: 'RoomEnhancementOptionTax';
  included?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  prepay?: Maybe<Scalars['Boolean']['output']>;
  vat?: Maybe<Scalars['Boolean']['output']>;
};

export type RoomEnhancementOptions = {
  __typename?: 'RoomEnhancementOptions';
  adults: Scalars['Int']['output'];
  childrenAge?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  offerCode: Scalars['String']['output'];
  option: Array<RoomEnhancementOption>;
  productCode: Scalars['String']['output'];
};

export type RoomOfferPackage = {
  __typename?: 'RoomOfferPackage';
  includedProducts?: Maybe<Array<Maybe<RoomOfferPackageProduct>>>;
  type?: Maybe<Scalars['String']['output']>;
};

export type RoomOfferPackageProduct = {
  __typename?: 'RoomOfferPackageProduct';
  code?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type RoomOffers = {
  __typename?: 'RoomOffers';
  averagePricing?: Maybe<AveragePricing>;
  burnPointAvailable?: Maybe<Scalars['Boolean']['output']>;
  categories?: Maybe<Array<Maybe<Categories>>>;
  childLabel?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  childSupplement?: Maybe<Scalars['Boolean']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  effectiveOccupancy?: Maybe<EffectiveOccupancy>;
  flexibility?: Maybe<Flexibility>;
  href?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  mainMealPlanDescription?: Maybe<Scalars['String']['output']>;
  mealPlan?: Maybe<Scalars['String']['output']>;
  mealPlanDescription?: Maybe<Scalars['String']['output']>;
  package?: Maybe<RoomOfferPackage>;
  paymentDescription?: Maybe<Scalars['String']['output']>;
  policies?: Maybe<Array<Maybe<Policies>>>;
  prepay?: Maybe<Scalars['Boolean']['output']>;
  pricing?: Maybe<Pricing>;
  remaining?: Maybe<Scalars['String']['output']>;
  snuRoomRef?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  supplement?: Maybe<Scalars['String']['output']>;
  tax?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type RoomSearchInput = {
  adults: Scalars['Int']['input'];
  childrenAges: Array<Scalars['Int']['input']>;
};

export type RoomSize = {
  __typename?: 'RoomSize';
  roomsizeft2?: Maybe<Scalars['String']['output']>;
  roomsizem2?: Maybe<Scalars['String']['output']>;
};

export type SearchBestOffer = {
  __typename?: 'SearchBestOffer';
  currency?: Maybe<Scalars['String']['output']>;
  memberMealPlan?: Maybe<Scalars['String']['output']>;
  memberPrice?: Maybe<Scalars['Float']['output']>;
  preferredOfferMealPlan?: Maybe<Scalars['String']['output']>;
  preferredOfferPrice?: Maybe<Scalars['Float']['output']>;
  publicMealPlan?: Maybe<Scalars['String']['output']>;
  publicPrice?: Maybe<Scalars['Float']['output']>;
};

export type SearchDestination = {
  __typename?: 'SearchDestination';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  expediaId?: Maybe<Scalars['String']['output']>;
  hotel?: Maybe<Hotel>;
  localizations?: Maybe<Array<Maybe<SearchDestinationLocalization>>>;
  type?: Maybe<SearchDestinationResultType>;
};

export type SearchDestinationLocalization = {
  __typename?: 'SearchDestinationLocalization';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
};

export type SearchDestinationResult = {
  __typename?: 'SearchDestinationResult';
  destinations?: Maybe<Array<Maybe<SearchDestination>>>;
  empty?: Maybe<Scalars['Boolean']['output']>;
};

export enum SearchDestinationResultType {
  City = 'CITY',
  Country = 'COUNTRY',
  Hotel = 'HOTEL'
}

export type SearchHotel = {
  __typename?: 'SearchHotel';
  bestOffer?: Maybe<SearchBestOffer>;
  brand: Scalars['String']['output'];
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  countryCode?: Maybe<Scalars['String']['output']>;
  expediaId: Scalars['String']['output'];
  experienceCategories?: Maybe<Array<ExperienceCategory>>;
  galleryImages?: Maybe<Array<AiPicture>>;
  hotelInclusiveness?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  nbReviews?: Maybe<Scalars['Int']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
  ridcode: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  street: Scalars['String']['output'];
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type SearchHotelResult = {
  __typename?: 'SearchHotelResult';
  alternativeHotels?: Maybe<Array<Maybe<SearchHotel>>>;
  hotels?: Maybe<Array<Maybe<SearchHotel>>>;
};

export type SearchOrigin = {
  __typename?: 'SearchOrigin';
  code: Scalars['String']['output'];
  country: Scalars['String']['output'];
  fullName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type: SearchOriginResultType;
};

export type SearchOriginResult = {
  __typename?: 'SearchOriginResult';
  empty: Scalars['Boolean']['output'];
  origins: Array<SearchOrigin>;
};

export enum SearchOriginResultType {
  Airport = 'AIRPORT',
  AirportMetroCode = 'AIRPORT_METRO_CODE',
  City = 'CITY',
  MetroStation = 'METRO_STATION',
  MultiCityVicinity = 'MULTI_CITY_VICINITY',
  MultiRegion = 'MULTI_REGION',
  Neighborhood = 'NEIGHBORHOOD',
  PointOfInterest = 'POINT_OF_INTEREST',
  TrainStation = 'TRAIN_STATION'
}

export type SelectedPeriod = {
  __typename?: 'SelectedPeriod';
  dateIn?: Maybe<Scalars['String']['output']>;
  nights?: Maybe<Scalars['Int']['output']>;
};

export type SelectedRoom = {
  adults?: InputMaybe<Scalars['Int']['input']>;
  childrenAges?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  offerCode?: InputMaybe<Scalars['String']['input']>;
  period?: InputMaybe<InputSelectedPeriod>;
  productCode?: InputMaybe<Scalars['String']['input']>;
};

export type SeoMetadata = {
  __typename?: 'SeoMetadata';
  description?: Maybe<Scalars['String']['output']>;
  ogDescription?: Maybe<Scalars['String']['output']>;
  ogImage?: Maybe<AiPicture>;
  ogTitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type SpecialHotelOffer = {
  __typename?: 'SpecialHotelOffer';
  ctaBookingLabel?: Maybe<Scalars['String']['output']>;
  heroImage?: Maybe<AiPicture>;
  inclusionsCarouselDescription?: Maybe<Scalars['String']['output']>;
  inclusionsCarouselPicture?: Maybe<Array<Maybe<AiPicture>>>;
  introduction?: Maybe<Scalars['String']['output']>;
  overviewCarouselDescription?: Maybe<Scalars['String']['output']>;
  overviewCarouselPicture?: Maybe<Array<Maybe<AiPicture>>>;
  seo?: Maybe<SeoMetadata>;
  slug?: Maybe<Scalars['String']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  termsAndConditionsContent?: Maybe<Scalars['JSONObject']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type State = {
  __typename?: 'State';
  code?: Maybe<Scalars['String']['output']>;
  codeGeo?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type StatusGift = {
  __typename?: 'StatusGift';
  beneficiaryCardInt?: Maybe<Scalars['String']['output']>;
  beneficiaryPmid?: Maybe<Scalars['String']['output']>;
  beneficiaryStatusExpirationDate?: Maybe<Scalars['String']['output']>;
  giftExpirationDate?: Maybe<Scalars['String']['output']>;
  givenCardProduct?: Maybe<GivenCardProduct>;
  statusGiftDate?: Maybe<Scalars['String']['output']>;
};

export type StayDetail = {
  __typename?: 'StayDetail';
  bookingValueDate?: Maybe<Scalars['String']['output']>;
  checkInDate?: Maybe<Scalars['String']['output']>;
  checkOutDate?: Maybe<Scalars['String']['output']>;
  hotelCode?: Maybe<Scalars['String']['output']>;
  hotelName?: Maybe<Scalars['String']['output']>;
  redeemedLoginHL?: Maybe<Scalars['String']['output']>;
  redemptionDate?: Maybe<Scalars['String']['output']>;
  roomInt?: Maybe<Scalars['String']['output']>;
  tarsBookingInt?: Maybe<Scalars['String']['output']>;
  tarsFileInt?: Maybe<Scalars['String']['output']>;
};

export type SubscribedBonus = {
  __typename?: 'SubscribedBonus';
  code?: Maybe<Scalars['String']['output']>;
  criteriaBonus?: Maybe<CriteriaBonus>;
  enrollmentDate?: Maybe<Scalars['String']['output']>;
  informationBonus?: Maybe<InformationBonus>;
  name?: Maybe<Scalars['String']['output']>;
  promiseBonus?: Maybe<PromiseBonus>;
  type?: Maybe<Scalars['String']['output']>;
};

export type SubscribedBonuses = {
  __typename?: 'SubscribedBonuses';
  subscribedBonus?: Maybe<Array<Maybe<SubscribedBonus>>>;
};

export type SubscriptionCards = {
  __typename?: 'SubscriptionCards';
  card?: Maybe<Array<Maybe<Card>>>;
  statusGiftEligibility?: Maybe<Scalars['String']['output']>;
};

export type SubscriptionLabels = {
  __typename?: 'SubscriptionLabels';
  label?: Maybe<Array<Maybe<Label>>>;
};

export type SurroundingDistance = {
  __typename?: 'SurroundingDistance';
  km?: Maybe<Scalars['Float']['output']>;
  miles?: Maybe<Scalars['Float']['output']>;
};

export type SurroundingPlace = {
  __typename?: 'SurroundingPlace';
  distance?: Maybe<SurroundingDistance>;
  name?: Maybe<Scalars['String']['output']>;
};

export type Surroundings = {
  __typename?: 'Surroundings';
  nearbyAirports?: Maybe<Array<Maybe<SurroundingPlace>>>;
  nearbyAttractions?: Maybe<Array<Maybe<SurroundingPlace>>>;
};

export type Survey = {
  __typename?: 'Survey';
  aggregates?: Maybe<Array<Maybe<Aggregate>>>;
  file?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  questionAnswers?: Maybe<Array<Maybe<QuestionAnswer>>>;
  stayDetail?: Maybe<StayDetail>;
};

export type Surveys = {
  __typename?: 'Surveys';
  aggregates?: Maybe<Array<Maybe<Aggregate>>>;
  survey?: Maybe<Array<Maybe<Survey>>>;
};

export type Testimonial = {
  __typename?: 'Testimonial';
  author?: Maybe<Scalars['String']['output']>;
  hotel?: Maybe<Hotel>;
  hotelId?: Maybe<Scalars['String']['output']>;
  reviewText?: Maybe<Scalars['String']['output']>;
};

export type Tracking = {
  __typename?: 'Tracking';
  createdByHotel?: Maybe<Scalars['String']['output']>;
  createdByOperator?: Maybe<Scalars['String']['output']>;
  createdBySystem?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['Date']['output']>;
  updatedByHotel?: Maybe<Scalars['String']['output']>;
  updatedByOperator?: Maybe<Scalars['String']['output']>;
  updatedBySystem?: Maybe<Scalars['String']['output']>;
  updatedDate?: Maybe<Scalars['Date']['output']>;
};

export type UnsubscriptionReasonLabels = {
  __typename?: 'UnsubscriptionReasonLabels';
  label?: Maybe<Array<Maybe<Label>>>;
};

export type UserOperation = {
  __typename?: 'UserOperation';
  cancelled?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  fileInt?: Maybe<Scalars['String']['output']>;
  nightsCount?: Maybe<Scalars['Int']['output']>;
  offerCode?: Maybe<Scalars['String']['output']>;
  offerName?: Maybe<Scalars['String']['output']>;
  operationDate?: Maybe<Scalars['Date']['output']>;
  points?: Maybe<Scalars['Int']['output']>;
  statusPoints?: Maybe<Scalars['Int']['output']>;
  transactionDate?: Maybe<Scalars['Date']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type Vat = {
  __typename?: 'Vat';
  amount?: Maybe<AmountValue>;
  detail?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type VerifyCodeResponse = {
  __typename?: 'VerifyCodeResponse';
  acknowledge?: Maybe<Scalars['Boolean']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
};

export type VipReason = {
  __typename?: 'VipReason';
  code?: Maybe<Scalars['String']['output']>;
  createdByHotelCode?: Maybe<Scalars['String']['output']>;
  creationDate?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  tracking?: Maybe<Tracking>;
  updatedate?: Maybe<Scalars['Date']['output']>;
  vipReasonHotelLikes?: Maybe<VipReasonHotelLikes>;
  vipReasonLabels?: Maybe<VipReasonLabels>;
};

export type VipReasonHotelLike = {
  __typename?: 'VipReasonHotelLike';
  hotelCode?: Maybe<Scalars['String']['output']>;
  tracking?: Maybe<Tracking>;
};

export type VipReasonHotelLikes = {
  __typename?: 'VipReasonHotelLikes';
  vipReasonHotelLike?: Maybe<Array<Maybe<VipReasonHotelLike>>>;
};

export type VipReasonLabels = {
  __typename?: 'VipReasonLabels';
  label?: Maybe<Array<Maybe<Label>>>;
};

export type VipReasons = {
  __typename?: 'VipReasons';
  vipReason?: Maybe<Array<Maybe<VipReason>>>;
};

export type Wallet = {
  __typename?: 'Wallet';
  creationDate?: Maybe<Scalars['Date']['output']>;
  endUse?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  startUse?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updateDate?: Maybe<Scalars['Date']['output']>;
};

export type Wallets = {
  __typename?: 'Wallets';
  wallet?: Maybe<Array<Maybe<Wallet>>>;
};

export type AccommodationFragment = { __typename?: 'Accommodation', topAmenities?: Array<string | null> | null, description?: string | null, extendedStay?: boolean | null, id?: string | null, label?: string | null, shortLabel?: string | null, spacialViewLink?: string | null, amenities?: Array<{ __typename?: 'AccommodationAmenity', label?: string | null, name?: string | null, amenities?: Array<{ __typename?: 'AccommodationAmenityItem', value?: string | null } | null> | null, facilities?: Array<{ __typename?: 'AccommodationFacility', label?: string | null, name?: string | null, items?: Array<{ __typename?: 'AccommodationItem', code?: string | null, name?: string | null, paying?: boolean | null } | null> | null } | null> | null } | null> | null, surface?: { __typename?: 'AccommodationSurface', squareFeet?: number | null, squareMeter?: number | null } | null, classification?: { __typename?: 'AccommodationClassification', standard?: string | null, type?: string | null } | null, configuration?: Array<{ __typename?: 'AccommodationConfiguration', assets?: Array<any | null> | null, beddings?: { __typename?: 'AccommodationBeddings', details?: Array<any | null> | null, doubleBed?: number | null, singleBed?: number | null, qualified: Array<{ __typename?: 'AccommodationBeddingsQualified', label?: string | null, quantity?: number | null, type?: string | null } | null>, extra?: { __typename?: 'AccommodationExtra', adultBed?: boolean | null, childBed?: boolean | null, crib?: boolean | null } | null } | null, maxOccupancy?: { __typename?: 'AccommodationMaxOccupancy', adult?: number | null, children?: number | null, maxChildAge?: number | null, pax?: number | null } | null, situation?: { __typename?: 'AccommodationSituation', accessibility?: boolean | null, views?: Array<string | null> | null } | null } | null> | null, floorSpace?: { __typename?: 'AccommodationFloorSpace', unit?: string | null, value?: number | null } | null, medias?: { __typename?: 'AccommodationMedias', total?: number | null, photos?: Array<{ __typename?: 'AiPicture', id?: string | null, alt?: string | null, src?: string | null, srcSet?: string | null } | null> | null } | null };

export type AccorMediaFragment = { __typename?: 'AccorMedia', category?: AccorMediaCategory | null, productCode?: string | null, type?: AccorMediaType | null, formats?: Array<{ __typename?: 'AccorMediaFormat', format?: string | null, path: string, generic?: boolean | null, lastUpdate?: string | null } | null> | null };

export type AiPictureFragment = { __typename?: 'AiPicture', alt?: string | null, id?: string | null, src?: string | null, srcSet?: string | null };

export type AmenityFragment = { __typename?: 'Amenity', code?: string | null, label?: string | null };

export type CivilityFragment = { __typename?: 'Civility', code?: string | null, label?: string | null, value?: string | null };

export type ContactUsFragment = { __typename?: 'ContactUs', email?: string | null };

export type CountryFragment = { __typename?: 'Country', alpha2Code?: string | null, callingCodes?: Array<string | null> | null, geoCode?: string | null, idCardRequired?: boolean | null, name?: string | null, nationality?: { __typename?: 'Nationality', geoCode?: string | null, isoCode?: string | null, name?: string | null } | null, states?: Array<{ __typename?: 'State', code?: string | null, codeGeo?: string | null, name?: string | null } | null> | null };

export type CurrencyFragment = { __typename?: 'Currency', code: string, value: string, symbol?: string | null, euroRate: number };

export type CustomerEmailContactFragment = { __typename?: 'ContactMediumEmail', email?: string | null, isPrimary?: boolean | null };

export type CustomerInformationFragment = { __typename?: 'CustomerInformation', id?: string | null, status?: string | null, individual?: { __typename?: 'Individual', nationality?: string | null, isLoyaltyMember?: boolean | null, uaUserId?: string | null, pmid?: string | null, individualName?: { __typename?: 'IndividualName', firstName?: string | null, lastName?: string | null, civility?: string | null } | null } | null, loyalty?: { __typename?: 'Loyalty', balances?: { __typename?: 'Balances', nbPoints?: number | null } | null, loyaltyCards?: { __typename?: 'LoyaltyCards', card?: Array<{ __typename?: 'Card', cardNumber?: string | null, isLastActiveCard?: boolean | null, cardProduct?: { __typename?: 'CardProduct', productLabel?: string | null, cardCodeTARS?: string | null, productTier?: string | null } | null } | null> | null } | null } | null, contactMediums?: { __typename?: 'ContactMediums', contactMedium?: Array<{ __typename?: 'ContactMedium', id: string, mediumUsages?: { __typename?: 'ContactMediumUsages', mediumUsage?: Array<{ __typename?: 'ContactMediumUsage', usageType?: string | null }> | null } | null, postalAddress?: { __typename?: 'ContactMediumPostalAddress', address1?: string | null, address2?: string | null, address3?: string | null, address4?: string | null, zipCode?: string | null, city?: string | null, countryCode?: string | null, stateCode?: string | null, isPrimary?: boolean | null } | null, telephoneNumber?: { __typename?: 'ContactMediumPhoneNumber', phonePrefix?: string | null, phoneNumber?: string | null, isPrimary?: boolean | null } | null, emailContact?: { __typename?: 'ContactMediumEmail', email?: string | null, isPrimary?: boolean | null } | null }> | null } | null };

export type CustomerPhoneNumberFragment = { __typename?: 'ContactMediumPhoneNumber', phonePrefix?: string | null, phoneNumber?: string | null, isPrimary?: boolean | null };

export type CustomerPostalAddressFragment = { __typename?: 'ContactMediumPostalAddress', address1?: string | null, address2?: string | null, address3?: string | null, address4?: string | null, zipCode?: string | null, city?: string | null, countryCode?: string | null, stateCode?: string | null, isPrimary?: boolean | null };

export type DestinationFragment = { __typename?: 'Country', title?: string | null, countInHotels?: number | null, id: string, destinationPicture?: { __typename?: 'AiPicture', alt?: string | null, id?: string | null, src?: string | null, srcSet?: string | null } | null };

export type DetailRoomOfferFragment = { __typename?: 'OfferDetailsRoomOffer', code?: string | null, label?: string | null, description?: string | null, mealPlan?: string | null, mealPlanDescription?: string | null, mainMealPlanDescription?: string | null, categories?: Array<{ __typename?: 'Categories', code?: string | null } | null> | null, pricing?: { __typename?: 'Pricing', currency?: string | null, amount?: { __typename?: 'Amount', afterTax?: number | null, hotelKeeper?: number | null } | null } | null, policies?: Array<{ __typename?: 'Policies', label?: string | null, description?: string | null } | null> | null, tax?: Array<{ __typename?: 'OfferDetailsRoomOfferTax', included?: boolean | null, prepay?: boolean | null, vat?: boolean | null, label?: string | null } | null> | null };

export type ExperienceCategoryFragment = { __typename?: 'ExperienceCategory', id?: string | null, title?: string | null, countInHotels?: number | null, logo?: { __typename?: 'AiPicture', id?: string | null, src?: string | null, alt?: string | null, srcSet?: string | null } | null, carouselImage?: { __typename?: 'AiPicture', id?: string | null, src?: string | null, alt?: string | null, srcSet?: string | null } | null };

export type FacilityFragment = { __typename?: 'Facility', id: string, cuisineType?: string | null, title: string, description: string, menu?: string | null, menuUrl?: string | null, openingHours?: string | null, picture?: { __typename?: 'AiPicture', id?: string | null, alt?: string | null, src?: string | null, srcSet?: string | null } | null, goldSticker?: { __typename?: 'GoldSticker', label?: string | null } | null };

export type FacilitySectionFragment = { __typename?: 'FacilitySection', id: string, title?: string | null, entries: Array<{ __typename?: 'Facility', id: string, cuisineType?: string | null, title: string, description: string, menu?: string | null, menuUrl?: string | null, openingHours?: string | null, picture?: { __typename?: 'AiPicture', id?: string | null, alt?: string | null, src?: string | null, srcSet?: string | null } | null, goldSticker?: { __typename?: 'GoldSticker', label?: string | null } | null } | null> };

export type FooterColumnFragment = { __typename?: 'FooterColumn', id: string, title: string, links?: Array<{ __typename?: 'Link', id: string, label: string, url: string }> | null };

export type FooterConfigurationFragment = { __typename?: 'FooterConfiguration', copyright: string, footerColumns?: Array<{ __typename?: 'FooterColumn', id: string, title: string, links?: Array<{ __typename?: 'Link', id: string, label: string, url: string }> | null }> | null, footerBrandLogos?: Array<{ __typename?: 'AiPicture', alt?: string | null, id?: string | null, src?: string | null, srcSet?: string | null }> | null, footerLinks?: Array<{ __typename?: 'Link', id: string, label: string, url: string }> | null, socialLinks?: Array<{ __typename?: 'Link', id: string, url: string, label: string, icon?: { __typename?: 'AiPicture', alt?: string | null, id?: string | null, src?: string | null, srcSet?: string | null } | null }> | null };

export type FooterIconLinkFragment = { __typename?: 'Link', id: string, url: string, label: string, icon?: { __typename?: 'AiPicture', alt?: string | null, id?: string | null, src?: string | null, srcSet?: string | null } | null };

export type FooterTextLinkFragment = { __typename?: 'Link', id: string, label: string, url: string };

export type AddressFragment = { __typename?: 'Address', city?: string | null, country?: string | null, countryCode?: string | null, lat?: string | null, lng?: string | null, zipCode?: string | null, street?: string | null };

export type HotelAmenityFragment = { __typename?: 'HotelAmenity', id: string, title?: string | null };

export type ContactFragment = { __typename?: 'Contact', mail?: string | null, phone?: string | null, phonePrefix?: string | null };

export type HotelEntertainmentFragment = { __typename?: 'HotelEntertainment', description?: string | null, endDate?: string | null, startDate?: string | null, title?: string | null, id: string, picture?: { __typename?: 'AiPicture', src?: string | null, srcSet?: string | null } | null };

export type HotelEventFragment = { __typename?: 'HotelEvent', id: string, title?: string | null, introduction?: string | null, learnMoreUrl?: string | null, picto?: { __typename?: 'AiPicture', id?: string | null, alt?: string | null, src?: string | null, srcSet?: string | null } | null };

export type HotelExperienceFragment = { __typename?: 'HotelExperience', id: string, title?: string | null, subtitle?: string | null, picture?: { __typename?: 'AiPicture', alt?: string | null, src?: string | null, srcSet?: string | null } | null };

export type HotelKidActivityFragment = { __typename?: 'HotelKidActivity', id: string, introduction?: string | null, learnMoreUrl?: any | null, title?: string | null, picto?: { __typename?: 'AiPicture', id?: string | null, src?: string | null, srcSet?: string | null, alt?: string | null } | null, goldSticker?: { __typename?: 'GoldSticker', label?: string | null } | null };

export type HotelOfferCarouselFragment = { __typename?: 'HotelOfferPage', title?: string | null, slug?: string | null, subtitle?: string | null, introduction?: string | null, heroImage?: { __typename?: 'AiPicture', alt?: string | null, id?: string | null, src?: string | null, srcSet?: string | null } | null };

export type HotelOfferPageFragment = { __typename?: 'HotelOfferPage', title?: string | null, slug?: string | null, subtitle?: string | null, introduction?: string | null, overviewCarouselDescription?: string | null, inclusionsCarouselDescription?: string | null, termsAndConditionsContent?: any | null, slugByLanguage?: any | null, heroImage?: { __typename?: 'AiPicture', alt?: string | null, id?: string | null, src?: string | null, srcSet?: string | null } | null, overviewCarouselPicture?: Array<{ __typename?: 'AiPicture', alt?: string | null, id?: string | null, src?: string | null, srcSet?: string | null } | null> | null, inclusionsCarouselPicture?: Array<{ __typename?: 'AiPicture', alt?: string | null, id?: string | null, src?: string | null, srcSet?: string | null } | null> | null, seo?: { __typename?: 'SeoMetadata', description?: string | null, ogDescription?: string | null, ogTitle?: string | null, title?: string | null, ogImage?: { __typename?: 'AiPicture', alt?: string | null, id?: string | null, src?: string | null, srcSet?: string | null } | null } | null, hotel?: { __typename?: 'Hotel', id: string, name?: string | null, slug: string, expediaId: string, minimumStayDuration?: number | null } | null };

export type HotelPageConfigurationFragment = { __typename?: 'HotelPageConfiguration', hide7Pillars?: boolean | null, hideEntertainments?: boolean | null, hideFoodsAndBeverages?: boolean | null, hideIntroduction?: boolean | null, hideKidsAndFamilyActivity?: boolean | null, hideKidsAndFamilyOverview?: boolean | null, hideMeetingAndEvent?: boolean | null, hideOffer?: boolean | null, hideReview?: boolean | null, hideServices?: boolean | null, hideSpa?: boolean | null, hideSportsActivities?: boolean | null, hideSportsOverview?: boolean | null };

export type ReviewItemFragment = { __typename?: 'ReviewItem', author?: string | null, score?: number | null, created?: string | null, text?: string | null, title?: string | null, tripType?: string | null };

export type HotelSpaActivityFragment = { __typename?: 'HotelSpaActivity', id: string, title?: string | null, description?: string | null, menuUrl?: string | null, picture?: { __typename?: 'AiPicture', id?: string | null, alt?: string | null, src?: string | null, srcSet?: string | null } | null };

export type HotelSportActivityFragment = { __typename?: 'HotelSportActivity', id: string, introduction?: string | null, learnMoreUrl?: any | null, title?: string | null, picto?: { __typename?: 'AiPicture', id?: string | null, src?: string | null, srcSet?: string | null, alt?: string | null } | null, goldSticker?: { __typename?: 'GoldSticker', label?: string | null } | null };

export type SurroundingsFragment = { __typename?: 'Surroundings', nearbyAirports?: Array<{ __typename?: 'SurroundingPlace', name?: string | null, distance?: { __typename?: 'SurroundingDistance', km?: number | null, miles?: number | null } | null } | null> | null, nearbyAttractions?: Array<{ __typename?: 'SurroundingPlace', name?: string | null, distance?: { __typename?: 'SurroundingDistance', km?: number | null, miles?: number | null } | null } | null> | null };

export type LanguageFragment = { __typename?: 'Language', code: string, label: string };

export type LegalPageFragment = { __typename?: 'LegalPage', description?: any | null, slug?: string | null, slugByLanguage?: any | null, title?: string | null, sections?: Array<{ __typename?: 'LegalPageSection', title?: string | null, description?: any | null } | null> | null, seo?: { __typename?: 'SeoMetadata', description?: string | null, ogDescription?: string | null, ogTitle?: string | null, title?: string | null, ogImage?: { __typename?: 'AiPicture', alt?: string | null, id?: string | null, src?: string | null, srcSet?: string | null } | null } | null };

export type NationalityFragment = { __typename?: 'Nationality', geoCode?: string | null, isoCode?: string | null, name?: string | null };

export type OfferAndPackageFragment = { __typename?: 'OfferAndPackage', description?: string | null, id: string, title?: string | null, sectionTitle?: string | null, detailLink?: string | null, picture?: { __typename?: 'AiPicture', id?: string | null, alt?: string | null, src?: string | null, srcSet?: string | null } | null };

export type OtherPageFragment = { __typename?: 'OtherPage', slug?: string | null, title?: string | null, subtitle?: string | null, introduction?: string | null, content?: any | null, slugByLanguage?: any | null, heroImage?: { __typename?: 'AiPicture', alt?: string | null, id?: string | null, src?: string | null, srcSet?: string | null } | null, cta?: { __typename?: 'OtherPageCta', label?: string | null, url?: string | null } | null, seo?: { __typename?: 'SeoMetadata', description?: string | null, ogDescription?: string | null, ogTitle?: string | null, title?: string | null, ogImage?: { __typename?: 'AiPicture', alt?: string | null, id?: string | null, src?: string | null, srcSet?: string | null } | null } | null };

export type PillarFragment = { __typename?: 'Pillar', description?: string | null, label?: string | null, link?: string | null, picture?: { __typename?: 'AiPicture', alt?: string | null, id?: string | null, srcSet?: string | null, src?: string | null } | null };

export type RoomEnhancementOptionsFragment = { __typename?: 'RoomEnhancementOptions', productCode: string, offerCode: string, option: Array<{ __typename?: 'RoomEnhancementOption', code?: string | null, label: string, maxQuantity: number, description?: string | null, type?: string | null, warranted?: boolean | null, pricing: { __typename?: 'EnhancementOptionPricing', currency: string, amount: { __typename?: 'EnhancementOptionPricingAmount', hotelKeeper: number, afterTax?: number | null, otherTax?: { __typename?: 'OtherTax', amount?: { __typename?: 'AmountValue', excluded?: number | null } | null } | null } }, pricingUnit?: { __typename?: 'EnhancementOptionPricingUnit', label: string } | null, media?: Array<{ __typename?: 'AccorMedia', formats?: Array<{ __typename?: 'AccorMediaFormat', path: string, format?: string | null } | null> | null } | null> | null, policy?: Array<{ __typename?: 'EnhancementOptionPolicy', code?: string | null, description?: string | null } | null> | null, detail?: Array<{ __typename?: 'EnhancementOptionDetail', pricing?: { __typename?: 'Pricing', currency?: string | null, amount?: { __typename?: 'Amount', hotelKeeper?: number | null, afterTax?: number | null } | null } | null, period?: { __typename?: 'SelectedPeriod', dateIn?: string | null } | null } | null> | null, tax?: Array<{ __typename?: 'RoomEnhancementOptionTax', label?: string | null } | null> | null }> };

export type RoomOfferFragment = { __typename?: 'RoomOffers', label?: string | null, description?: string | null, mealPlan?: string | null, mealPlanDescription?: string | null, mainMealPlanDescription?: string | null, tax?: Array<string | null> | null, pricing?: { __typename?: 'Pricing', currency?: string | null, amount?: { __typename?: 'Amount', hotelKeeper?: number | null, vat?: { __typename?: 'Vat', amount?: { __typename?: 'AmountValue', excluded?: number | null } | null } | null } | null } | null, policies?: Array<{ __typename?: 'Policies', label?: string | null, description?: string | null } | null> | null };

export type RoomOfferDetailFragment = { __typename?: 'OfferDetailsRoomDetail', date?: string | null, offers?: Array<{ __typename?: 'OfferDetailsRoomDetailOffer', pricing?: { __typename?: 'Pricing', currency?: string | null, amount?: { __typename?: 'Amount', afterTax?: number | null, hotelKeeper?: number | null } | null } | null, mealPlan?: { __typename?: 'OfferDetailsMealPlan', code?: string | null } | null } | null> | null };

export type SearchHotelFragment = { __typename?: 'SearchHotel', brand: string, city: string, country: string, countryCode?: string | null, hotelInclusiveness?: string | null, id: string, name: string, nbReviews?: number | null, rating?: number | null, ridcode: string, slug: string, street: string, zipCode?: string | null, expediaId: string, bestOffer?: { __typename?: 'SearchBestOffer', currency?: string | null, memberMealPlan?: string | null, memberPrice?: number | null, publicMealPlan?: string | null, publicPrice?: number | null, preferredOfferMealPlan?: string | null, preferredOfferPrice?: number | null } | null, experienceCategories?: Array<{ __typename?: 'ExperienceCategory', title?: string | null, id?: string | null, order: number, logo?: { __typename?: 'AiPicture', alt?: string | null, id?: string | null, src?: string | null, srcSet?: string | null } | null }> | null, galleryImages?: Array<{ __typename?: 'AiPicture', alt?: string | null, id?: string | null, src?: string | null, srcSet?: string | null }> | null };

export type SearchOriginFragment = { __typename?: 'SearchOrigin', code: string, country: string, fullName: string, id: string, name: string, type: SearchOriginResultType };

export type SeoMetadataFragment = { __typename?: 'SeoMetadata', description?: string | null, ogDescription?: string | null, ogTitle?: string | null, title?: string | null, ogImage?: { __typename?: 'AiPicture', alt?: string | null, id?: string | null, src?: string | null, srcSet?: string | null } | null };

export type StateFragment = { __typename?: 'State', code?: string | null, codeGeo?: string | null, name?: string | null };

export type TestimonialFragment = { __typename?: 'Testimonial', reviewText?: string | null, author?: string | null, hotel?: { __typename?: 'Hotel', name?: string | null, address?: { __typename?: 'Address', country?: string | null } | null } | null };

export type BasketFragment = { __typename?: 'Basket', hotelId?: string | null, id: string, rooms?: Array<{ __typename?: 'BasketRoom', id?: string | null, adults?: number | null, childrenAges?: Array<number | null> | null, prepay?: boolean | null, productCode?: string | null, productLabel?: string | null, beneficiary?: { __typename?: 'BasketBeneficiary', address1?: string | null, address2?: string | null, address3?: string | null, address4?: string | null, nationalityCode?: string | null, stateCode?: string | null, territoryCode?: string | null, zipcode?: string | null, city?: string | null, civilityCode: string, countryCode: string, email: string, firstName: string, firstNameNonLatin?: string | null, lastName: string, lastNameNonLatin?: string | null, phone?: { __typename?: 'Phone', number?: string | null, prefix?: string | null } | null, billing?: { __typename?: 'BasketBeneficiaryCompany', name?: string | null, vatNumber?: string | null } | null } | null, offer?: { __typename?: 'BasketRoomOffer', code?: string | null, label?: string | null, averagePricing?: { __typename?: 'BasketOptionPricing', currency?: string | null, amount?: { __typename?: 'BasketPriceDetails', afterTax?: number | null, hotelKeeper?: number | null, payAtTheHotel?: number | null, payOnline?: number | null, fees?: { __typename?: 'BasketTaxe', excluded?: number | null, included?: number | null, details?: Array<{ __typename?: 'BasketTaxeDetails', code?: string | null, included?: boolean | null, label?: string | null, onlinePayable?: boolean | null, refundable?: boolean | null } | null> | null } | null, otherTax?: { __typename?: 'BasketTaxe', excluded?: number | null, included?: number | null, details?: Array<{ __typename?: 'BasketTaxeDetails', code?: string | null, included?: boolean | null, label?: string | null, onlinePayable?: boolean | null, refundable?: boolean | null } | null> | null } | null, vat?: { __typename?: 'BasketTaxe', excluded?: number | null, included?: number | null, details?: Array<{ __typename?: 'BasketTaxeDetails', code?: string | null, included?: boolean | null, label?: string | null, onlinePayable?: boolean | null, refundable?: boolean | null } | null> | null } | null } | null, commission?: { __typename?: 'BasketCommission', amount?: number | null, currency?: string | null, percent?: number | null } | null } | null, pricing?: { __typename?: 'BasketOptionPricing', currency?: string | null, amount?: { __typename?: 'BasketPriceDetails', afterTax?: number | null, hotelKeeper?: number | null, payAtTheHotel?: number | null, payOnline?: number | null, fees?: { __typename?: 'BasketTaxe', excluded?: number | null, included?: number | null, details?: Array<{ __typename?: 'BasketTaxeDetails', code?: string | null, included?: boolean | null, label?: string | null, onlinePayable?: boolean | null, refundable?: boolean | null } | null> | null } | null, otherTax?: { __typename?: 'BasketTaxe', excluded?: number | null, included?: number | null, details?: Array<{ __typename?: 'BasketTaxeDetails', code?: string | null, included?: boolean | null, label?: string | null, onlinePayable?: boolean | null, refundable?: boolean | null } | null> | null } | null, vat?: { __typename?: 'BasketTaxe', excluded?: number | null, included?: number | null, details?: Array<{ __typename?: 'BasketTaxeDetails', code?: string | null, included?: boolean | null, label?: string | null, onlinePayable?: boolean | null, refundable?: boolean | null } | null> | null } | null } | null, commission?: { __typename?: 'BasketCommission', amount?: number | null, currency?: string | null, percent?: number | null } | null } | null, referenceOffers?: Array<{ __typename?: 'BasketRoomReferenceOffer', categories?: Array<BasketRoomOfferCategoryCode | null> | null, code?: string | null, averagePricing?: { __typename?: 'BasketOptionPricing', currency?: string | null, amount?: { __typename?: 'BasketPriceDetails', afterTax?: number | null, hotelKeeper?: number | null, payAtTheHotel?: number | null, payOnline?: number | null, fees?: { __typename?: 'BasketTaxe', excluded?: number | null, included?: number | null, details?: Array<{ __typename?: 'BasketTaxeDetails', code?: string | null, included?: boolean | null, label?: string | null, onlinePayable?: boolean | null, refundable?: boolean | null } | null> | null } | null, otherTax?: { __typename?: 'BasketTaxe', excluded?: number | null, included?: number | null, details?: Array<{ __typename?: 'BasketTaxeDetails', code?: string | null, included?: boolean | null, label?: string | null, onlinePayable?: boolean | null, refundable?: boolean | null } | null> | null } | null, vat?: { __typename?: 'BasketTaxe', excluded?: number | null, included?: number | null, details?: Array<{ __typename?: 'BasketTaxeDetails', code?: string | null, included?: boolean | null, label?: string | null, onlinePayable?: boolean | null, refundable?: boolean | null } | null> | null } | null } | null, commission?: { __typename?: 'BasketCommission', amount?: number | null, currency?: string | null, percent?: number | null } | null } | null, pricing?: { __typename?: 'BasketOptionPricing', currency?: string | null, amount?: { __typename?: 'BasketPriceDetails', afterTax?: number | null, hotelKeeper?: number | null, payAtTheHotel?: number | null, payOnline?: number | null, fees?: { __typename?: 'BasketTaxe', excluded?: number | null, included?: number | null, details?: Array<{ __typename?: 'BasketTaxeDetails', code?: string | null, included?: boolean | null, label?: string | null, onlinePayable?: boolean | null, refundable?: boolean | null } | null> | null } | null, otherTax?: { __typename?: 'BasketTaxe', excluded?: number | null, included?: number | null, details?: Array<{ __typename?: 'BasketTaxeDetails', code?: string | null, included?: boolean | null, label?: string | null, onlinePayable?: boolean | null, refundable?: boolean | null } | null> | null } | null, vat?: { __typename?: 'BasketTaxe', excluded?: number | null, included?: number | null, details?: Array<{ __typename?: 'BasketTaxeDetails', code?: string | null, included?: boolean | null, label?: string | null, onlinePayable?: boolean | null, refundable?: boolean | null } | null> | null } | null } | null, commission?: { __typename?: 'BasketCommission', amount?: number | null, currency?: string | null, percent?: number | null } | null } | null } | null> | null, categories?: Array<{ __typename?: 'BasketRoomOfferCategory', code?: BasketRoomOfferCategoryCode | null, subCategories?: Array<string | null> | null } | null> | null, checkIn?: { __typename?: 'BasketRoomOfferCheckIn', availability?: BasketRoomOfferCheckInAvailability | null, available?: boolean | null, checkInSmsAvailable?: boolean | null, paymentDate?: string | null, price?: { __typename?: 'BasketAmount', amount: number, currency: string } | null } | null, concession?: { __typename?: 'BasketRoomOfferConcession', unit?: BasketRoomOfferConcessionUnit | null, value?: number | null } | null, deduction?: { __typename?: 'BasketRoomOfferDeduction', value?: number | null, reference?: { __typename?: 'BasketRoomOfferDeductionReference', deduction?: string | null, index?: number | null } | null } | null, flexibility?: { __typename?: 'BasketRoomOfferFlexibility', code?: BasketRoomOfferFlexibilityCode | null, label?: string | null, limitDate?: string | null, penalty?: { __typename?: 'BasketPenalty', night?: number | null, percent?: number | null, amount?: { __typename?: 'BasketAmount', amount: number, currency: string } | null } | null } | null, mealPlan?: { __typename?: 'BasketRoomOfferMealPlan', description?: string | null, status?: string | null, type?: BasketRoomOfferMealPlanType | null } | null, policies: Array<{ __typename?: 'BasketRoomOptionPolicy', code?: string | null, description?: string | null, label?: string | null, numberDayLimit?: number | null, metas?: Array<{ __typename?: 'BasketMetaInfo', key?: string | null, value?: string | null } | null> | null } | null> } | null, options: Array<{ __typename?: 'BasketRoomOption', code?: string | null, quantity?: number | null, remaining?: number | null, title?: string | null, type?: BasketRoomOptionType | null, warranted?: boolean | null, webExclusive?: boolean | null, description?: string | null, label?: string | null, maxQuantity?: number | null, perDay?: boolean | null, pricingUnit?: { __typename?: 'BasketRoomOptionPricingUnit', code?: BasketRoomOptionPricingUnitCode | null, label?: string | null } | null, unitaryPricing?: { __typename?: 'BasketRoomUnitaryPrice', afterTax?: number | null, beforeTax?: number | null, currency?: string | null, hotelKeeper?: number | null } | null, details?: Array<{ __typename?: 'BasketRoomOptionDetails', status?: BasketRoomOptionStatus | null, period?: { __typename?: 'BasketPeriod', dateIn?: string | null, nights?: number | null } | null, pricing?: { __typename?: 'BasketOptionPricing', currency?: string | null, amount?: { __typename?: 'BasketPriceDetails', afterTax?: number | null, hotelKeeper?: number | null, payAtTheHotel?: number | null, payOnline?: number | null, fees?: { __typename?: 'BasketTaxe', excluded?: number | null, included?: number | null, details?: Array<{ __typename?: 'BasketTaxeDetails', code?: string | null, included?: boolean | null, label?: string | null, onlinePayable?: boolean | null, refundable?: boolean | null } | null> | null } | null, otherTax?: { __typename?: 'BasketTaxe', excluded?: number | null, included?: number | null, details?: Array<{ __typename?: 'BasketTaxeDetails', code?: string | null, included?: boolean | null, label?: string | null, onlinePayable?: boolean | null, refundable?: boolean | null } | null> | null } | null, vat?: { __typename?: 'BasketTaxe', excluded?: number | null, included?: number | null, details?: Array<{ __typename?: 'BasketTaxeDetails', code?: string | null, included?: boolean | null, label?: string | null, onlinePayable?: boolean | null, refundable?: boolean | null } | null> | null } | null } | null, commission?: { __typename?: 'BasketCommission', amount?: number | null, currency?: string | null, percent?: number | null } | null } | null } | null> | null, medias: Array<{ __typename?: 'BasketRoomOptionMedia', category?: BasketRoomOptionMediaCategory | null, defaultMedium?: boolean | null, type?: BasketRoomOptionMediaType | null, sources?: Array<{ __typename?: 'BasketRoomOptionMediaSource', format?: string | null, url?: string | null } | null> | null } | null>, policies: Array<{ __typename?: 'BasketRoomOptionPolicy', code?: string | null, description?: string | null, label?: string | null, numberDayLimit?: number | null, metas?: Array<{ __typename?: 'BasketMetaInfo', key?: string | null, value?: string | null } | null> | null } | null>, prices?: { __typename?: 'BasketRoomOptionPrices', currency?: string | null, extraTax?: string | null, finalPrice?: string | null, price?: string | null } | null, pricing?: { __typename?: 'BasketOptionPricing', currency?: string | null, amount?: { __typename?: 'BasketPriceDetails', afterTax?: number | null, hotelKeeper?: number | null, payAtTheHotel?: number | null, payOnline?: number | null, fees?: { __typename?: 'BasketTaxe', excluded?: number | null, included?: number | null, details?: Array<{ __typename?: 'BasketTaxeDetails', code?: string | null, included?: boolean | null, label?: string | null, onlinePayable?: boolean | null, refundable?: boolean | null } | null> | null } | null, otherTax?: { __typename?: 'BasketTaxe', excluded?: number | null, included?: number | null, details?: Array<{ __typename?: 'BasketTaxeDetails', code?: string | null, included?: boolean | null, label?: string | null, onlinePayable?: boolean | null, refundable?: boolean | null } | null> | null } | null, vat?: { __typename?: 'BasketTaxe', excluded?: number | null, included?: number | null, details?: Array<{ __typename?: 'BasketTaxeDetails', code?: string | null, included?: boolean | null, label?: string | null, onlinePayable?: boolean | null, refundable?: boolean | null } | null> | null } | null } | null, commission?: { __typename?: 'BasketCommission', amount?: number | null, currency?: string | null, percent?: number | null } | null } | null } | null>, period?: { __typename?: 'BasketPeriod', dateIn?: string | null, nights?: number | null } | null } | null> | null, products?: Array<{ __typename?: 'BasketProduct', adults?: number | null, productCode?: string | null, purchasedOfferId?: string | null, quantity?: number | null, salesPoliciesUrls?: Array<string | null> | null, status?: string | null, title?: string | null, type?: string | null, childrenAges?: Array<number | null> | null, description?: string | null, id?: string | null, partnerCode?: string | null, paymentDate?: string | null, quotation?: { __typename?: 'BasketProductQuotation', id?: string | null, offerId?: string | null } | null, beneficiaries?: Array<{ __typename?: 'BasketBeneficiary', address1?: string | null, address2?: string | null, address3?: string | null, address4?: string | null, nationalityCode?: string | null, stateCode?: string | null, territoryCode?: string | null, zipcode?: string | null, city?: string | null, civilityCode: string, countryCode: string, email: string, firstName: string, firstNameNonLatin?: string | null, lastName: string, lastNameNonLatin?: string | null, phone?: { __typename?: 'Phone', number?: string | null, prefix?: string | null } | null, billing?: { __typename?: 'BasketBeneficiaryCompany', name?: string | null, vatNumber?: string | null } | null } | null> | null, period?: { __typename?: 'BasketProductPeriod', from?: string | null, to?: string | null } | null, price?: { __typename?: 'BasketProductPriceDetails', afterTax?: number | null, beforeTax?: number | null, currency?: string | null, payAtTheHotel?: number | null, payOnline?: number | null, totalTax?: number | null } | null } | null> | null, vouchers?: Array<{ __typename?: 'BasketVoucher', points: number, price: { __typename?: 'BasketAmount', amount: number, currency: string }, detail: Array<{ __typename?: 'BasketVoucherDetail', points: number, roomId: string, price: { __typename?: 'BasketAmount', amount: number, currency: string } }> }> | null, paymentWithFees?: { __typename?: 'BasketPaymentWithFees', type?: string | null, families?: Array<{ __typename?: 'BasketPaymentFamily', familyCode?: string | null, rank?: number | null, payment?: { __typename?: 'BasketFeesPayment', code?: string | null, amounts?: Array<{ __typename?: 'BasketFeesAmount', afterTax?: number | null, currency?: string | null, payAtTheHotel?: number | null, payOnline?: number | null, rank?: number | null, voucher?: number | null, fees?: { __typename?: 'BasketFees', amountAfterTax?: number | null, amountAtTheHotel?: number | null, amountOnline?: number | null, percent?: number | null } | null } | null> | null } | null } | null> | null } | null, prices?: { __typename?: 'BasketPrice', currency?: string | null, average?: { __typename?: 'BasketAveragePrice', amount?: { __typename?: 'BasketPriceLight', afterTax?: number | null, hotelKeeper?: number | null } | null, commission?: { __typename?: 'BasketCommission', amount?: number | null, currency?: string | null, percent?: number | null } | null } | null, commission?: { __typename?: 'BasketCommission', amount?: number | null, currency?: string | null, percent?: number | null } | null, details?: { __typename?: 'BasketPriceDetails', afterTax?: number | null, hotelKeeper?: number | null, payAtTheHotel?: number | null, payOnline?: number | null, fees?: { __typename?: 'BasketTaxe', excluded?: number | null, included?: number | null, details?: Array<{ __typename?: 'BasketTaxeDetails', code?: string | null, included?: boolean | null, label?: string | null, onlinePayable?: boolean | null, refundable?: boolean | null } | null> | null } | null, otherTax?: { __typename?: 'BasketTaxe', excluded?: number | null, included?: number | null, details?: Array<{ __typename?: 'BasketTaxeDetails', code?: string | null, included?: boolean | null, label?: string | null, onlinePayable?: boolean | null, refundable?: boolean | null } | null> | null } | null, vat?: { __typename?: 'BasketTaxe', excluded?: number | null, included?: number | null, details?: Array<{ __typename?: 'BasketTaxeDetails', code?: string | null, included?: boolean | null, label?: string | null, onlinePayable?: boolean | null, refundable?: boolean | null } | null> | null } | null } | null, withProducts?: { __typename?: 'BasketProductPriceDetails', afterTax?: number | null, beforeTax?: number | null, currency?: string | null, payAtTheHotel?: number | null, payOnline?: number | null, totalTax?: number | null } | null } | null, policies?: { __typename?: 'BasketPolicies', extras?: Array<string | null> | null, warranty?: string | null } | null, payment?: { __typename?: 'BasketPayment', type?: string | null, families?: Array<{ __typename?: 'BasketPaymentFamily', familyCode?: string | null, methods?: Array<{ __typename?: 'BasketPaymentFamilyMethod', code?: string | null, name?: string | null } | null> | null } | null> | null } | null, warrantyPolicies?: { __typename?: 'BasketWarrantyPolicies', checkInLimitHour?: string | null } | null };

export type BasketAmountFragment = { __typename?: 'BasketAmount', amount: number, currency: string };

export type BasketBeneficiaryFragment = { __typename?: 'BasketBeneficiary', address1?: string | null, address2?: string | null, address3?: string | null, address4?: string | null, nationalityCode?: string | null, stateCode?: string | null, territoryCode?: string | null, zipcode?: string | null, city?: string | null, civilityCode: string, countryCode: string, email: string, firstName: string, firstNameNonLatin?: string | null, lastName: string, lastNameNonLatin?: string | null, phone?: { __typename?: 'Phone', number?: string | null, prefix?: string | null } | null, billing?: { __typename?: 'BasketBeneficiaryCompany', name?: string | null, vatNumber?: string | null } | null };

export type BasketCommissionFragment = { __typename?: 'BasketCommission', amount?: number | null, currency?: string | null, percent?: number | null };

export type BasketOptionPricingFragment = { __typename?: 'BasketOptionPricing', currency?: string | null, amount?: { __typename?: 'BasketPriceDetails', afterTax?: number | null, hotelKeeper?: number | null, payAtTheHotel?: number | null, payOnline?: number | null, fees?: { __typename?: 'BasketTaxe', excluded?: number | null, included?: number | null, details?: Array<{ __typename?: 'BasketTaxeDetails', code?: string | null, included?: boolean | null, label?: string | null, onlinePayable?: boolean | null, refundable?: boolean | null } | null> | null } | null, otherTax?: { __typename?: 'BasketTaxe', excluded?: number | null, included?: number | null, details?: Array<{ __typename?: 'BasketTaxeDetails', code?: string | null, included?: boolean | null, label?: string | null, onlinePayable?: boolean | null, refundable?: boolean | null } | null> | null } | null, vat?: { __typename?: 'BasketTaxe', excluded?: number | null, included?: number | null, details?: Array<{ __typename?: 'BasketTaxeDetails', code?: string | null, included?: boolean | null, label?: string | null, onlinePayable?: boolean | null, refundable?: boolean | null } | null> | null } | null } | null, commission?: { __typename?: 'BasketCommission', amount?: number | null, currency?: string | null, percent?: number | null } | null };

export type BasketPaymentFragment = { __typename?: 'BasketPayment', type?: string | null, families?: Array<{ __typename?: 'BasketPaymentFamily', familyCode?: string | null, methods?: Array<{ __typename?: 'BasketPaymentFamilyMethod', code?: string | null, name?: string | null } | null> | null } | null> | null };

export type BasketPaymentFamilyFragment = { __typename?: 'BasketPaymentFamily', familyCode?: string | null, rank?: number | null, payment?: { __typename?: 'BasketFeesPayment', code?: string | null, amounts?: Array<{ __typename?: 'BasketFeesAmount', afterTax?: number | null, currency?: string | null, payAtTheHotel?: number | null, payOnline?: number | null, rank?: number | null, voucher?: number | null, fees?: { __typename?: 'BasketFees', amountAfterTax?: number | null, amountAtTheHotel?: number | null, amountOnline?: number | null, percent?: number | null } | null } | null> | null } | null };

export type BasketPeriodFragment = { __typename?: 'BasketPeriod', dateIn?: string | null, nights?: number | null };

export type BasketPriceDetailsFragment = { __typename?: 'BasketPriceDetails', afterTax?: number | null, hotelKeeper?: number | null, payAtTheHotel?: number | null, payOnline?: number | null, fees?: { __typename?: 'BasketTaxe', excluded?: number | null, included?: number | null, details?: Array<{ __typename?: 'BasketTaxeDetails', code?: string | null, included?: boolean | null, label?: string | null, onlinePayable?: boolean | null, refundable?: boolean | null } | null> | null } | null, otherTax?: { __typename?: 'BasketTaxe', excluded?: number | null, included?: number | null, details?: Array<{ __typename?: 'BasketTaxeDetails', code?: string | null, included?: boolean | null, label?: string | null, onlinePayable?: boolean | null, refundable?: boolean | null } | null> | null } | null, vat?: { __typename?: 'BasketTaxe', excluded?: number | null, included?: number | null, details?: Array<{ __typename?: 'BasketTaxeDetails', code?: string | null, included?: boolean | null, label?: string | null, onlinePayable?: boolean | null, refundable?: boolean | null } | null> | null } | null };

export type BasketProductFragment = { __typename?: 'BasketProduct', adults?: number | null, productCode?: string | null, purchasedOfferId?: string | null, quantity?: number | null, salesPoliciesUrls?: Array<string | null> | null, status?: string | null, title?: string | null, type?: string | null, childrenAges?: Array<number | null> | null, description?: string | null, id?: string | null, partnerCode?: string | null, paymentDate?: string | null, quotation?: { __typename?: 'BasketProductQuotation', id?: string | null, offerId?: string | null } | null, beneficiaries?: Array<{ __typename?: 'BasketBeneficiary', address1?: string | null, address2?: string | null, address3?: string | null, address4?: string | null, nationalityCode?: string | null, stateCode?: string | null, territoryCode?: string | null, zipcode?: string | null, city?: string | null, civilityCode: string, countryCode: string, email: string, firstName: string, firstNameNonLatin?: string | null, lastName: string, lastNameNonLatin?: string | null, phone?: { __typename?: 'Phone', number?: string | null, prefix?: string | null } | null, billing?: { __typename?: 'BasketBeneficiaryCompany', name?: string | null, vatNumber?: string | null } | null } | null> | null, period?: { __typename?: 'BasketProductPeriod', from?: string | null, to?: string | null } | null, price?: { __typename?: 'BasketProductPriceDetails', afterTax?: number | null, beforeTax?: number | null, currency?: string | null, payAtTheHotel?: number | null, payOnline?: number | null, totalTax?: number | null } | null };

export type BasketProductPriceDetailsFragment = { __typename?: 'BasketProductPriceDetails', afterTax?: number | null, beforeTax?: number | null, currency?: string | null, payAtTheHotel?: number | null, payOnline?: number | null, totalTax?: number | null };

export type BasketRoomFragment = { __typename?: 'BasketRoom', id?: string | null, adults?: number | null, childrenAges?: Array<number | null> | null, prepay?: boolean | null, productCode?: string | null, productLabel?: string | null, beneficiary?: { __typename?: 'BasketBeneficiary', address1?: string | null, address2?: string | null, address3?: string | null, address4?: string | null, nationalityCode?: string | null, stateCode?: string | null, territoryCode?: string | null, zipcode?: string | null, city?: string | null, civilityCode: string, countryCode: string, email: string, firstName: string, firstNameNonLatin?: string | null, lastName: string, lastNameNonLatin?: string | null, phone?: { __typename?: 'Phone', number?: string | null, prefix?: string | null } | null, billing?: { __typename?: 'BasketBeneficiaryCompany', name?: string | null, vatNumber?: string | null } | null } | null, offer?: { __typename?: 'BasketRoomOffer', code?: string | null, label?: string | null, averagePricing?: { __typename?: 'BasketOptionPricing', currency?: string | null, amount?: { __typename?: 'BasketPriceDetails', afterTax?: number | null, hotelKeeper?: number | null, payAtTheHotel?: number | null, payOnline?: number | null, fees?: { __typename?: 'BasketTaxe', excluded?: number | null, included?: number | null, details?: Array<{ __typename?: 'BasketTaxeDetails', code?: string | null, included?: boolean | null, label?: string | null, onlinePayable?: boolean | null, refundable?: boolean | null } | null> | null } | null, otherTax?: { __typename?: 'BasketTaxe', excluded?: number | null, included?: number | null, details?: Array<{ __typename?: 'BasketTaxeDetails', code?: string | null, included?: boolean | null, label?: string | null, onlinePayable?: boolean | null, refundable?: boolean | null } | null> | null } | null, vat?: { __typename?: 'BasketTaxe', excluded?: number | null, included?: number | null, details?: Array<{ __typename?: 'BasketTaxeDetails', code?: string | null, included?: boolean | null, label?: string | null, onlinePayable?: boolean | null, refundable?: boolean | null } | null> | null } | null } | null, commission?: { __typename?: 'BasketCommission', amount?: number | null, currency?: string | null, percent?: number | null } | null } | null, pricing?: { __typename?: 'BasketOptionPricing', currency?: string | null, amount?: { __typename?: 'BasketPriceDetails', afterTax?: number | null, hotelKeeper?: number | null, payAtTheHotel?: number | null, payOnline?: number | null, fees?: { __typename?: 'BasketTaxe', excluded?: number | null, included?: number | null, details?: Array<{ __typename?: 'BasketTaxeDetails', code?: string | null, included?: boolean | null, label?: string | null, onlinePayable?: boolean | null, refundable?: boolean | null } | null> | null } | null, otherTax?: { __typename?: 'BasketTaxe', excluded?: number | null, included?: number | null, details?: Array<{ __typename?: 'BasketTaxeDetails', code?: string | null, included?: boolean | null, label?: string | null, onlinePayable?: boolean | null, refundable?: boolean | null } | null> | null } | null, vat?: { __typename?: 'BasketTaxe', excluded?: number | null, included?: number | null, details?: Array<{ __typename?: 'BasketTaxeDetails', code?: string | null, included?: boolean | null, label?: string | null, onlinePayable?: boolean | null, refundable?: boolean | null } | null> | null } | null } | null, commission?: { __typename?: 'BasketCommission', amount?: number | null, currency?: string | null, percent?: number | null } | null } | null, referenceOffers?: Array<{ __typename?: 'BasketRoomReferenceOffer', categories?: Array<BasketRoomOfferCategoryCode | null> | null, code?: string | null, averagePricing?: { __typename?: 'BasketOptionPricing', currency?: string | null, amount?: { __typename?: 'BasketPriceDetails', afterTax?: number | null, hotelKeeper?: number | null, payAtTheHotel?: number | null, payOnline?: number | null, fees?: { __typename?: 'BasketTaxe', excluded?: number | null, included?: number | null, details?: Array<{ __typename?: 'BasketTaxeDetails', code?: string | null, included?: boolean | null, label?: string | null, onlinePayable?: boolean | null, refundable?: boolean | null } | null> | null } | null, otherTax?: { __typename?: 'BasketTaxe', excluded?: number | null, included?: number | null, details?: Array<{ __typename?: 'BasketTaxeDetails', code?: string | null, included?: boolean | null, label?: string | null, onlinePayable?: boolean | null, refundable?: boolean | null } | null> | null } | null, vat?: { __typename?: 'BasketTaxe', excluded?: number | null, included?: number | null, details?: Array<{ __typename?: 'BasketTaxeDetails', code?: string | null, included?: boolean | null, label?: string | null, onlinePayable?: boolean | null, refundable?: boolean | null } | null> | null } | null } | null, commission?: { __typename?: 'BasketCommission', amount?: number | null, currency?: string | null, percent?: number | null } | null } | null, pricing?: { __typename?: 'BasketOptionPricing', currency?: string | null, amount?: { __typename?: 'BasketPriceDetails', afterTax?: number | null, hotelKeeper?: number | null, payAtTheHotel?: number | null, payOnline?: number | null, fees?: { __typename?: 'BasketTaxe', excluded?: number | null, included?: number | null, details?: Array<{ __typename?: 'BasketTaxeDetails', code?: string | null, included?: boolean | null, label?: string | null, onlinePayable?: boolean | null, refundable?: boolean | null } | null> | null } | null, otherTax?: { __typename?: 'BasketTaxe', excluded?: number | null, included?: number | null, details?: Array<{ __typename?: 'BasketTaxeDetails', code?: string | null, included?: boolean | null, label?: string | null, onlinePayable?: boolean | null, refundable?: boolean | null } | null> | null } | null, vat?: { __typename?: 'BasketTaxe', excluded?: number | null, included?: number | null, details?: Array<{ __typename?: 'BasketTaxeDetails', code?: string | null, included?: boolean | null, label?: string | null, onlinePayable?: boolean | null, refundable?: boolean | null } | null> | null } | null } | null, commission?: { __typename?: 'BasketCommission', amount?: number | null, currency?: string | null, percent?: number | null } | null } | null } | null> | null, categories?: Array<{ __typename?: 'BasketRoomOfferCategory', code?: BasketRoomOfferCategoryCode | null, subCategories?: Array<string | null> | null } | null> | null, checkIn?: { __typename?: 'BasketRoomOfferCheckIn', availability?: BasketRoomOfferCheckInAvailability | null, available?: boolean | null, checkInSmsAvailable?: boolean | null, paymentDate?: string | null, price?: { __typename?: 'BasketAmount', amount: number, currency: string } | null } | null, concession?: { __typename?: 'BasketRoomOfferConcession', unit?: BasketRoomOfferConcessionUnit | null, value?: number | null } | null, deduction?: { __typename?: 'BasketRoomOfferDeduction', value?: number | null, reference?: { __typename?: 'BasketRoomOfferDeductionReference', deduction?: string | null, index?: number | null } | null } | null, flexibility?: { __typename?: 'BasketRoomOfferFlexibility', code?: BasketRoomOfferFlexibilityCode | null, label?: string | null, limitDate?: string | null, penalty?: { __typename?: 'BasketPenalty', night?: number | null, percent?: number | null, amount?: { __typename?: 'BasketAmount', amount: number, currency: string } | null } | null } | null, mealPlan?: { __typename?: 'BasketRoomOfferMealPlan', description?: string | null, status?: string | null, type?: BasketRoomOfferMealPlanType | null } | null, policies: Array<{ __typename?: 'BasketRoomOptionPolicy', code?: string | null, description?: string | null, label?: string | null, numberDayLimit?: number | null, metas?: Array<{ __typename?: 'BasketMetaInfo', key?: string | null, value?: string | null } | null> | null } | null> } | null, options: Array<{ __typename?: 'BasketRoomOption', code?: string | null, quantity?: number | null, remaining?: number | null, title?: string | null, type?: BasketRoomOptionType | null, warranted?: boolean | null, webExclusive?: boolean | null, description?: string | null, label?: string | null, maxQuantity?: number | null, perDay?: boolean | null, pricingUnit?: { __typename?: 'BasketRoomOptionPricingUnit', code?: BasketRoomOptionPricingUnitCode | null, label?: string | null } | null, unitaryPricing?: { __typename?: 'BasketRoomUnitaryPrice', afterTax?: number | null, beforeTax?: number | null, currency?: string | null, hotelKeeper?: number | null } | null, details?: Array<{ __typename?: 'BasketRoomOptionDetails', status?: BasketRoomOptionStatus | null, period?: { __typename?: 'BasketPeriod', dateIn?: string | null, nights?: number | null } | null, pricing?: { __typename?: 'BasketOptionPricing', currency?: string | null, amount?: { __typename?: 'BasketPriceDetails', afterTax?: number | null, hotelKeeper?: number | null, payAtTheHotel?: number | null, payOnline?: number | null, fees?: { __typename?: 'BasketTaxe', excluded?: number | null, included?: number | null, details?: Array<{ __typename?: 'BasketTaxeDetails', code?: string | null, included?: boolean | null, label?: string | null, onlinePayable?: boolean | null, refundable?: boolean | null } | null> | null } | null, otherTax?: { __typename?: 'BasketTaxe', excluded?: number | null, included?: number | null, details?: Array<{ __typename?: 'BasketTaxeDetails', code?: string | null, included?: boolean | null, label?: string | null, onlinePayable?: boolean | null, refundable?: boolean | null } | null> | null } | null, vat?: { __typename?: 'BasketTaxe', excluded?: number | null, included?: number | null, details?: Array<{ __typename?: 'BasketTaxeDetails', code?: string | null, included?: boolean | null, label?: string | null, onlinePayable?: boolean | null, refundable?: boolean | null } | null> | null } | null } | null, commission?: { __typename?: 'BasketCommission', amount?: number | null, currency?: string | null, percent?: number | null } | null } | null } | null> | null, medias: Array<{ __typename?: 'BasketRoomOptionMedia', category?: BasketRoomOptionMediaCategory | null, defaultMedium?: boolean | null, type?: BasketRoomOptionMediaType | null, sources?: Array<{ __typename?: 'BasketRoomOptionMediaSource', format?: string | null, url?: string | null } | null> | null } | null>, policies: Array<{ __typename?: 'BasketRoomOptionPolicy', code?: string | null, description?: string | null, label?: string | null, numberDayLimit?: number | null, metas?: Array<{ __typename?: 'BasketMetaInfo', key?: string | null, value?: string | null } | null> | null } | null>, prices?: { __typename?: 'BasketRoomOptionPrices', currency?: string | null, extraTax?: string | null, finalPrice?: string | null, price?: string | null } | null, pricing?: { __typename?: 'BasketOptionPricing', currency?: string | null, amount?: { __typename?: 'BasketPriceDetails', afterTax?: number | null, hotelKeeper?: number | null, payAtTheHotel?: number | null, payOnline?: number | null, fees?: { __typename?: 'BasketTaxe', excluded?: number | null, included?: number | null, details?: Array<{ __typename?: 'BasketTaxeDetails', code?: string | null, included?: boolean | null, label?: string | null, onlinePayable?: boolean | null, refundable?: boolean | null } | null> | null } | null, otherTax?: { __typename?: 'BasketTaxe', excluded?: number | null, included?: number | null, details?: Array<{ __typename?: 'BasketTaxeDetails', code?: string | null, included?: boolean | null, label?: string | null, onlinePayable?: boolean | null, refundable?: boolean | null } | null> | null } | null, vat?: { __typename?: 'BasketTaxe', excluded?: number | null, included?: number | null, details?: Array<{ __typename?: 'BasketTaxeDetails', code?: string | null, included?: boolean | null, label?: string | null, onlinePayable?: boolean | null, refundable?: boolean | null } | null> | null } | null } | null, commission?: { __typename?: 'BasketCommission', amount?: number | null, currency?: string | null, percent?: number | null } | null } | null } | null>, period?: { __typename?: 'BasketPeriod', dateIn?: string | null, nights?: number | null } | null };

export type BasketRoomOfferFragment = { __typename?: 'BasketRoomOffer', code?: string | null, label?: string | null, averagePricing?: { __typename?: 'BasketOptionPricing', currency?: string | null, amount?: { __typename?: 'BasketPriceDetails', afterTax?: number | null, hotelKeeper?: number | null, payAtTheHotel?: number | null, payOnline?: number | null, fees?: { __typename?: 'BasketTaxe', excluded?: number | null, included?: number | null, details?: Array<{ __typename?: 'BasketTaxeDetails', code?: string | null, included?: boolean | null, label?: string | null, onlinePayable?: boolean | null, refundable?: boolean | null } | null> | null } | null, otherTax?: { __typename?: 'BasketTaxe', excluded?: number | null, included?: number | null, details?: Array<{ __typename?: 'BasketTaxeDetails', code?: string | null, included?: boolean | null, label?: string | null, onlinePayable?: boolean | null, refundable?: boolean | null } | null> | null } | null, vat?: { __typename?: 'BasketTaxe', excluded?: number | null, included?: number | null, details?: Array<{ __typename?: 'BasketTaxeDetails', code?: string | null, included?: boolean | null, label?: string | null, onlinePayable?: boolean | null, refundable?: boolean | null } | null> | null } | null } | null, commission?: { __typename?: 'BasketCommission', amount?: number | null, currency?: string | null, percent?: number | null } | null } | null, pricing?: { __typename?: 'BasketOptionPricing', currency?: string | null, amount?: { __typename?: 'BasketPriceDetails', afterTax?: number | null, hotelKeeper?: number | null, payAtTheHotel?: number | null, payOnline?: number | null, fees?: { __typename?: 'BasketTaxe', excluded?: number | null, included?: number | null, details?: Array<{ __typename?: 'BasketTaxeDetails', code?: string | null, included?: boolean | null, label?: string | null, onlinePayable?: boolean | null, refundable?: boolean | null } | null> | null } | null, otherTax?: { __typename?: 'BasketTaxe', excluded?: number | null, included?: number | null, details?: Array<{ __typename?: 'BasketTaxeDetails', code?: string | null, included?: boolean | null, label?: string | null, onlinePayable?: boolean | null, refundable?: boolean | null } | null> | null } | null, vat?: { __typename?: 'BasketTaxe', excluded?: number | null, included?: number | null, details?: Array<{ __typename?: 'BasketTaxeDetails', code?: string | null, included?: boolean | null, label?: string | null, onlinePayable?: boolean | null, refundable?: boolean | null } | null> | null } | null } | null, commission?: { __typename?: 'BasketCommission', amount?: number | null, currency?: string | null, percent?: number | null } | null } | null, referenceOffers?: Array<{ __typename?: 'BasketRoomReferenceOffer', categories?: Array<BasketRoomOfferCategoryCode | null> | null, code?: string | null, averagePricing?: { __typename?: 'BasketOptionPricing', currency?: string | null, amount?: { __typename?: 'BasketPriceDetails', afterTax?: number | null, hotelKeeper?: number | null, payAtTheHotel?: number | null, payOnline?: number | null, fees?: { __typename?: 'BasketTaxe', excluded?: number | null, included?: number | null, details?: Array<{ __typename?: 'BasketTaxeDetails', code?: string | null, included?: boolean | null, label?: string | null, onlinePayable?: boolean | null, refundable?: boolean | null } | null> | null } | null, otherTax?: { __typename?: 'BasketTaxe', excluded?: number | null, included?: number | null, details?: Array<{ __typename?: 'BasketTaxeDetails', code?: string | null, included?: boolean | null, label?: string | null, onlinePayable?: boolean | null, refundable?: boolean | null } | null> | null } | null, vat?: { __typename?: 'BasketTaxe', excluded?: number | null, included?: number | null, details?: Array<{ __typename?: 'BasketTaxeDetails', code?: string | null, included?: boolean | null, label?: string | null, onlinePayable?: boolean | null, refundable?: boolean | null } | null> | null } | null } | null, commission?: { __typename?: 'BasketCommission', amount?: number | null, currency?: string | null, percent?: number | null } | null } | null, pricing?: { __typename?: 'BasketOptionPricing', currency?: string | null, amount?: { __typename?: 'BasketPriceDetails', afterTax?: number | null, hotelKeeper?: number | null, payAtTheHotel?: number | null, payOnline?: number | null, fees?: { __typename?: 'BasketTaxe', excluded?: number | null, included?: number | null, details?: Array<{ __typename?: 'BasketTaxeDetails', code?: string | null, included?: boolean | null, label?: string | null, onlinePayable?: boolean | null, refundable?: boolean | null } | null> | null } | null, otherTax?: { __typename?: 'BasketTaxe', excluded?: number | null, included?: number | null, details?: Array<{ __typename?: 'BasketTaxeDetails', code?: string | null, included?: boolean | null, label?: string | null, onlinePayable?: boolean | null, refundable?: boolean | null } | null> | null } | null, vat?: { __typename?: 'BasketTaxe', excluded?: number | null, included?: number | null, details?: Array<{ __typename?: 'BasketTaxeDetails', code?: string | null, included?: boolean | null, label?: string | null, onlinePayable?: boolean | null, refundable?: boolean | null } | null> | null } | null } | null, commission?: { __typename?: 'BasketCommission', amount?: number | null, currency?: string | null, percent?: number | null } | null } | null } | null> | null, categories?: Array<{ __typename?: 'BasketRoomOfferCategory', code?: BasketRoomOfferCategoryCode | null, subCategories?: Array<string | null> | null } | null> | null, checkIn?: { __typename?: 'BasketRoomOfferCheckIn', availability?: BasketRoomOfferCheckInAvailability | null, available?: boolean | null, checkInSmsAvailable?: boolean | null, paymentDate?: string | null, price?: { __typename?: 'BasketAmount', amount: number, currency: string } | null } | null, concession?: { __typename?: 'BasketRoomOfferConcession', unit?: BasketRoomOfferConcessionUnit | null, value?: number | null } | null, deduction?: { __typename?: 'BasketRoomOfferDeduction', value?: number | null, reference?: { __typename?: 'BasketRoomOfferDeductionReference', deduction?: string | null, index?: number | null } | null } | null, flexibility?: { __typename?: 'BasketRoomOfferFlexibility', code?: BasketRoomOfferFlexibilityCode | null, label?: string | null, limitDate?: string | null, penalty?: { __typename?: 'BasketPenalty', night?: number | null, percent?: number | null, amount?: { __typename?: 'BasketAmount', amount: number, currency: string } | null } | null } | null, mealPlan?: { __typename?: 'BasketRoomOfferMealPlan', description?: string | null, status?: string | null, type?: BasketRoomOfferMealPlanType | null } | null, policies: Array<{ __typename?: 'BasketRoomOptionPolicy', code?: string | null, description?: string | null, label?: string | null, numberDayLimit?: number | null, metas?: Array<{ __typename?: 'BasketMetaInfo', key?: string | null, value?: string | null } | null> | null } | null> };

export type BasketRoomOptionFragment = { __typename?: 'BasketRoomOption', code?: string | null, quantity?: number | null, remaining?: number | null, title?: string | null, type?: BasketRoomOptionType | null, warranted?: boolean | null, webExclusive?: boolean | null, description?: string | null, label?: string | null, maxQuantity?: number | null, perDay?: boolean | null, pricingUnit?: { __typename?: 'BasketRoomOptionPricingUnit', code?: BasketRoomOptionPricingUnitCode | null, label?: string | null } | null, unitaryPricing?: { __typename?: 'BasketRoomUnitaryPrice', afterTax?: number | null, beforeTax?: number | null, currency?: string | null, hotelKeeper?: number | null } | null, details?: Array<{ __typename?: 'BasketRoomOptionDetails', status?: BasketRoomOptionStatus | null, period?: { __typename?: 'BasketPeriod', dateIn?: string | null, nights?: number | null } | null, pricing?: { __typename?: 'BasketOptionPricing', currency?: string | null, amount?: { __typename?: 'BasketPriceDetails', afterTax?: number | null, hotelKeeper?: number | null, payAtTheHotel?: number | null, payOnline?: number | null, fees?: { __typename?: 'BasketTaxe', excluded?: number | null, included?: number | null, details?: Array<{ __typename?: 'BasketTaxeDetails', code?: string | null, included?: boolean | null, label?: string | null, onlinePayable?: boolean | null, refundable?: boolean | null } | null> | null } | null, otherTax?: { __typename?: 'BasketTaxe', excluded?: number | null, included?: number | null, details?: Array<{ __typename?: 'BasketTaxeDetails', code?: string | null, included?: boolean | null, label?: string | null, onlinePayable?: boolean | null, refundable?: boolean | null } | null> | null } | null, vat?: { __typename?: 'BasketTaxe', excluded?: number | null, included?: number | null, details?: Array<{ __typename?: 'BasketTaxeDetails', code?: string | null, included?: boolean | null, label?: string | null, onlinePayable?: boolean | null, refundable?: boolean | null } | null> | null } | null } | null, commission?: { __typename?: 'BasketCommission', amount?: number | null, currency?: string | null, percent?: number | null } | null } | null } | null> | null, medias: Array<{ __typename?: 'BasketRoomOptionMedia', category?: BasketRoomOptionMediaCategory | null, defaultMedium?: boolean | null, type?: BasketRoomOptionMediaType | null, sources?: Array<{ __typename?: 'BasketRoomOptionMediaSource', format?: string | null, url?: string | null } | null> | null } | null>, policies: Array<{ __typename?: 'BasketRoomOptionPolicy', code?: string | null, description?: string | null, label?: string | null, numberDayLimit?: number | null, metas?: Array<{ __typename?: 'BasketMetaInfo', key?: string | null, value?: string | null } | null> | null } | null>, prices?: { __typename?: 'BasketRoomOptionPrices', currency?: string | null, extraTax?: string | null, finalPrice?: string | null, price?: string | null } | null, pricing?: { __typename?: 'BasketOptionPricing', currency?: string | null, amount?: { __typename?: 'BasketPriceDetails', afterTax?: number | null, hotelKeeper?: number | null, payAtTheHotel?: number | null, payOnline?: number | null, fees?: { __typename?: 'BasketTaxe', excluded?: number | null, included?: number | null, details?: Array<{ __typename?: 'BasketTaxeDetails', code?: string | null, included?: boolean | null, label?: string | null, onlinePayable?: boolean | null, refundable?: boolean | null } | null> | null } | null, otherTax?: { __typename?: 'BasketTaxe', excluded?: number | null, included?: number | null, details?: Array<{ __typename?: 'BasketTaxeDetails', code?: string | null, included?: boolean | null, label?: string | null, onlinePayable?: boolean | null, refundable?: boolean | null } | null> | null } | null, vat?: { __typename?: 'BasketTaxe', excluded?: number | null, included?: number | null, details?: Array<{ __typename?: 'BasketTaxeDetails', code?: string | null, included?: boolean | null, label?: string | null, onlinePayable?: boolean | null, refundable?: boolean | null } | null> | null } | null } | null, commission?: { __typename?: 'BasketCommission', amount?: number | null, currency?: string | null, percent?: number | null } | null } | null };

export type BasketRoomOptionPolicyFragment = { __typename?: 'BasketRoomOptionPolicy', code?: string | null, description?: string | null, label?: string | null, numberDayLimit?: number | null, metas?: Array<{ __typename?: 'BasketMetaInfo', key?: string | null, value?: string | null } | null> | null };

export type BasketTaxeFragment = { __typename?: 'BasketTaxe', excluded?: number | null, included?: number | null, details?: Array<{ __typename?: 'BasketTaxeDetails', code?: string | null, included?: boolean | null, label?: string | null, onlinePayable?: boolean | null, refundable?: boolean | null } | null> | null };

export type BasketVoucherFragment = { __typename?: 'BasketVoucher', points: number, price: { __typename?: 'BasketAmount', amount: number, currency: string }, detail: Array<{ __typename?: 'BasketVoucherDetail', points: number, roomId: string, price: { __typename?: 'BasketAmount', amount: number, currency: string } }> };

export type AvailabilityRoomFragment = { __typename?: 'AvailabilityRoom', code?: string | null, offers?: Array<{ __typename?: 'RoomOffers', code?: string | null, label?: string | null, description?: string | null, mealPlanDescription?: string | null, mealPlan?: string | null, prepay?: boolean | null, burnPointAvailable?: boolean | null, pricing?: { __typename?: 'Pricing', currency?: string | null, amount?: { __typename?: 'Amount', hotelKeeper?: number | null, afterTax?: number | null, otherTax?: { __typename?: 'OtherTax', amount?: { __typename?: 'AmountValue', excluded?: number | null } | null } | null, vat?: { __typename?: 'Vat', amount?: { __typename?: 'AmountValue', excluded?: number | null } | null } | null, fees?: { __typename?: 'Fees', amount?: { __typename?: 'AmountValue', excluded?: number | null } | null } | null } | null } | null, categories?: Array<{ __typename?: 'Categories', code?: string | null } | null> | null, flexibility?: { __typename?: 'Flexibility', code?: string | null, label?: string | null, limitDate?: string | null } | null, package?: { __typename?: 'RoomOfferPackage', type?: string | null } | null } | null> | null, commercialOffers?: Array<{ __typename?: 'CommercialOffer', main?: { __typename?: 'Offer', index?: number | null, deduction?: { __typename?: 'Deduction', value?: number | null } | null } | null } | null> | null };

export type BookingBasketFragment = { __typename?: 'Basket', id: string, hotelId?: string | null, prices?: { __typename?: 'BasketPrice', currency?: string | null, details?: { __typename?: 'BasketPriceDetails', afterTax?: number | null, payOnline?: number | null, payAtTheHotel?: number | null, hotelKeeper?: number | null, vat?: { __typename?: 'BasketTaxe', excluded?: number | null } | null } | null } | null, hotel?: { __typename?: 'BasketHotel', billingAddressMandatory?: boolean | null } | null, rooms?: Array<{ __typename?: 'BasketRoom', id?: string | null, adults?: number | null, productCode?: string | null, offer?: { __typename?: 'BasketRoomOffer', label?: string | null, code?: string | null, flexibility?: { __typename?: 'BasketRoomOfferFlexibility', limitDate?: string | null, code?: BasketRoomOfferFlexibilityCode | null } | null, pricing?: { __typename?: 'BasketOptionPricing', amount?: { __typename?: 'BasketPriceDetails', afterTax?: number | null, otherTax?: { __typename?: 'BasketTaxe', excluded?: number | null } | null, vat?: { __typename?: 'BasketTaxe', excluded?: number | null } | null, fees?: { __typename?: 'BasketTaxe', excluded?: number | null } | null } | null } | null } | null, period?: { __typename?: 'BasketPeriod', dateIn?: string | null, nights?: number | null } | null, beneficiary?: { __typename?: 'BasketBeneficiary', civilityCode: string, nationalityCode?: string | null, firstName: string, lastName: string, email: string, address1?: string | null, address2?: string | null, address3?: string | null, address4?: string | null, zipcode?: string | null, city?: string | null, countryCode: string, stateCode?: string | null, territoryCode?: string | null, phone?: { __typename?: 'Phone', prefix?: string | null, number?: string | null } | null } | null, options: Array<{ __typename?: 'BasketRoomOption', code?: string | null, quantity?: number | null } | null> } | null> | null, payment?: { __typename?: 'BasketPayment', type?: string | null, families?: Array<{ __typename?: 'BasketPaymentFamily', familyCode?: string | null, methods?: Array<{ __typename?: 'BasketPaymentFamilyMethod', code?: string | null, name?: string | null, paymentChannel?: string | null } | null> | null } | null> | null } | null, vouchers?: Array<{ __typename?: 'BasketVoucher', points: number, price: { __typename?: 'BasketAmount', amount: number, currency: string } }> | null, policies?: { __typename?: 'BasketPolicies', isBillingAddressMandatory: boolean } | null, warrantyPolicies?: { __typename?: 'BasketWarrantyPolicies', checkInLimitHour?: string | null } | null };

export type VoucherWithoutDetailFragment = { __typename?: 'BasketVoucher', points: number, price: { __typename?: 'BasketAmount', amount: number, currency: string } };

export type SpecialOfferPackageFragment = { __typename?: 'OfferAndPackage', id: string, title?: string | null, description?: string | null, sectionTitle?: string | null, detailLink?: string | null, picture?: { __typename?: 'AiPicture', id?: string | null, src?: string | null, srcSet?: string | null, alt?: string | null } | null };

export type CreateBasketMutationVariables = Exact<{
  hotelCode: Scalars['ID']['input'];
  rooms: Array<BasketRoomPayload> | BasketRoomPayload;
}>;


export type CreateBasketMutation = { __typename?: 'Mutation', createBasket?: { __typename?: 'Basket', id: string, hotelId?: string | null, prices?: { __typename?: 'BasketPrice', currency?: string | null, details?: { __typename?: 'BasketPriceDetails', afterTax?: number | null, payOnline?: number | null, payAtTheHotel?: number | null, hotelKeeper?: number | null, vat?: { __typename?: 'BasketTaxe', excluded?: number | null } | null } | null } | null, hotel?: { __typename?: 'BasketHotel', billingAddressMandatory?: boolean | null } | null, rooms?: Array<{ __typename?: 'BasketRoom', id?: string | null, adults?: number | null, productCode?: string | null, offer?: { __typename?: 'BasketRoomOffer', label?: string | null, code?: string | null, flexibility?: { __typename?: 'BasketRoomOfferFlexibility', limitDate?: string | null, code?: BasketRoomOfferFlexibilityCode | null } | null, pricing?: { __typename?: 'BasketOptionPricing', amount?: { __typename?: 'BasketPriceDetails', afterTax?: number | null, otherTax?: { __typename?: 'BasketTaxe', excluded?: number | null } | null, vat?: { __typename?: 'BasketTaxe', excluded?: number | null } | null, fees?: { __typename?: 'BasketTaxe', excluded?: number | null } | null } | null } | null } | null, period?: { __typename?: 'BasketPeriod', dateIn?: string | null, nights?: number | null } | null, beneficiary?: { __typename?: 'BasketBeneficiary', civilityCode: string, nationalityCode?: string | null, firstName: string, lastName: string, email: string, address1?: string | null, address2?: string | null, address3?: string | null, address4?: string | null, zipcode?: string | null, city?: string | null, countryCode: string, stateCode?: string | null, territoryCode?: string | null, phone?: { __typename?: 'Phone', prefix?: string | null, number?: string | null } | null } | null, options: Array<{ __typename?: 'BasketRoomOption', code?: string | null, quantity?: number | null } | null> } | null> | null, payment?: { __typename?: 'BasketPayment', type?: string | null, families?: Array<{ __typename?: 'BasketPaymentFamily', familyCode?: string | null, methods?: Array<{ __typename?: 'BasketPaymentFamilyMethod', code?: string | null, name?: string | null, paymentChannel?: string | null } | null> | null } | null> | null } | null, vouchers?: Array<{ __typename?: 'BasketVoucher', points: number, price: { __typename?: 'BasketAmount', amount: number, currency: string } }> | null, policies?: { __typename?: 'BasketPolicies', isBillingAddressMandatory: boolean } | null, warrantyPolicies?: { __typename?: 'BasketWarrantyPolicies', checkInLimitHour?: string | null } | null } | null };

export type PerformBookingMutationVariables = Exact<{
  payload?: InputMaybe<PerformBookingPayload>;
}>;


export type PerformBookingMutation = { __typename?: 'Mutation', continueToPayment?: { __typename?: 'PerformBookingResponse', bookingId?: string | null, payment?: { __typename?: 'PerformBookingPaymentResponse', status?: string | null, provider?: { __typename?: 'PerformBookingPaymentProviderResponse', redirectUrl?: string | null } | null } | null, responseStatus?: { __typename?: 'PerformBookingResponseStatusResponse', bookingStatus?: string | null } | null } | null };

export type UpdateBasketMutationVariables = Exact<{
  hotelCode: Scalars['ID']['input'];
  basketId: Scalars['ID']['input'];
  rooms: Array<BasketRoomPayload> | BasketRoomPayload;
}>;


export type UpdateBasketMutation = { __typename?: 'Mutation', updateBasket?: { __typename?: 'Basket', id: string, hotelId?: string | null, prices?: { __typename?: 'BasketPrice', currency?: string | null, details?: { __typename?: 'BasketPriceDetails', afterTax?: number | null, payOnline?: number | null, payAtTheHotel?: number | null, hotelKeeper?: number | null, vat?: { __typename?: 'BasketTaxe', excluded?: number | null } | null } | null } | null, hotel?: { __typename?: 'BasketHotel', billingAddressMandatory?: boolean | null } | null, rooms?: Array<{ __typename?: 'BasketRoom', id?: string | null, adults?: number | null, productCode?: string | null, offer?: { __typename?: 'BasketRoomOffer', label?: string | null, code?: string | null, flexibility?: { __typename?: 'BasketRoomOfferFlexibility', limitDate?: string | null, code?: BasketRoomOfferFlexibilityCode | null } | null, pricing?: { __typename?: 'BasketOptionPricing', amount?: { __typename?: 'BasketPriceDetails', afterTax?: number | null, otherTax?: { __typename?: 'BasketTaxe', excluded?: number | null } | null, vat?: { __typename?: 'BasketTaxe', excluded?: number | null } | null, fees?: { __typename?: 'BasketTaxe', excluded?: number | null } | null } | null } | null } | null, period?: { __typename?: 'BasketPeriod', dateIn?: string | null, nights?: number | null } | null, beneficiary?: { __typename?: 'BasketBeneficiary', civilityCode: string, nationalityCode?: string | null, firstName: string, lastName: string, email: string, address1?: string | null, address2?: string | null, address3?: string | null, address4?: string | null, zipcode?: string | null, city?: string | null, countryCode: string, stateCode?: string | null, territoryCode?: string | null, phone?: { __typename?: 'Phone', prefix?: string | null, number?: string | null } | null } | null, options: Array<{ __typename?: 'BasketRoomOption', code?: string | null, quantity?: number | null } | null> } | null> | null, payment?: { __typename?: 'BasketPayment', type?: string | null, families?: Array<{ __typename?: 'BasketPaymentFamily', familyCode?: string | null, methods?: Array<{ __typename?: 'BasketPaymentFamilyMethod', code?: string | null, name?: string | null, paymentChannel?: string | null } | null> | null } | null> | null } | null, vouchers?: Array<{ __typename?: 'BasketVoucher', points: number, price: { __typename?: 'BasketAmount', amount: number, currency: string } }> | null, policies?: { __typename?: 'BasketPolicies', isBillingAddressMandatory: boolean } | null, warrantyPolicies?: { __typename?: 'BasketWarrantyPolicies', checkInLimitHour?: string | null } | null } | null };

export type IdentificationPlainTextQueryVariables = Exact<{
  accessCode?: InputMaybe<Scalars['String']['input']>;
  cardNumber?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['String']['input']>;
  preferentialCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type IdentificationPlainTextQuery = { __typename?: 'Query', identificationPlainText?: { __typename?: 'IdentificationPlainText', identification?: { __typename?: 'Identification', identificationId?: string | null } | null } | null };

export type AccountEligibilityQueryVariables = Exact<{
  email?: InputMaybe<Scalars['String']['input']>;
}>;


export type AccountEligibilityQuery = { __typename?: 'Query', accountEligibility?: { __typename?: 'EligibilityResponse', codeSent?: boolean | null, contactType?: string | null } | null };

export type AmenitiesQueryVariables = Exact<{ [key: string]: never; }>;


export type AmenitiesQuery = { __typename?: 'Query', amenities: Array<{ __typename?: 'Amenity', code?: string | null, label?: string | null }> };

export type AvailableRoomEnhancementOptionsQueryVariables = Exact<{
  hotelCode: Scalars['ID']['input'];
  rooms: Array<InputMaybe<SelectedRoom>> | InputMaybe<SelectedRoom>;
}>;


export type AvailableRoomEnhancementOptionsQuery = { __typename?: 'Query', availableRoomEnhancementOptions?: Array<{ __typename?: 'RoomEnhancementOptions', productCode: string, offerCode: string, option: Array<{ __typename?: 'RoomEnhancementOption', code?: string | null, label: string, maxQuantity: number, description?: string | null, type?: string | null, warranted?: boolean | null, pricing: { __typename?: 'EnhancementOptionPricing', currency: string, amount: { __typename?: 'EnhancementOptionPricingAmount', hotelKeeper: number, afterTax?: number | null, otherTax?: { __typename?: 'OtherTax', amount?: { __typename?: 'AmountValue', excluded?: number | null } | null } | null } }, pricingUnit?: { __typename?: 'EnhancementOptionPricingUnit', label: string } | null, media?: Array<{ __typename?: 'AccorMedia', formats?: Array<{ __typename?: 'AccorMediaFormat', path: string, format?: string | null } | null> | null } | null> | null, policy?: Array<{ __typename?: 'EnhancementOptionPolicy', code?: string | null, description?: string | null } | null> | null, detail?: Array<{ __typename?: 'EnhancementOptionDetail', pricing?: { __typename?: 'Pricing', currency?: string | null, amount?: { __typename?: 'Amount', hotelKeeper?: number | null, afterTax?: number | null } | null } | null, period?: { __typename?: 'SelectedPeriod', dateIn?: string | null } | null } | null> | null, tax?: Array<{ __typename?: 'RoomEnhancementOptionTax', label?: string | null } | null> | null }> } | null> | null };

export type AvailableRoomsQueryVariables = Exact<{
  hotelId: Scalars['ID']['input'];
  dateIn: Scalars['Date']['input'];
  nights: Scalars['Int']['input'];
  adults: Scalars['Int']['input'];
  childrenAges?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
}>;


export type AvailableRoomsQuery = { __typename?: 'Query', availableRooms?: Array<{ __typename?: 'AvailableRoom', accommodationRoom?: { __typename?: 'Accommodation', topAmenities?: Array<string | null> | null, description?: string | null, extendedStay?: boolean | null, id?: string | null, label?: string | null, shortLabel?: string | null, spacialViewLink?: string | null, amenities?: Array<{ __typename?: 'AccommodationAmenity', label?: string | null, name?: string | null, amenities?: Array<{ __typename?: 'AccommodationAmenityItem', value?: string | null } | null> | null, facilities?: Array<{ __typename?: 'AccommodationFacility', label?: string | null, name?: string | null, items?: Array<{ __typename?: 'AccommodationItem', code?: string | null, name?: string | null, paying?: boolean | null } | null> | null } | null> | null } | null> | null, surface?: { __typename?: 'AccommodationSurface', squareFeet?: number | null, squareMeter?: number | null } | null, classification?: { __typename?: 'AccommodationClassification', standard?: string | null, type?: string | null } | null, configuration?: Array<{ __typename?: 'AccommodationConfiguration', assets?: Array<any | null> | null, beddings?: { __typename?: 'AccommodationBeddings', details?: Array<any | null> | null, doubleBed?: number | null, singleBed?: number | null, qualified: Array<{ __typename?: 'AccommodationBeddingsQualified', label?: string | null, quantity?: number | null, type?: string | null } | null>, extra?: { __typename?: 'AccommodationExtra', adultBed?: boolean | null, childBed?: boolean | null, crib?: boolean | null } | null } | null, maxOccupancy?: { __typename?: 'AccommodationMaxOccupancy', adult?: number | null, children?: number | null, maxChildAge?: number | null, pax?: number | null } | null, situation?: { __typename?: 'AccommodationSituation', accessibility?: boolean | null, views?: Array<string | null> | null } | null } | null> | null, floorSpace?: { __typename?: 'AccommodationFloorSpace', unit?: string | null, value?: number | null } | null, medias?: { __typename?: 'AccommodationMedias', total?: number | null, photos?: Array<{ __typename?: 'AiPicture', id?: string | null, alt?: string | null, src?: string | null, srcSet?: string | null } | null> | null } | null } | null, availabilityRoom?: { __typename?: 'AvailabilityRoom', code?: string | null, offers?: Array<{ __typename?: 'RoomOffers', code?: string | null, label?: string | null, description?: string | null, mealPlanDescription?: string | null, mealPlan?: string | null, prepay?: boolean | null, burnPointAvailable?: boolean | null, pricing?: { __typename?: 'Pricing', currency?: string | null, amount?: { __typename?: 'Amount', hotelKeeper?: number | null, afterTax?: number | null, otherTax?: { __typename?: 'OtherTax', amount?: { __typename?: 'AmountValue', excluded?: number | null } | null } | null, vat?: { __typename?: 'Vat', amount?: { __typename?: 'AmountValue', excluded?: number | null } | null } | null, fees?: { __typename?: 'Fees', amount?: { __typename?: 'AmountValue', excluded?: number | null } | null } | null } | null } | null, categories?: Array<{ __typename?: 'Categories', code?: string | null } | null> | null, flexibility?: { __typename?: 'Flexibility', code?: string | null, label?: string | null, limitDate?: string | null } | null, package?: { __typename?: 'RoomOfferPackage', type?: string | null } | null } | null> | null, commercialOffers?: Array<{ __typename?: 'CommercialOffer', main?: { __typename?: 'Offer', index?: number | null, deduction?: { __typename?: 'Deduction', value?: number | null } | null } | null } | null> | null } | null } | null> | null };

export type BasketQueryVariables = Exact<{
  basketId: Scalars['ID']['input'];
}>;


export type BasketQuery = { __typename?: 'Query', basket?: { __typename?: 'Basket', id: string, hotelId?: string | null, prices?: { __typename?: 'BasketPrice', currency?: string | null, details?: { __typename?: 'BasketPriceDetails', afterTax?: number | null, payOnline?: number | null, payAtTheHotel?: number | null, hotelKeeper?: number | null, vat?: { __typename?: 'BasketTaxe', excluded?: number | null } | null } | null } | null, hotel?: { __typename?: 'BasketHotel', billingAddressMandatory?: boolean | null } | null, rooms?: Array<{ __typename?: 'BasketRoom', id?: string | null, adults?: number | null, productCode?: string | null, offer?: { __typename?: 'BasketRoomOffer', label?: string | null, code?: string | null, flexibility?: { __typename?: 'BasketRoomOfferFlexibility', limitDate?: string | null, code?: BasketRoomOfferFlexibilityCode | null } | null, pricing?: { __typename?: 'BasketOptionPricing', amount?: { __typename?: 'BasketPriceDetails', afterTax?: number | null, otherTax?: { __typename?: 'BasketTaxe', excluded?: number | null } | null, vat?: { __typename?: 'BasketTaxe', excluded?: number | null } | null, fees?: { __typename?: 'BasketTaxe', excluded?: number | null } | null } | null } | null } | null, period?: { __typename?: 'BasketPeriod', dateIn?: string | null, nights?: number | null } | null, beneficiary?: { __typename?: 'BasketBeneficiary', civilityCode: string, nationalityCode?: string | null, firstName: string, lastName: string, email: string, address1?: string | null, address2?: string | null, address3?: string | null, address4?: string | null, zipcode?: string | null, city?: string | null, countryCode: string, stateCode?: string | null, territoryCode?: string | null, phone?: { __typename?: 'Phone', prefix?: string | null, number?: string | null } | null } | null, options: Array<{ __typename?: 'BasketRoomOption', code?: string | null, quantity?: number | null } | null> } | null> | null, payment?: { __typename?: 'BasketPayment', type?: string | null, families?: Array<{ __typename?: 'BasketPaymentFamily', familyCode?: string | null, methods?: Array<{ __typename?: 'BasketPaymentFamilyMethod', code?: string | null, name?: string | null, paymentChannel?: string | null } | null> | null } | null> | null } | null, vouchers?: Array<{ __typename?: 'BasketVoucher', points: number, price: { __typename?: 'BasketAmount', amount: number, currency: string } }> | null, policies?: { __typename?: 'BasketPolicies', isBillingAddressMandatory: boolean } | null, warrantyPolicies?: { __typename?: 'BasketWarrantyPolicies', checkInLimitHour?: string | null } | null } | null };

export type BestOfferQueryVariables = Exact<{
  hotelCode: Scalars['ID']['input'];
  dateIn: Scalars['String']['input'];
  nights: Scalars['Int']['input'];
  adults: Scalars['Int']['input'];
  childrenAges?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
}>;


export type BestOfferQuery = { __typename?: 'Query', bestOffer: { __typename?: 'BestOffer', empty: boolean, currency?: string | null, price?: { __typename?: 'BestOfferPrice', afterTax?: number | null, hotelKeeper?: number | null } | null } };

export type BookingQueryVariables = Exact<{
  bookingId: Scalars['ID']['input'];
}>;


export type BookingQuery = { __typename?: 'Query', booking?: { __typename?: 'Booking', id?: string | null, number?: string | null, hotel?: { __typename?: 'BookingHotel', code?: string | null, name?: string | null } | null, benefits?: { __typename?: 'BookingHotelBenefits', voucher?: { __typename?: 'BookingHotelBenefitsVoucher', points?: number | null, price?: { __typename?: 'BookingHotelBenefitsVoucherPrice', amount?: number | null, currency?: string | null } | null } | null } | null, pricing?: { __typename?: 'BookingHotelPricing', currency?: string | null, amount?: { __typename?: 'CommonPricingAmount', afterTax?: number | null, payAtTheHotel?: number | null, payOnline?: number | null, vat?: { __typename?: 'CommonTaxPricing', amount?: { __typename?: 'CommonTaxPricingAmount', excluded?: number | null } | null } | null } | null } | null, item?: Array<{ __typename?: 'BookingHotelItem', id?: string | null, detail?: { __typename?: 'BookingHotelItemDetail', adults?: number | null, children?: number | null, date?: string | null, nights?: number | null } | null, room?: { __typename?: 'BookingHotelItemRoom', code?: string | null, label?: string | null, policies?: Array<{ __typename?: 'BookingHotelItemRoomPolicies', label?: string | null, description?: string | null } | null> | null, offer?: { __typename?: 'BookingHotelItemRoomOffer', code?: string | null, label?: string | null, pricing?: { __typename?: 'BookingHotemItemRoomOfferPricing', amount?: { __typename?: 'CommonPricingAmount', hotelKeeper?: number | null, afterTax?: number | null } | null } | null } | null } | null, option?: Array<{ __typename?: 'BookingHotelItemOption', code?: string | null, label?: string | null, pricing?: { __typename?: 'BookingHotelItemOptionPricing', currency?: string | null, amount?: { __typename?: 'CommonPricingAmount', hotelKeeper?: number | null, vat?: { __typename?: 'CommonTaxPricing', amount?: { __typename?: 'CommonTaxPricingAmount', excluded?: number | null } | null } | null, fees?: { __typename?: 'CommonTaxPricing', amount?: { __typename?: 'CommonTaxPricingAmount', excluded?: number | null } | null } | null, otherTax?: { __typename?: 'CommonTaxPricing', amount?: { __typename?: 'CommonTaxPricingAmount', excluded?: number | null } | null } | null } | null } | null } | null> | null, pricing?: { __typename?: 'BookingHotelItemPricing', currency?: string | null, amount?: { __typename?: 'CommonPricingAmount', afterTax?: number | null, fees?: { __typename?: 'CommonTaxPricing', amount?: { __typename?: 'CommonTaxPricingAmount', excluded?: number | null } | null } | null, vat?: { __typename?: 'CommonTaxPricing', amount?: { __typename?: 'CommonTaxPricingAmount', excluded?: number | null } | null } | null, otherTax?: { __typename?: 'CommonTaxPricing', amount?: { __typename?: 'CommonTaxPricingAmount', excluded?: number | null } | null } | null } | null } | null, participant?: { __typename?: 'BookingHotelItemParticipant', reservee?: { __typename?: 'ParticipantReservee', firstName?: string | null, lastName?: string | null, mail?: string | null, civility?: string | null } | null } | null, payment?: { __typename?: 'BookingHotelItemPayment', paymentResponseType?: { __typename?: 'BookingHotelItemPaymentResponseType', cardType?: string | null } | null } | null } | null> | null } | null };

export type BookingSeoQueryVariables = Exact<{ [key: string]: never; }>;


export type BookingSeoQuery = { __typename?: 'Query', bookingSeo?: { __typename?: 'BookingSeoMetadata', room?: { __typename?: 'SeoMetadata', description?: string | null, ogDescription?: string | null, ogTitle?: string | null, title?: string | null, ogImage?: { __typename?: 'AiPicture', alt?: string | null, id?: string | null, src?: string | null, srcSet?: string | null } | null } | null, rate?: { __typename?: 'SeoMetadata', description?: string | null, ogDescription?: string | null, ogTitle?: string | null, title?: string | null, ogImage?: { __typename?: 'AiPicture', alt?: string | null, id?: string | null, src?: string | null, srcSet?: string | null } | null } | null, details?: { __typename?: 'SeoMetadata', description?: string | null, ogDescription?: string | null, ogTitle?: string | null, title?: string | null, ogImage?: { __typename?: 'AiPicture', alt?: string | null, id?: string | null, src?: string | null, srcSet?: string | null } | null } | null, payment?: { __typename?: 'SeoMetadata', description?: string | null, ogDescription?: string | null, ogTitle?: string | null, title?: string | null, ogImage?: { __typename?: 'AiPicture', alt?: string | null, id?: string | null, src?: string | null, srcSet?: string | null } | null } | null, confirmation?: { __typename?: 'SeoMetadata', description?: string | null, ogDescription?: string | null, ogTitle?: string | null, title?: string | null, ogImage?: { __typename?: 'AiPicture', alt?: string | null, id?: string | null, src?: string | null, srcSet?: string | null } | null } | null } | null };

export type CivilitiesQueryVariables = Exact<{ [key: string]: never; }>;


export type CivilitiesQuery = { __typename?: 'Query', civilities: Array<{ __typename?: 'Civility', code?: string | null, label?: string | null, value?: string | null }> };

export type CheckCorporateCodesQueryVariables = Exact<{
  accessCode?: InputMaybe<Scalars['String']['input']>;
  cardNumber?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['String']['input']>;
  preferentialCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type CheckCorporateCodesQuery = { __typename?: 'Query', checkCorporateCodes?: { __typename?: 'IdentificationPlainText', identification?: { __typename?: 'Identification', identificationId?: string | null } | null } | null };

export type CountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type CountriesQuery = { __typename?: 'Query', countries: Array<{ __typename?: 'Country', alpha2Code?: string | null, callingCodes?: Array<string | null> | null, geoCode?: string | null, idCardRequired?: boolean | null, name?: string | null, nationality?: { __typename?: 'Nationality', geoCode?: string | null, isoCode?: string | null, name?: string | null } | null, states?: Array<{ __typename?: 'State', code?: string | null, codeGeo?: string | null, name?: string | null } | null> | null }> };

export type CurrenciesQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrenciesQuery = { __typename?: 'Query', currencies: Array<{ __typename?: 'Currency', code: string, value: string, symbol?: string | null, euroRate: number }> };

export type ExpediaFeatureQueryVariables = Exact<{ [key: string]: never; }>;


export type ExpediaFeatureQuery = { __typename?: 'Query', globalConfiguration?: { __typename?: 'GlobalConfiguration', expedia: { __typename?: 'ExpediaConfiguration', countries: Array<string>, languages: Array<string>, expediaHotelIds: Array<string> } } | null };

export type ExperienceCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type ExperienceCategoriesQuery = { __typename?: 'Query', experienceCategories?: Array<{ __typename?: 'ExperienceCategory', id?: string | null, title?: string | null, order: number, logo?: { __typename?: 'AiPicture', src?: string | null, srcSet?: string | null, alt?: string | null } | null, carouselImage?: { __typename?: 'AiPicture', src?: string | null, srcSet?: string | null, alt?: string | null } | null } | null> | null };

export type GlobalConfigurationQueryVariables = Exact<{ [key: string]: never; }>;


export type GlobalConfigurationQuery = { __typename?: 'Query', globalConfiguration?: { __typename?: 'GlobalConfiguration', contactUs?: { __typename?: 'ContactUs', email?: string | null } | null, footer?: { __typename?: 'FooterConfiguration', copyright: string, footerColumns?: Array<{ __typename?: 'FooterColumn', id: string, title: string, links?: Array<{ __typename?: 'Link', id: string, label: string, url: string }> | null }> | null, footerBrandLogos?: Array<{ __typename?: 'AiPicture', alt?: string | null, id?: string | null, src?: string | null, srcSet?: string | null }> | null, footerLinks?: Array<{ __typename?: 'Link', id: string, label: string, url: string }> | null, socialLinks?: Array<{ __typename?: 'Link', id: string, url: string, label: string, icon?: { __typename?: 'AiPicture', alt?: string | null, id?: string | null, src?: string | null, srcSet?: string | null } | null }> | null } | null } | null };

export type HomepageQueryVariables = Exact<{ [key: string]: never; }>;


export type HomepageQuery = { __typename?: 'Query', homepage?: { __typename?: 'Homepage', title?: string | null, title2?: string | null, subtitle?: string | null, introTitle?: string | null, introDescription?: string | null, experienceCategoriesBigTitle?: string | null, experienceCategoriesTitle?: string | null, experienceCategoriesSubtitle?: string | null, iconicDestinationTitle?: string | null, iconicDestinationSubtitle?: string | null, offerDescription?: string | null, specialPackageLink?: string | null, seoMetadata?: { __typename?: 'SeoMetadata', description?: string | null, ogDescription?: string | null, ogTitle?: string | null, title?: string | null, ogImage?: { __typename?: 'AiPicture', alt?: string | null, id?: string | null, src?: string | null, srcSet?: string | null } | null } | null, heroImage?: { __typename?: 'AiPicture', id?: string | null, src?: string | null, srcSet?: string | null, alt?: string | null } | null, heroVideo?: { __typename?: 'AiPicture', id?: string | null, src?: string | null, srcSet?: string | null, alt?: string | null } | null, experienceCategories?: Array<{ __typename?: 'ExperienceCategory', id?: string | null, title?: string | null, countInHotels?: number | null, logo?: { __typename?: 'AiPicture', id?: string | null, src?: string | null, alt?: string | null, srcSet?: string | null } | null, carouselImage?: { __typename?: 'AiPicture', id?: string | null, src?: string | null, alt?: string | null, srcSet?: string | null } | null } | null> | null, featuredHotels?: Array<{ __typename?: 'Hotel', id: string, slug: string, brand?: string | null, name?: string | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, street?: string | null, lat?: string | null, lng?: string | null } | null, medias?: Array<{ __typename?: 'AccorMedia', category?: AccorMediaCategory | null, productCode?: string | null, type?: AccorMediaType | null, formats?: Array<{ __typename?: 'AccorMediaFormat', format?: string | null, generic?: boolean | null, path: string } | null> | null } | null> | null, experienceCategories?: Array<{ __typename?: 'ExperienceCategory', title?: string | null, order: number, logo?: { __typename?: 'AiPicture', id?: string | null, alt?: string | null, src?: string | null, srcSet?: string | null } | null } | null> | null, heroImage?: { __typename?: 'AiPicture', id?: string | null, alt?: string | null, src?: string | null, srcSet?: string | null } | null } | null> | null, sevenPillars?: Array<{ __typename?: 'Pillar', description?: string | null, label?: string | null, link?: string | null, picture?: { __typename?: 'AiPicture', alt?: string | null, id?: string | null, srcSet?: string | null, src?: string | null } | null } | null> | null, specialPackages?: Array<{ __typename?: 'OfferAndPackage', id: string, title?: string | null, description?: string | null, sectionTitle?: string | null, detailLink?: string | null, picture?: { __typename?: 'AiPicture', id?: string | null, src?: string | null, srcSet?: string | null, alt?: string | null } | null } | null> | null, featuredTestimonials?: Array<{ __typename?: 'Testimonial', reviewText?: string | null, author?: string | null, hotel?: { __typename?: 'Hotel', name?: string | null, address?: { __typename?: 'Address', country?: string | null } | null } | null } | null> | null, destinations?: Array<{ __typename?: 'Country', title?: string | null, countInHotels?: number | null, id: string, destinationPicture?: { __typename?: 'AiPicture', alt?: string | null, id?: string | null, src?: string | null, srcSet?: string | null } | null } | null> | null } | null };

export type HotelQueryVariables = Exact<{
  hotelId: Scalars['ID']['input'];
  mediaType?: InputMaybe<AccorMediaType>;
  mediaCategory?: InputMaybe<AccorMediaCategory>;
}>;


export type HotelQuery = { __typename?: 'Query', hotel?: { __typename?: 'Hotel', id: string, slug: string, name?: string | null, brand?: string | null, opDescription?: string | null, opSeeAllOffersLink?: string | null, kfDescription?: string | null, soDescription?: string | null, spaDescription?: string | null, checkInHour?: string | null, checkOutHour?: string | null, hotelInclusiveness?: string | null, description?: string | null, maxChildAge?: number | null, minimumStayDuration?: number | null, contact?: { __typename?: 'Contact', mail?: string | null, phone?: string | null, phonePrefix?: string | null } | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, countryCode?: string | null, lat?: string | null, lng?: string | null, zipCode?: string | null, street?: string | null } | null, rating?: { __typename?: 'Rating', stars?: number | null } | null, reviews?: { __typename?: 'Reviews', average?: number | null, count?: number | null } | null, spaActivities?: Array<{ __typename?: 'HotelSpaActivity', id: string, title?: string | null, description?: string | null, menuUrl?: string | null, picture?: { __typename?: 'AiPicture', id?: string | null, alt?: string | null, src?: string | null, srcSet?: string | null } | null } | null> | null, heroImage?: { __typename?: 'AiPicture', id?: string | null, alt?: string | null, src?: string | null, srcSet?: string | null } | null, heroVideo?: { __typename?: 'AiPicture', id?: string | null, alt?: string | null, src?: string | null, srcSet?: string | null } | null, galleryImages?: Array<{ __typename?: 'AiPicture', id?: string | null, alt?: string | null, src?: string | null, srcSet?: string | null } | null> | null, hotelExperiences?: Array<{ __typename?: 'HotelExperience', id: string, title?: string | null, subtitle?: string | null, picture?: { __typename?: 'AiPicture', alt?: string | null, src?: string | null, srcSet?: string | null } | null } | null> | null, offersAndPackages?: Array<{ __typename?: 'OfferAndPackage', description?: string | null, id: string, title?: string | null, sectionTitle?: string | null, detailLink?: string | null, picture?: { __typename?: 'AiPicture', id?: string | null, alt?: string | null, src?: string | null, srcSet?: string | null } | null } | null> | null, hotelOffers?: Array<{ __typename?: 'HotelOfferPage', title?: string | null, slug?: string | null, subtitle?: string | null, introduction?: string | null, heroImage?: { __typename?: 'AiPicture', alt?: string | null, id?: string | null, src?: string | null, srcSet?: string | null } | null } | null> | null, entertainments?: Array<{ __typename?: 'HotelEntertainment', description?: string | null, endDate?: string | null, startDate?: string | null, title?: string | null, id: string, picture?: { __typename?: 'AiPicture', src?: string | null, srcSet?: string | null } | null } | null> | null, experienceCategories?: Array<{ __typename?: 'ExperienceCategory', title?: string | null, order: number, logo?: { __typename?: 'AiPicture', id?: string | null, alt?: string | null, src?: string | null, srcSet?: string | null } | null } | null> | null, kfGalleryImages?: Array<{ __typename?: 'AiPicture', id?: string | null, alt?: string | null, src?: string | null, srcSet?: string | null } | null> | null, kidsActivities?: Array<{ __typename?: 'HotelKidActivity', id: string, introduction?: string | null, learnMoreUrl?: any | null, title?: string | null, picto?: { __typename?: 'AiPicture', id?: string | null, src?: string | null, srcSet?: string | null, alt?: string | null } | null, goldSticker?: { __typename?: 'GoldSticker', label?: string | null } | null } | null> | null, soGalleryImages?: Array<{ __typename?: 'AiPicture', id?: string | null, alt?: string | null, src?: string | null, srcSet?: string | null } | null> | null, sportActivities?: Array<{ __typename?: 'HotelSportActivity', id: string, introduction?: string | null, learnMoreUrl?: any | null, title?: string | null, picto?: { __typename?: 'AiPicture', id?: string | null, src?: string | null, srcSet?: string | null, alt?: string | null } | null, goldSticker?: { __typename?: 'GoldSticker', label?: string | null } | null } | null> | null, surroundings?: { __typename?: 'Surroundings', nearbyAirports?: Array<{ __typename?: 'SurroundingPlace', name?: string | null, distance?: { __typename?: 'SurroundingDistance', km?: number | null, miles?: number | null } | null } | null> | null, nearbyAttractions?: Array<{ __typename?: 'SurroundingPlace', name?: string | null, distance?: { __typename?: 'SurroundingDistance', km?: number | null, miles?: number | null } | null } | null> | null } | null, events?: Array<{ __typename?: 'HotelEvent', id: string, title?: string | null, introduction?: string | null, learnMoreUrl?: string | null, picto?: { __typename?: 'AiPicture', id?: string | null, alt?: string | null, src?: string | null, srcSet?: string | null } | null } | null> | null, facilities?: Array<{ __typename?: 'HotelAmenity', id: string, title?: string | null }> | null, rooms?: Array<{ __typename?: 'Accommodation', topAmenities?: Array<string | null> | null, description?: string | null, extendedStay?: boolean | null, id?: string | null, label?: string | null, shortLabel?: string | null, spacialViewLink?: string | null, amenities?: Array<{ __typename?: 'AccommodationAmenity', label?: string | null, name?: string | null, amenities?: Array<{ __typename?: 'AccommodationAmenityItem', value?: string | null } | null> | null, facilities?: Array<{ __typename?: 'AccommodationFacility', label?: string | null, name?: string | null, items?: Array<{ __typename?: 'AccommodationItem', code?: string | null, name?: string | null, paying?: boolean | null } | null> | null } | null> | null } | null> | null, surface?: { __typename?: 'AccommodationSurface', squareFeet?: number | null, squareMeter?: number | null } | null, classification?: { __typename?: 'AccommodationClassification', standard?: string | null, type?: string | null } | null, configuration?: Array<{ __typename?: 'AccommodationConfiguration', assets?: Array<any | null> | null, beddings?: { __typename?: 'AccommodationBeddings', details?: Array<any | null> | null, doubleBed?: number | null, singleBed?: number | null, qualified: Array<{ __typename?: 'AccommodationBeddingsQualified', label?: string | null, quantity?: number | null, type?: string | null } | null>, extra?: { __typename?: 'AccommodationExtra', adultBed?: boolean | null, childBed?: boolean | null, crib?: boolean | null } | null } | null, maxOccupancy?: { __typename?: 'AccommodationMaxOccupancy', adult?: number | null, children?: number | null, maxChildAge?: number | null, pax?: number | null } | null, situation?: { __typename?: 'AccommodationSituation', accessibility?: boolean | null, views?: Array<string | null> | null } | null } | null> | null, floorSpace?: { __typename?: 'AccommodationFloorSpace', unit?: string | null, value?: number | null } | null, medias?: { __typename?: 'AccommodationMedias', total?: number | null, photos?: Array<{ __typename?: 'AiPicture', id?: string | null, alt?: string | null, src?: string | null, srcSet?: string | null } | null> | null } | null } | null> | null, medias?: Array<{ __typename?: 'AccorMedia', category?: AccorMediaCategory | null, productCode?: string | null, type?: AccorMediaType | null, formats?: Array<{ __typename?: 'AccorMediaFormat', format?: string | null, path: string, generic?: boolean | null, lastUpdate?: string | null } | null> | null } | null> | null, hotelFacilities?: Array<{ __typename?: 'FacilitySection', id: string, title?: string | null, entries: Array<{ __typename?: 'Facility', id: string, cuisineType?: string | null, title: string, description: string, menu?: string | null, menuUrl?: string | null, openingHours?: string | null, picture?: { __typename?: 'AiPicture', id?: string | null, alt?: string | null, src?: string | null, srcSet?: string | null } | null, goldSticker?: { __typename?: 'GoldSticker', label?: string | null } | null } | null> } | null> | null, pageConfiguration?: { __typename?: 'HotelPageConfiguration', hide7Pillars?: boolean | null, hideEntertainments?: boolean | null, hideFoodsAndBeverages?: boolean | null, hideIntroduction?: boolean | null, hideKidsAndFamilyActivity?: boolean | null, hideKidsAndFamilyOverview?: boolean | null, hideMeetingAndEvent?: boolean | null, hideOffer?: boolean | null, hideReview?: boolean | null, hideServices?: boolean | null, hideSpa?: boolean | null, hideSportsActivities?: boolean | null, hideSportsOverview?: boolean | null } | null } | null };

export type HotelBySlugQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  mediaType?: InputMaybe<AccorMediaType>;
  mediaCategory?: InputMaybe<AccorMediaCategory>;
}>;


export type HotelBySlugQuery = { __typename?: 'Query', hotelBySlug?: { __typename?: 'Hotel', id: string, slug: string, name?: string | null, brand?: string | null, expediaId: string, opDescription?: string | null, opSeeAllOffersLink?: string | null, kfDescription?: string | null, soDescription?: string | null, spaDescription?: string | null, checkInHour?: string | null, checkOutHour?: string | null, description?: string | null, minimumStayDuration?: number | null, maxChildAge?: number | null, map?: string | null, contact?: { __typename?: 'Contact', mail?: string | null, phone?: string | null, phonePrefix?: string | null } | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, countryCode?: string | null, lat?: string | null, lng?: string | null, zipCode?: string | null, street?: string | null } | null, rating?: { __typename?: 'Rating', stars?: number | null } | null, reviews?: { __typename?: 'Reviews', average?: number | null, count?: number | null } | null, spaActivities?: Array<{ __typename?: 'HotelSpaActivity', id: string, title?: string | null, description?: string | null, menuUrl?: string | null, picture?: { __typename?: 'AiPicture', id?: string | null, alt?: string | null, src?: string | null, srcSet?: string | null } | null } | null> | null, heroImage?: { __typename?: 'AiPicture', id?: string | null, alt?: string | null, src?: string | null, srcSet?: string | null } | null, heroVideo?: { __typename?: 'AiPicture', id?: string | null, alt?: string | null, src?: string | null, srcSet?: string | null } | null, galleryImages?: Array<{ __typename?: 'AiPicture', id?: string | null, alt?: string | null, src?: string | null, srcSet?: string | null } | null> | null, hotelExperiences?: Array<{ __typename?: 'HotelExperience', id: string, title?: string | null, subtitle?: string | null, picture?: { __typename?: 'AiPicture', alt?: string | null, src?: string | null, srcSet?: string | null } | null } | null> | null, offersAndPackages?: Array<{ __typename?: 'OfferAndPackage', description?: string | null, id: string, title?: string | null, sectionTitle?: string | null, detailLink?: string | null, picture?: { __typename?: 'AiPicture', id?: string | null, alt?: string | null, src?: string | null, srcSet?: string | null } | null } | null> | null, hotelOffers?: Array<{ __typename?: 'HotelOfferPage', title?: string | null, slug?: string | null, subtitle?: string | null, introduction?: string | null, heroImage?: { __typename?: 'AiPicture', alt?: string | null, id?: string | null, src?: string | null, srcSet?: string | null } | null } | null> | null, entertainments?: Array<{ __typename?: 'HotelEntertainment', description?: string | null, endDate?: string | null, startDate?: string | null, title?: string | null, id: string, picture?: { __typename?: 'AiPicture', src?: string | null, srcSet?: string | null } | null } | null> | null, experienceCategories?: Array<{ __typename?: 'ExperienceCategory', title?: string | null, order: number, logo?: { __typename?: 'AiPicture', id?: string | null, alt?: string | null, src?: string | null, srcSet?: string | null } | null } | null> | null, kfGalleryImages?: Array<{ __typename?: 'AiPicture', id?: string | null, alt?: string | null, src?: string | null, srcSet?: string | null } | null> | null, kidsActivities?: Array<{ __typename?: 'HotelKidActivity', id: string, introduction?: string | null, learnMoreUrl?: any | null, title?: string | null, picto?: { __typename?: 'AiPicture', id?: string | null, src?: string | null, srcSet?: string | null, alt?: string | null } | null, goldSticker?: { __typename?: 'GoldSticker', label?: string | null } | null } | null> | null, loyaltyProgram?: { __typename?: 'LoyaltyProgram', advantageAllowed?: boolean | null, burnAllowed?: boolean | null, earnAllowed?: boolean | null, memberRate?: boolean | null, status?: string | null } | null, soGalleryImages?: Array<{ __typename?: 'AiPicture', id?: string | null, alt?: string | null, src?: string | null, srcSet?: string | null } | null> | null, sportActivities?: Array<{ __typename?: 'HotelSportActivity', id: string, introduction?: string | null, learnMoreUrl?: any | null, title?: string | null, picto?: { __typename?: 'AiPicture', id?: string | null, src?: string | null, srcSet?: string | null, alt?: string | null } | null, goldSticker?: { __typename?: 'GoldSticker', label?: string | null } | null } | null> | null, surroundings?: { __typename?: 'Surroundings', nearbyAirports?: Array<{ __typename?: 'SurroundingPlace', name?: string | null, distance?: { __typename?: 'SurroundingDistance', km?: number | null, miles?: number | null } | null } | null> | null, nearbyAttractions?: Array<{ __typename?: 'SurroundingPlace', name?: string | null, distance?: { __typename?: 'SurroundingDistance', km?: number | null, miles?: number | null } | null } | null> | null } | null, events?: Array<{ __typename?: 'HotelEvent', id: string, title?: string | null, introduction?: string | null, learnMoreUrl?: string | null, picto?: { __typename?: 'AiPicture', id?: string | null, alt?: string | null, src?: string | null, srcSet?: string | null } | null } | null> | null, facilities?: Array<{ __typename?: 'HotelAmenity', id: string, title?: string | null }> | null, rooms?: Array<{ __typename?: 'Accommodation', topAmenities?: Array<string | null> | null, description?: string | null, extendedStay?: boolean | null, id?: string | null, label?: string | null, shortLabel?: string | null, spacialViewLink?: string | null, amenities?: Array<{ __typename?: 'AccommodationAmenity', label?: string | null, name?: string | null, amenities?: Array<{ __typename?: 'AccommodationAmenityItem', value?: string | null } | null> | null, facilities?: Array<{ __typename?: 'AccommodationFacility', label?: string | null, name?: string | null, items?: Array<{ __typename?: 'AccommodationItem', code?: string | null, name?: string | null, paying?: boolean | null } | null> | null } | null> | null } | null> | null, surface?: { __typename?: 'AccommodationSurface', squareFeet?: number | null, squareMeter?: number | null } | null, classification?: { __typename?: 'AccommodationClassification', standard?: string | null, type?: string | null } | null, configuration?: Array<{ __typename?: 'AccommodationConfiguration', assets?: Array<any | null> | null, beddings?: { __typename?: 'AccommodationBeddings', details?: Array<any | null> | null, doubleBed?: number | null, singleBed?: number | null, qualified: Array<{ __typename?: 'AccommodationBeddingsQualified', label?: string | null, quantity?: number | null, type?: string | null } | null>, extra?: { __typename?: 'AccommodationExtra', adultBed?: boolean | null, childBed?: boolean | null, crib?: boolean | null } | null } | null, maxOccupancy?: { __typename?: 'AccommodationMaxOccupancy', adult?: number | null, children?: number | null, maxChildAge?: number | null, pax?: number | null } | null, situation?: { __typename?: 'AccommodationSituation', accessibility?: boolean | null, views?: Array<string | null> | null } | null } | null> | null, floorSpace?: { __typename?: 'AccommodationFloorSpace', unit?: string | null, value?: number | null } | null, medias?: { __typename?: 'AccommodationMedias', total?: number | null, photos?: Array<{ __typename?: 'AiPicture', id?: string | null, alt?: string | null, src?: string | null, srcSet?: string | null } | null> | null } | null } | null> | null, medias?: Array<{ __typename?: 'AccorMedia', category?: AccorMediaCategory | null, productCode?: string | null, type?: AccorMediaType | null, formats?: Array<{ __typename?: 'AccorMediaFormat', format?: string | null, path: string, generic?: boolean | null, lastUpdate?: string | null } | null> | null } | null> | null, hotelFacilities?: Array<{ __typename?: 'FacilitySection', id: string, title?: string | null, entries: Array<{ __typename?: 'Facility', id: string, cuisineType?: string | null, title: string, description: string, menu?: string | null, menuUrl?: string | null, openingHours?: string | null, picture?: { __typename?: 'AiPicture', id?: string | null, alt?: string | null, src?: string | null, srcSet?: string | null } | null, goldSticker?: { __typename?: 'GoldSticker', label?: string | null } | null } | null> } | null> | null, pageConfiguration?: { __typename?: 'HotelPageConfiguration', hide7Pillars?: boolean | null, hideEntertainments?: boolean | null, hideFoodsAndBeverages?: boolean | null, hideIntroduction?: boolean | null, hideKidsAndFamilyActivity?: boolean | null, hideKidsAndFamilyOverview?: boolean | null, hideMeetingAndEvent?: boolean | null, hideOffer?: boolean | null, hideReview?: boolean | null, hideServices?: boolean | null, hideSpa?: boolean | null, hideSportsActivities?: boolean | null, hideSportsOverview?: boolean | null } | null, seo?: { __typename?: 'SeoMetadata', description?: string | null, ogDescription?: string | null, ogTitle?: string | null, title?: string | null, ogImage?: { __typename?: 'AiPicture', alt?: string | null, id?: string | null, src?: string | null, srcSet?: string | null } | null } | null } | null };

export type HotelContextQueryVariables = Exact<{
  hotelId: Scalars['ID']['input'];
}>;


export type HotelContextQuery = { __typename?: 'Query', hotel?: { __typename?: 'Hotel', id: string, slug: string, name?: string | null, minimumStayDuration?: number | null, maxChildAge?: number | null, brand?: string | null, address?: { __typename?: 'Address', city?: string | null, zipCode?: string | null, country?: string | null, countryCode?: string | null } | null } | null };

export type HotelOfferPageQueryVariables = Exact<{
  hotelSlug: Scalars['String']['input'];
  slug: Scalars['String']['input'];
}>;


export type HotelOfferPageQuery = { __typename?: 'Query', hotelOfferPage?: { __typename?: 'HotelOfferPage', title?: string | null, slug?: string | null, subtitle?: string | null, introduction?: string | null, overviewCarouselDescription?: string | null, inclusionsCarouselDescription?: string | null, termsAndConditionsContent?: any | null, slugByLanguage?: any | null, heroImage?: { __typename?: 'AiPicture', alt?: string | null, id?: string | null, src?: string | null, srcSet?: string | null } | null, overviewCarouselPicture?: Array<{ __typename?: 'AiPicture', alt?: string | null, id?: string | null, src?: string | null, srcSet?: string | null } | null> | null, inclusionsCarouselPicture?: Array<{ __typename?: 'AiPicture', alt?: string | null, id?: string | null, src?: string | null, srcSet?: string | null } | null> | null, seo?: { __typename?: 'SeoMetadata', description?: string | null, ogDescription?: string | null, ogTitle?: string | null, title?: string | null, ogImage?: { __typename?: 'AiPicture', alt?: string | null, id?: string | null, src?: string | null, srcSet?: string | null } | null } | null, hotel?: { __typename?: 'Hotel', id: string, name?: string | null, slug: string, expediaId: string, minimumStayDuration?: number | null } | null } | null };

export type HotelReviewsQueryVariables = Exact<{
  hotelId: Scalars['ID']['input'];
  size?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type HotelReviewsQuery = { __typename?: 'Query', hotel?: { __typename?: 'Hotel', id: string, reviewsList?: Array<{ __typename?: 'ReviewItem', author?: string | null, score?: number | null, created?: string | null, text?: string | null, title?: string | null, tripType?: string | null } | null> | null } | null };

export type HotelRoomsAvailabilitiesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  nights: Scalars['Int']['input'];
  dateIn: Scalars['String']['input'];
  adults: Scalars['Int']['input'];
  childrenAges?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>>;
}>;


export type HotelRoomsAvailabilitiesQuery = { __typename?: 'Query', hotelRoomsAvailabilities: Array<{ __typename?: 'AvailabilityRoom', code?: string | null, offers?: Array<{ __typename?: 'RoomOffers', code?: string | null, label?: string | null, description?: string | null, mealPlanDescription?: string | null, mealPlan?: string | null, prepay?: boolean | null, burnPointAvailable?: boolean | null, pricing?: { __typename?: 'Pricing', currency?: string | null, amount?: { __typename?: 'Amount', hotelKeeper?: number | null, afterTax?: number | null, otherTax?: { __typename?: 'OtherTax', amount?: { __typename?: 'AmountValue', excluded?: number | null } | null } | null, vat?: { __typename?: 'Vat', amount?: { __typename?: 'AmountValue', excluded?: number | null } | null } | null, fees?: { __typename?: 'Fees', amount?: { __typename?: 'AmountValue', excluded?: number | null } | null } | null } | null } | null, categories?: Array<{ __typename?: 'Categories', code?: string | null } | null> | null, flexibility?: { __typename?: 'Flexibility', code?: string | null, label?: string | null, limitDate?: string | null } | null, package?: { __typename?: 'RoomOfferPackage', type?: string | null } | null } | null> | null, commercialOffers?: Array<{ __typename?: 'CommercialOffer', main?: { __typename?: 'Offer', index?: number | null, deduction?: { __typename?: 'Deduction', value?: number | null } | null } | null } | null> | null } | null> };

export type LanguagesQueryVariables = Exact<{ [key: string]: never; }>;


export type LanguagesQuery = { __typename?: 'Query', languages: Array<{ __typename?: 'Language', code: string, label: string }> };

export type LegalPageQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type LegalPageQuery = { __typename?: 'Query', legalPage?: { __typename?: 'LegalPage', description?: any | null, slug?: string | null, slugByLanguage?: any | null, title?: string | null, sections?: Array<{ __typename?: 'LegalPageSection', title?: string | null, description?: any | null } | null> | null, seo?: { __typename?: 'SeoMetadata', description?: string | null, ogDescription?: string | null, ogTitle?: string | null, title?: string | null, ogImage?: { __typename?: 'AiPicture', alt?: string | null, id?: string | null, src?: string | null, srcSet?: string | null } | null } | null } | null };

export type NationalitiesQueryVariables = Exact<{ [key: string]: never; }>;


export type NationalitiesQuery = { __typename?: 'Query', nationalities: Array<{ __typename?: 'Nationality', geoCode?: string | null, isoCode?: string | null, name?: string | null }> };

export type ExampleQueryVariables = Exact<{ [key: string]: never; }>;


export type ExampleQuery = { __typename?: 'Query', now: string };

export type OtherPageQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type OtherPageQuery = { __typename?: 'Query', otherPage?: { __typename?: 'OtherPage', slug?: string | null, title?: string | null, subtitle?: string | null, introduction?: string | null, content?: any | null, slugByLanguage?: any | null, heroImage?: { __typename?: 'AiPicture', alt?: string | null, id?: string | null, src?: string | null, srcSet?: string | null } | null, cta?: { __typename?: 'OtherPageCta', label?: string | null, url?: string | null } | null, seo?: { __typename?: 'SeoMetadata', description?: string | null, ogDescription?: string | null, ogTitle?: string | null, title?: string | null, ogImage?: { __typename?: 'AiPicture', alt?: string | null, id?: string | null, src?: string | null, srcSet?: string | null } | null } | null } | null };

export type RoomDetailsOffersQueryVariables = Exact<{
  hotelCode: Scalars['ID']['input'];
  productCode: Scalars['ID']['input'];
  offerCode: Scalars['ID']['input'];
  dateIn: Scalars['String']['input'];
  nights: Scalars['Int']['input'];
  adults: Scalars['Int']['input'];
  childrenAges?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
}>;


export type RoomDetailsOffersQuery = { __typename?: 'Query', roomOfferDetails?: { __typename?: 'OfferDetailsRoom', label?: string | null, description?: string | null, offers?: Array<{ __typename?: 'OfferDetailsRoomOffer', code?: string | null, label?: string | null, description?: string | null, mealPlan?: string | null, mealPlanDescription?: string | null, mainMealPlanDescription?: string | null, categories?: Array<{ __typename?: 'Categories', code?: string | null } | null> | null, pricing?: { __typename?: 'Pricing', currency?: string | null, amount?: { __typename?: 'Amount', afterTax?: number | null, hotelKeeper?: number | null } | null } | null, policies?: Array<{ __typename?: 'Policies', label?: string | null, description?: string | null } | null> | null, tax?: Array<{ __typename?: 'OfferDetailsRoomOfferTax', included?: boolean | null, prepay?: boolean | null, vat?: boolean | null, label?: string | null } | null> | null } | null> | null, detail?: Array<{ __typename?: 'OfferDetailsRoomDetail', date?: string | null, offers?: Array<{ __typename?: 'OfferDetailsRoomDetailOffer', pricing?: { __typename?: 'Pricing', currency?: string | null, amount?: { __typename?: 'Amount', afterTax?: number | null, hotelKeeper?: number | null } | null } | null, mealPlan?: { __typename?: 'OfferDetailsMealPlan', code?: string | null } | null } | null> | null } | null> | null } | null };

export type SearchAirportOriginQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type SearchAirportOriginQuery = { __typename?: 'Query', searchAirportOrigin?: { __typename?: 'SearchOriginResult', empty: boolean, origins: Array<{ __typename?: 'SearchOrigin', code: string, country: string, fullName: string, id: string, name: string, type: SearchOriginResultType }> } | null };

export type SearchDestinationQueryVariables = Exact<{
  search: Scalars['String']['input'];
}>;


export type SearchDestinationQuery = { __typename?: 'Query', searchDestination?: { __typename?: 'SearchDestinationResult', empty?: boolean | null, destinations?: Array<{ __typename?: 'SearchDestination', city?: string | null, country?: string | null, expediaId?: string | null, type?: SearchDestinationResultType | null, hotel?: { __typename?: 'Hotel', id: string, name?: string | null } | null, localizations?: Array<{ __typename?: 'SearchDestinationLocalization', city?: string | null, country?: string | null, language?: string | null } | null> | null } | null> | null } | null };

export type SearchHotelsQueryVariables = Exact<{
  destination?: InputMaybe<DestinationSearchInput>;
  dates?: InputMaybe<DateSearchInput>;
  rooms?: InputMaybe<Array<InputMaybe<RoomSearchInput>> | InputMaybe<RoomSearchInput>>;
}>;


export type SearchHotelsQuery = { __typename?: 'Query', searchHotels?: { __typename?: 'SearchHotelResult', hotels?: Array<{ __typename?: 'SearchHotel', brand: string, city: string, country: string, countryCode?: string | null, hotelInclusiveness?: string | null, id: string, name: string, nbReviews?: number | null, rating?: number | null, ridcode: string, slug: string, street: string, zipCode?: string | null, expediaId: string, bestOffer?: { __typename?: 'SearchBestOffer', currency?: string | null, memberMealPlan?: string | null, memberPrice?: number | null, publicMealPlan?: string | null, publicPrice?: number | null, preferredOfferMealPlan?: string | null, preferredOfferPrice?: number | null } | null, experienceCategories?: Array<{ __typename?: 'ExperienceCategory', title?: string | null, id?: string | null, order: number, logo?: { __typename?: 'AiPicture', alt?: string | null, id?: string | null, src?: string | null, srcSet?: string | null } | null }> | null, galleryImages?: Array<{ __typename?: 'AiPicture', alt?: string | null, id?: string | null, src?: string | null, srcSet?: string | null }> | null } | null> | null, alternativeHotels?: Array<{ __typename?: 'SearchHotel', brand: string, city: string, country: string, countryCode?: string | null, hotelInclusiveness?: string | null, id: string, name: string, nbReviews?: number | null, rating?: number | null, ridcode: string, slug: string, street: string, zipCode?: string | null, expediaId: string, bestOffer?: { __typename?: 'SearchBestOffer', currency?: string | null, memberMealPlan?: string | null, memberPrice?: number | null, publicMealPlan?: string | null, publicPrice?: number | null, preferredOfferMealPlan?: string | null, preferredOfferPrice?: number | null } | null, experienceCategories?: Array<{ __typename?: 'ExperienceCategory', title?: string | null, id?: string | null, order: number, logo?: { __typename?: 'AiPicture', alt?: string | null, id?: string | null, src?: string | null, srcSet?: string | null } | null }> | null, galleryImages?: Array<{ __typename?: 'AiPicture', alt?: string | null, id?: string | null, src?: string | null, srcSet?: string | null }> | null } | null> | null } | null };

export type SearchSeoQueryVariables = Exact<{ [key: string]: never; }>;


export type SearchSeoQuery = { __typename?: 'Query', searchSeo?: { __typename?: 'SeoMetadata', description?: string | null, ogDescription?: string | null, ogTitle?: string | null, title?: string | null, ogImage?: { __typename?: 'AiPicture', alt?: string | null, id?: string | null, src?: string | null, srcSet?: string | null } | null } | null };

export type UserQueryVariables = Exact<{ [key: string]: never; }>;


export type UserQuery = { __typename?: 'Query', user?: { __typename?: 'CustomerInformation', id?: string | null, status?: string | null, individual?: { __typename?: 'Individual', nationality?: string | null, isLoyaltyMember?: boolean | null, uaUserId?: string | null, pmid?: string | null, individualName?: { __typename?: 'IndividualName', firstName?: string | null, lastName?: string | null, civility?: string | null } | null } | null, loyalty?: { __typename?: 'Loyalty', balances?: { __typename?: 'Balances', nbPoints?: number | null } | null, loyaltyCards?: { __typename?: 'LoyaltyCards', card?: Array<{ __typename?: 'Card', cardNumber?: string | null, isLastActiveCard?: boolean | null, cardProduct?: { __typename?: 'CardProduct', productLabel?: string | null, cardCodeTARS?: string | null, productTier?: string | null } | null } | null> | null } | null } | null, contactMediums?: { __typename?: 'ContactMediums', contactMedium?: Array<{ __typename?: 'ContactMedium', id: string, mediumUsages?: { __typename?: 'ContactMediumUsages', mediumUsage?: Array<{ __typename?: 'ContactMediumUsage', usageType?: string | null }> | null } | null, postalAddress?: { __typename?: 'ContactMediumPostalAddress', address1?: string | null, address2?: string | null, address3?: string | null, address4?: string | null, zipCode?: string | null, city?: string | null, countryCode?: string | null, stateCode?: string | null, isPrimary?: boolean | null } | null, telephoneNumber?: { __typename?: 'ContactMediumPhoneNumber', phonePrefix?: string | null, phoneNumber?: string | null, isPrimary?: boolean | null } | null, emailContact?: { __typename?: 'ContactMediumEmail', email?: string | null, isPrimary?: boolean | null } | null }> | null } | null } | null };

export type ValidatePhoneQueryVariables = Exact<{
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type ValidatePhoneQuery = { __typename?: 'Query', validatePhone?: boolean | null };

export type ValidateRoomsQueryVariables = Exact<{
  rooms: Array<InputMaybe<BasicRoom>> | InputMaybe<BasicRoom>;
  hotelCode: Scalars['ID']['input'];
  dateIn: Scalars['String']['input'];
  nights: Scalars['Int']['input'];
}>;


export type ValidateRoomsQuery = { __typename?: 'Query', validateRooms?: boolean | null };

export type VerifyCodeQueryVariables = Exact<{
  email?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
}>;


export type VerifyCodeQuery = { __typename?: 'Query', verifyCode?: { __typename?: 'VerifyCodeResponse', acknowledge?: boolean | null, reason?: string | null } | null };

// Generated on 2025-07-03T07:56:33+00:00
